import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.literature');
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-literature',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.literature/view.scss */
@charset "UTF-8";
@keyframes literature-modal-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes literature-modal-pop {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes literature-modal-icon-float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2px);
  }
}
@keyframes literature-loading-rise {
  0%, 100% {
    transform: scaleY(0.45);
    opacity: 0.45;
  }
  45% {
    transform: scaleY(1);
    opacity: 1;
  }
}
.literature-shell {
  color: #0f172a;
}

.literature-alert {
  border: 1px solid;
  border-radius: 8px;
  padding: 12px 14px;
  font-size: 13px;
  line-height: 1.5;
}

.literature-alert--error {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.literature-alert--success {
  border-color: #a7f3d0;
  background: #ecfdf5;
  color: #047857;
}

.literature-loading-panel,
.literature-list-loading {
  display: flex;
  min-height: 220px;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
}

.literature-list-loading {
  min-height: 160px;
  color: #64748b;
  font-size: 13px;
  font-weight: 700;
}

.literature-loading-mark {
  display: inline-flex;
  height: 18px;
  align-items: center;
  gap: 3px;
}

.literature-loading-mark > span {
  display: block;
  width: 4px;
  height: 18px;
  border-radius: 999px;
  transform-origin: center bottom;
  animation: literature-loading-rise 760ms ease-in-out infinite;
}

.literature-loading-mark > span:nth-child(1) {
  background: #10b981;
}

.literature-loading-mark > span:nth-child(2) {
  background: #f59e0b;
  animation-delay: 110ms;
}

.literature-loading-mark > span:nth-child(3) {
  background: #38bdf8;
  animation-delay: 220ms;
}

.literature-home-header {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 18px;
  overflow: hidden;
  border: 1px solid #dbe7e2;
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(240, 253, 244, 0.84), rgba(255, 251, 235, 0.54) 45%, rgba(248, 250, 252, 0.96)), #ffffff;
  padding: 22px;
  box-shadow: 0 16px 35px rgba(15, 23, 42, 0.06);
}

.literature-home-header::after {
  content: "";
  position: absolute;
  right: 22px;
  bottom: 0;
  left: 22px;
  height: 3px;
  border-radius: 999px 999px 0 0;
  background: linear-gradient(90deg, #10b981, #f59e0b, #38bdf8);
}

.literature-state-pill,
.literature-type-pill,
.literature-row-action {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.literature-search {
  display: flex;
  height: 40px;
  align-items: center;
  gap: 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.92);
  padding: 0 12px;
  color: #64748b;
  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.literature-search:focus-within {
  border-color: #10b981;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.12);
}

.literature-search input {
  min-width: 0;
  border: 0;
  outline: 0;
  box-shadow: none;
  appearance: none;
}

.literature-search input:focus,
.literature-search input:focus-visible {
  border: 0;
  outline: 0;
  box-shadow: none;
}

.literature-primary-button,
.literature-secondary-button,
.literature-back-button,
.literature-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  transition: transform 160ms ease, border-color 160ms ease, background 160ms ease, box-shadow 160ms ease, color 160ms ease;
}

.literature-primary-button {
  height: 40px;
  gap: 8px;
  border: 1px solid #064e3b;
  background: #064e3b;
  padding: 0 14px;
  color: #ffffff;
  box-shadow: 0 12px 22px rgba(6, 78, 59, 0.18);
}

.literature-primary-button:hover:not(:disabled) {
  transform: translateY(-1px);
  background: #022c22;
}

.literature-secondary-button,
.literature-back-button {
  height: 40px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  padding: 0 12px;
  color: #334155;
}

.literature-secondary-button:hover:not(:disabled),
.literature-back-button:hover:not(:disabled) {
  border-color: #94a3b8;
  background: #f8fafc;
  color: #0f172a;
}

.literature-icon-button {
  width: 36px;
  height: 36px;
  border: 1px solid #dbe3ea;
  background: #ffffff;
  color: #64748b;
}

.literature-icon-button:hover:not(:disabled) {
  border-color: #99f6e4;
  background: #f0fdfa;
  color: #047857;
}

.literature-primary-button:disabled,
.literature-secondary-button:disabled,
.literature-back-button:disabled,
.literature-icon-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.literature-overview-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.literature-overview-card {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  padding: 16px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
}

.literature-overview-card__top {
  display: flex;
  align-items: center;
  gap: 8px;
}

.literature-overview-card__marker {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #10b981;
}

.literature-overview-card:nth-child(2) .literature-overview-card__marker {
  background: #38bdf8;
}

.literature-overview-card:nth-child(3) .literature-overview-card__marker {
  background: #f59e0b;
}

.literature-overview-card:nth-child(4) .literature-overview-card__marker {
  background: #fb7185;
}

.literature-collection-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 14px;
}

.literature-collection-card {
  position: relative;
  overflow: hidden;
  border: 1px solid #dbe3ea;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.05);
  transition: border-color 180ms ease, box-shadow 180ms ease;
}

.literature-collection-card::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 3px;
  background: linear-gradient(90deg, #10b981, #38bdf8);
}

.literature-collection-card:hover {
  border-color: #99f6e4;
  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.08);
}

.literature-collection-card.is-muted::before {
  background: linear-gradient(90deg, #f59e0b, #fb7185);
}

.literature-collection-card__body {
  display: flex;
  min-height: 192px;
  cursor: pointer;
  flex-direction: column;
  padding: 18px;
  outline: none;
}

.literature-collection-card__body:focus-visible {
  box-shadow: inset 0 0 0 2px rgba(16, 185, 129, 0.35);
}

.literature-collection-card__icon {
  display: inline-flex;
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid #a7f3d0;
  border-radius: 8px;
  background: #ecfdf5;
  color: #047857;
}

.literature-state-pill {
  height: 24px;
  border-radius: 999px;
  padding: 0 10px;
  font-size: 11px;
  font-weight: 700;
}

.literature-state-pill--warning {
  border: 1px solid #fde68a;
  background: #fffbeb;
  color: #b45309;
}

.literature-storage-strip {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-top: 16px;
}

.literature-storage-chip {
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 10px;
}

.literature-card-foot {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: auto;
  border-top: 1px solid #edf2f7;
  padding-top: 14px;
  color: #94a3b8;
  font-size: 11px;
}

.literature-empty-state {
  display: flex;
  min-height: 148px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  padding: 30px 16px;
  text-align: center;
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
}

.literature-empty-state__icon {
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f0fdfa;
  color: #0f766e;
}

.literature-empty-state--error {
  border-color: #fecdd3;
  color: #be123c;
}

.literature-drive-workspace {
  position: relative;
  display: flex;
  min-height: 0 !important;
  flex-direction: column;
  gap: 12px;
  overflow: visible;
  background: transparent;
}

.literature-drive-workspace.is-dragging {
  outline: 2px solid rgba(13, 148, 136, 0.35);
  outline-offset: 4px;
}

.literature-drive-drop-overlay {
  position: absolute;
  inset: 0;
  z-index: 80;
  display: flex;
  min-height: 240px;
  align-items: center;
  justify-content: center;
  border: 1px dashed #14b8a6;
  border-radius: 10px;
  background: rgba(240, 253, 250, 0.82);
  pointer-events: none;
}

.literature-drive-drop-overlay__panel {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #99f6e4;
  border-radius: 8px;
  background: #ffffff;
  padding: 14px 18px;
  color: #0f766e;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.12);
}

.literature-drive-drop-overlay__panel p {
  color: #0f172a;
  font-size: 14px;
  font-weight: 900;
}

.literature-drive-header {
  position: sticky;
  top: 0;
  z-index: 50;
  overflow: visible;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  padding: 10px 12px;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.035);
}

.literature-drive-titlebar {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 12px;
}

.literature-drive-title-main {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  align-items: center;
  gap: 12px;
}

.literature-drive-title-row {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.literature-back-button--icon {
  width: 34px;
  height: 36px;
  padding: 0;
  border-color: transparent;
  background: transparent;
  color: #334155;
}

.literature-back-button--icon:hover:not(:disabled) {
  border-color: #dbe3ea;
  background: #f8fafc;
}

.literature-drive-tools {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.literature-drive-tools .literature-secondary-button {
  height: 38px;
}

.literature-drive-search {
  width: min(300px, 100%);
  height: 38px;
}

.literature-drive-add-wrap {
  position: relative;
}

.literature-drive-add-button {
  height: 38px;
}

.literature-drive-action-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 60;
}

.literature-drive-summary {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 0;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #f1f5f9;
}

.literature-drive-summary span {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  border: 0;
  background: transparent;
  padding: 0;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
}

.literature-drive-summary span + span::before {
  content: "·";
  margin: 0 7px;
  color: #cbd5e1;
}

.literature-breadcrumbs {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  margin-top: 2px;
}

.literature-breadcrumb {
  display: inline-flex;
  align-items: center;
  border: 0;
  border-radius: 4px;
  background: transparent;
  padding: 1px 0;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  transition: border-color 160ms ease, background 160ms ease, color 160ms ease;
}

.literature-breadcrumb + .literature-breadcrumb::before {
  content: "/";
  margin: 0 7px;
  color: #cbd5e1;
  font-weight: 700;
}

.literature-breadcrumb:hover {
  color: #0f172a;
}

.literature-breadcrumb.is-active {
  color: #047857;
  font-weight: 800;
}

@media (max-width: 900px) {
  .literature-upload-work__row {
    grid-template-columns: minmax(0, 1fr);
  }
  .literature-upload-work__meta,
  .literature-upload-work__status-line {
    justify-content: flex-start;
  }
}
.literature-drive-body {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 12px;
  background: transparent;
}

.literature-upload-work {
  overflow: hidden;
  border: 1px solid #dbe3ea;
  border-radius: 8px;
  background: #ffffff;
}

.literature-upload-work__head {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 13px 16px;
}

.literature-upload-work__head p {
  overflow: hidden;
  color: #0f172a;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 900;
}

.literature-upload-work__head span {
  display: block;
  overflow: hidden;
  margin-top: 3px;
  color: #64748b;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 700;
}

.literature-upload-work__count {
  flex-shrink: 0;
  border: 1px solid #dbeafe;
  border-radius: 999px;
  background: #eff6ff;
  padding: 5px 9px;
  color: #1d4ed8 !important;
  font-size: 11px !important;
  font-weight: 900 !important;
}

.literature-upload-work__list {
  border-top: 1px solid #edf2f7;
}

.literature-upload-work__row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 120px minmax(220px, 0.75fr);
  gap: 12px;
  align-items: center;
  border-bottom: 1px solid #edf2f7;
  padding: 12px 16px;
}

.literature-upload-work__row:last-child {
  border-bottom: 0;
}

.literature-upload-work__row.is-processing,
.literature-upload-work__row.is-transferring {
  background: #fffbeb;
}

.literature-upload-work__row.is-complete {
  background: #f0fdf4;
}

.literature-upload-work__row.is-attention {
  background: #fff1f2;
}

.literature-upload-work__row.is-stored {
  background: #f8fafc;
}

.literature-upload-work__file {
  display: grid;
  min-width: 0;
  grid-template-columns: 34px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
}

.literature-upload-work__icon {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
}

.literature-upload-work__file p {
  overflow: hidden;
  color: #0f172a;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 900;
}

.literature-upload-work__file span:not(.literature-upload-work__icon) {
  display: block;
  overflow: hidden;
  margin-top: 3px;
  color: #64748b;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 700;
}

.literature-upload-work__meta {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 6px;
}

.literature-upload-work__meta span {
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #ffffff;
  padding: 4px 7px;
  color: #475569;
  font-size: 10px;
  font-weight: 900;
}

.literature-upload-work__status {
  min-width: 0;
}

.literature-upload-work__status-line {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.literature-upload-work__status-line strong {
  flex-shrink: 0;
  color: #0f172a;
  font-size: 12px;
  font-weight: 900;
}

.literature-upload-work__status-line span {
  overflow: hidden;
  color: #64748b;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 700;
}

.literature-upload-work__bar {
  position: relative;
  overflow: hidden;
  height: 6px;
  margin-top: 8px;
  border-radius: 999px;
  background: #e2e8f0;
}

.literature-upload-work__bar span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #0f766e;
  transition: width 180ms ease;
}

.literature-upload-work__row.is-processing .literature-upload-work__bar span,
.literature-upload-work__row.is-transferring .literature-upload-work__bar span {
  background: #d97706;
}

.literature-upload-work__row.is-attention .literature-upload-work__bar span {
  background: #e11d48;
}

.literature-upload-work__row.is-stored .literature-upload-work__bar span {
  background: #64748b;
}

.literature-upload-work__more {
  border-top: 1px solid #edf2f7;
  padding: 10px 16px 12px;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
}

.literature-section-label {
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 9px 16px;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
}

.literature-folder-row,
.literature-bundle-row {
  position: relative;
  display: grid;
  width: 100%;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #edf2f7;
  background: #ffffff;
  padding: 14px 16px;
  text-align: left;
  transition: background 160ms ease;
}

.literature-folder-row {
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0;
  padding: 0;
}

.literature-bundle-row {
  grid-template-columns: 1fr;
}

.literature-folder-row:hover,
.literature-bundle-row:hover {
  background: #f8fafc;
}

.literature-folder-main {
  display: grid;
  width: 100%;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  border: 0;
  background: transparent;
  padding: 14px 16px;
  color: inherit;
  cursor: pointer;
  text-align: left;
}

.literature-folder-row__icon {
  display: inline-flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border: 1px solid #fde68a;
  border-radius: 8px;
  background: #fffbeb;
  color: #b45309;
}

.literature-folder-delete-button,
.literature-bundle-delete-button {
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  align-self: center;
  margin-right: 12px;
  border: 1px solid #fecdd3;
  border-radius: 8px;
  background: #fff1f2;
  color: #e11d48;
  transition: border-color 160ms ease, background 160ms ease, color 160ms ease;
}

.literature-bundle-delete-button {
  justify-self: end;
  margin-right: 0;
}

.literature-folder-delete-button:hover:not(:disabled),
.literature-bundle-delete-button:hover:not(:disabled) {
  border-color: #fda4af;
  background: #ffe4e6;
  color: #be123c;
}

.literature-folder-delete-button:disabled,
.literature-bundle-delete-button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.literature-row-action,
.literature-type-pill {
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}

.literature-row-action {
  border: 1px solid #a7f3d0;
  background: #ecfdf5;
  padding: 5px 10px;
  color: #047857;
}

.literature-type-pill {
  border: 1px solid #dbe3ea;
  background: #f8fafc;
  padding: 5px 10px;
  color: #334155;
}

.literature-bundle-progress {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.literature-bundle-progress__steps {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 4px;
}

.literature-flow-step-pill {
  display: inline-flex;
  max-width: 86px;
  height: 22px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #f8fafc;
  padding: 0 7px;
  color: #64748b;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 10px;
  font-weight: 800;
}

button.literature-flow-step-pill {
  cursor: pointer;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

button.literature-flow-step-pill:hover {
  border-color: #94a3b8;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
}

button.literature-flow-step-pill:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.18);
}

.literature-progress-open-button {
  display: inline-flex;
  width: fit-content;
  max-width: 100%;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  padding: 6px 9px;
  color: #334155;
  font-size: 11px;
  font-weight: 900;
  transition: border-color 160ms ease, background 160ms ease, box-shadow 160ms ease;
}

.literature-progress-open-button strong {
  border-left: 1px solid rgba(100, 116, 139, 0.25);
  padding-left: 8px;
  font-weight: 900;
}

.literature-progress-open-button:hover,
.literature-progress-open-button:focus-visible {
  border-color: #94a3b8;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
  outline: 0;
}

.literature-progress-open-button.is-usable {
  border-color: #a7f3d0;
  background: #ecfdf5;
  color: #047857;
}

.literature-progress-open-button.is-processing {
  border-color: #fde68a;
  background: #fffbeb;
  color: #b45309;
}

.literature-progress-open-button.is-attention {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.literature-flow-step-pill.is-usable {
  border-color: #a7f3d0;
  background: #ecfdf5;
  color: #047857;
}

.literature-flow-step-pill.is-processing {
  border-color: #fde68a;
  background: #fffbeb;
  color: #b45309;
}

.literature-flow-step-pill.is-attention {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.literature-stage-backdrop {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.28);
}

.literature-stage-modal {
  display: flex;
  width: min(980px, 100%);
  max-height: min(760px, 100vh - 48px);
  min-height: 520px;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #dbe3ea;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.2);
}

.literature-stage-modal__head {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #edf2f7;
  padding: 18px 20px 14px;
}

.literature-stage-modal__head p {
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.literature-stage-modal__head h2 {
  margin-top: 4px;
  color: #0f172a;
  font-size: 20px;
  font-weight: 900;
}

.literature-stage-modal__body {
  display: grid;
  min-height: 0;
  flex: 1 1 auto;
  grid-template-columns: 280px minmax(0, 1fr);
}

.literature-stage-timeline {
  min-height: 0;
  overflow-y: auto;
  border-right: 1px solid #edf2f7;
  background: #f8fafc;
  padding: 16px;
}

.literature-stage-timeline__head {
  margin-bottom: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  padding: 12px;
}

.literature-stage-timeline__head div:first-child {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: #64748b;
  font-size: 11px;
  font-weight: 900;
}

.literature-stage-timeline__head strong {
  color: #0f172a;
  font-size: 18px;
}

.literature-stage-progressbar {
  overflow: hidden;
  height: 7px;
  margin-top: 10px;
  border-radius: 999px;
  background: #e2e8f0;
}

.literature-stage-progressbar span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #059669;
}

.literature-stage-timeline__item {
  display: grid;
  width: 100%;
  grid-template-columns: 18px minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  padding: 11px 10px;
  text-align: left;
  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.literature-stage-timeline__item + .literature-stage-timeline__item {
  margin-top: 8px;
}

.literature-stage-timeline__item:hover,
.literature-stage-timeline__item.is-active {
  border-color: #94a3b8;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}

.literature-stage-timeline__item.is-active {
  background: #f0fdfa;
}

.literature-stage-timeline__dot {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: #cbd5e1;
}

.literature-stage-timeline__item.is-usable .literature-stage-timeline__dot {
  background: #10b981;
}

.literature-stage-timeline__item.is-processing .literature-stage-timeline__dot {
  background: #f59e0b;
}

.literature-stage-timeline__item.is-attention .literature-stage-timeline__dot {
  background: #e11d48;
}

.literature-stage-timeline__item strong {
  display: block;
  color: #0f172a;
  font-size: 13px;
  font-weight: 900;
}

.literature-stage-timeline__item p {
  margin-top: 3px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.literature-stage-timeline__item em {
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #f8fafc;
  padding: 3px 7px;
  color: #64748b;
  font-size: 10px;
  font-style: normal;
  font-weight: 900;
  white-space: nowrap;
}

.literature-stage-content {
  display: flex;
  min-width: 0;
  min-height: 0;
  flex-direction: column;
}

.literature-stage-drawer {
  display: flex;
  width: min(560px, 100vw - 24px);
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  border-left: 1px solid #dbe3ea;
  background: #ffffff;
  box-shadow: -24px 0 48px rgba(15, 23, 42, 0.16);
}

.literature-stage-drawer__head {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #edf2f7;
  padding: 18px 18px 14px;
}

.literature-stage-drawer__head p {
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.literature-stage-drawer__head h2 {
  margin-top: 4px;
  color: #0f172a;
  font-size: 18px;
  font-weight: 900;
}

.literature-stage-drawer__close {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #64748b;
  transition: background 160ms ease, color 160ms ease;
}

.literature-stage-drawer__close:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.literature-stage-drawer__summary {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid #edf2f7;
  padding: 12px 18px;
  color: #475569;
  font-size: 12px;
  font-weight: 800;
}

.literature-stage-drawer__summary .literature-flow-step-pill {
  max-width: none;
}

.literature-stage-metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  border-bottom: 1px solid #edf2f7;
  padding: 14px 18px;
}

.literature-stage-metric {
  min-width: 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 10px;
}

.literature-stage-metric span {
  display: block;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
}

.literature-stage-metric strong {
  display: block;
  overflow: hidden;
  margin-top: 4px;
  color: #0f172a;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 900;
}

.literature-stage-preview {
  max-height: min(46vh, 430px);
  overflow-y: auto;
  border-bottom: 1px solid #edf2f7;
  padding: 14px 18px;
}

.literature-stage-preview__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  color: #64748b;
  font-size: 12px;
  font-weight: 900;
}

.literature-stage-preview__head-actions {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;
}

.literature-stage-preview__action,
.literature-stage-preview-summary__button,
.literature-text-viewer__primary {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid #0f766e;
  border-radius: 8px;
  background: #0f766e;
  padding: 0 11px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  transition: background 160ms ease, border-color 160ms ease, opacity 160ms ease;
}

.literature-stage-preview__action:hover,
.literature-stage-preview-summary__button:hover,
.literature-text-viewer__primary:hover {
  border-color: #115e59;
  background: #115e59;
}

.literature-stage-preview__action:disabled,
.literature-stage-preview-summary__button:disabled,
.literature-text-viewer__primary:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.literature-stage-loading {
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  padding: 20px 12px;
  color: #475569;
  text-align: center;
  font-size: 13px;
  font-weight: 800;
}

.literature-stage-empty.is-error {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.literature-stage-preview-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #dbe3ea;
  border-radius: 8px;
  background: #ffffff;
  padding: 12px;
}

.literature-stage-preview-summary strong {
  display: block;
  color: #0f172a;
  font-size: 15px;
  font-weight: 900;
}

.literature-stage-preview-summary span {
  display: block;
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.literature-stage-text-card {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
}

.literature-stage-text-card + .literature-stage-text-card {
  margin-top: 10px;
}

.literature-stage-text-card__head {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #edf2f7;
  padding: 9px 10px;
}

.literature-stage-text-card__head strong {
  flex-shrink: 0;
  color: #0f172a;
  font-size: 12px;
  font-weight: 900;
}

.literature-stage-text-card__head span {
  overflow: hidden;
  color: #64748b;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 800;
}

.literature-stage-text-card pre {
  max-height: 220px;
  overflow: auto;
  margin: 0;
  padding: 11px 12px;
  color: #1e293b;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.65;
}

.literature-text-viewer-backdrop {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  background: rgba(15, 23, 42, 0.34);
}

.literature-text-viewer {
  display: flex;
  width: min(1180px, 100%);
  height: min(820px, 100vh - 36px);
  min-height: 560px;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.24);
}

.literature-text-viewer__head {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #edf2f7;
  padding: 18px 20px 14px;
}

.literature-text-viewer__head p {
  color: #64748b;
  font-size: 12px;
  font-weight: 800;
}

.literature-text-viewer__head h2 {
  margin-top: 3px;
  color: #0f172a;
  font-size: 20px;
  font-weight: 900;
}

.literature-text-viewer__head span {
  display: block;
  margin-top: 5px;
  color: #475569;
  font-size: 12px;
  font-weight: 800;
}

.literature-text-viewer__toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #edf2f7;
  padding: 12px 20px;
}

.literature-text-viewer__search {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  align-items: center;
  gap: 9px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  padding: 0 10px;
  color: #64748b;
}

.literature-text-viewer__search input {
  min-width: 0;
  height: 38px;
  flex: 1 1 auto;
  border: 0;
  outline: 0;
  color: #0f172a;
  font-size: 13px;
  font-weight: 700;
}

.literature-text-viewer__search button {
  flex-shrink: 0;
  color: #0f766e;
  font-size: 12px;
  font-weight: 900;
}

.literature-text-viewer__body {
  display: grid;
  min-height: 0;
  flex: 1 1 auto;
  grid-template-columns: 260px minmax(0, 1fr);
}

.literature-text-viewer__pages {
  min-height: 0;
  overflow-y: auto;
  border-right: 1px solid #edf2f7;
  background: #f8fafc;
  padding: 14px;
}

.literature-text-viewer__pager {
  display: grid;
  grid-template-columns: 1fr 72px 1fr 1fr;
  gap: 6px;
  margin-bottom: 12px;
}

.literature-text-viewer__pager button,
.literature-text-viewer__page-list button,
.literature-text-viewer__page-head button {
  min-height: 32px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  padding: 0 9px;
  color: #334155;
  font-size: 12px;
  font-weight: 900;
  transition: border-color 160ms ease, background 160ms ease, color 160ms ease;
}

.literature-text-viewer__pager button:hover,
.literature-text-viewer__page-list button:hover,
.literature-text-viewer__page-head button:hover {
  border-color: #94a3b8;
  background: #f1f5f9;
  color: #0f172a;
}

.literature-text-viewer__pager button:disabled,
.literature-text-viewer__page-list button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.literature-text-viewer__pager input {
  min-width: 0;
  height: 32px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  padding: 0 8px;
  color: #0f172a;
  text-align: center;
  font-size: 12px;
  font-weight: 900;
}

.literature-text-viewer__page-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.literature-text-viewer__page-list button.is-active {
  border-color: #0f766e;
  background: #ecfdf5;
  color: #0f766e;
}

.literature-text-viewer__search-summary {
  margin-top: 12px;
  border: 1px solid #dbe3ea;
  border-radius: 8px;
  background: #ffffff;
  padding: 10px;
}

.literature-text-viewer__search-summary strong,
.literature-text-viewer__search-summary span {
  display: block;
  font-size: 12px;
  font-weight: 900;
}

.literature-text-viewer__search-summary strong {
  color: #0f172a;
}

.literature-text-viewer__search-summary span {
  margin-top: 3px;
  color: #64748b;
}

.literature-text-viewer__content {
  min-height: 0;
  overflow-y: auto;
  padding: 18px 20px 24px;
  background: #ffffff;
}

.literature-text-viewer__page {
  border: 1px solid #dbe3ea;
  border-radius: 8px;
  background: #ffffff;
}

.literature-text-viewer__page + .literature-text-viewer__page {
  margin-top: 12px;
}

.literature-text-viewer__page-head {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #edf2f7;
  padding: 10px 12px;
}

.literature-text-viewer__page-head strong {
  flex-shrink: 0;
  color: #0f172a;
  font-size: 13px;
  font-weight: 900;
}

.literature-text-viewer__page-head span {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  color: #64748b;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 800;
}

.literature-text-viewer__page pre {
  margin: 0;
  padding: 16px;
  color: #1e293b;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: inherit;
  font-size: 14px;
  font-weight: 650;
  line-height: 1.8;
}

.literature-stage-files {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 14px 18px 20px;
}

.literature-stage-files__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  color: #64748b;
  font-size: 12px;
  font-weight: 900;
}

.literature-stage-empty {
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  padding: 24px 12px;
  color: #64748b;
  text-align: center;
  font-size: 13px;
  font-weight: 800;
}

.literature-stage-file-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(150px, auto);
  gap: 12px;
  align-items: center;
  border-top: 1px solid #edf2f7;
  padding: 12px 0;
}

.literature-stage-file-row p {
  color: #0f172a;
  font-size: 13px;
  font-weight: 900;
}

.literature-stage-file-row span {
  display: block;
  margin-top: 3px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.literature-stage-file-row__meta {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.literature-stage-file-row__meta strong {
  display: inline-flex;
  align-items: center;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #f8fafc;
  padding: 4px 8px;
  color: #64748b;
  font-size: 11px;
  font-weight: 900;
}

.literature-stage-file-row__meta strong.is-usable {
  border-color: #a7f3d0;
  background: #ecfdf5;
  color: #047857;
}

.literature-stage-file-row__meta strong.is-processing {
  border-color: #fde68a;
  background: #fffbeb;
  color: #b45309;
}

.literature-stage-file-row__meta strong.is-attention {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.literature-bundle-head {
  display: none;
  grid-template-columns: minmax(180px, 1fr) minmax(220px, 1.15fr) 92px 82px 130px 44px;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
  padding: 10px 16px;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
}

.literature-drive-list {
  overflow: hidden;
  border: 1px solid #dbe3ea;
  border-radius: 8px;
  background: #ffffff;
}

.literature-drive-list-head,
.literature-drive-row {
  display: grid;
  grid-template-columns: minmax(260px, 1.4fr) minmax(220px, 1.1fr) 96px 82px 132px 96px;
  align-items: center;
  gap: 12px;
}

.literature-drive-list-head {
  min-height: 36px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 0 16px;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
}

.literature-drive-row {
  min-height: 64px;
  border-bottom: 1px solid #edf2f7;
  padding: 10px 16px;
  transition: background 160ms ease;
}

.literature-drive-row:last-child {
  border-bottom: 0;
}

.literature-drive-row:hover {
  background: #f8fafc;
}

.literature-drive-name-cell {
  display: grid;
  min-width: 0;
  grid-template-columns: 34px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  border: 0;
  background: transparent;
  padding: 0;
  color: inherit;
  text-align: left;
}

button.literature-drive-name-cell {
  cursor: pointer;
}

button.literature-drive-name-cell:hover p:first-child {
  color: #047857;
}

.literature-drive-name-cell p + p {
  margin-top: 3px;
}

.literature-drive-row-icon {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.literature-drive-row-icon--folder {
  border: 1px solid #fde68a;
  background: #fffbeb;
  color: #b45309;
}

.literature-drive-row-icon--file {
  border: 1px solid #dbeafe;
  background: #eff6ff;
  color: #2563eb;
}

.literature-drive-status-cell,
.literature-drive-meta-cell,
.literature-drive-actions-cell {
  min-width: 0;
}

.literature-drive-cell-label {
  display: none;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 800;
}

.literature-drive-muted,
.literature-drive-count,
.literature-drive-date {
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}

.literature-drive-date {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.literature-type-pill--plain {
  border-color: #fde68a;
  background: #fffbeb;
  color: #92400e;
}

.literature-drive-actions-cell {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}

.literature-drive-text-button {
  height: 30px;
  border: 1px solid #dbe3ea;
  border-radius: 8px;
  background: #ffffff;
  padding: 0 10px;
  color: #0f766e;
  font-size: 12px;
  font-weight: 800;
  transition: border-color 160ms ease, background 160ms ease, color 160ms ease;
}

.literature-drive-text-button:hover:not(:disabled) {
  border-color: #99f6e4;
  background: #f0fdfa;
  color: #047857;
}

.literature-drive-delete-button {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #94a3b8;
  transition: border-color 160ms ease, background 160ms ease, color 160ms ease;
}

.literature-drive-delete-button:hover:not(:disabled) {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.literature-drive-delete-button:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

@media (max-width: 1180px) {
  .literature-drive-list-head {
    display: none;
  }
  .literature-drive-row {
    grid-template-columns: minmax(0, 1fr);
    align-items: stretch;
    gap: 8px;
    padding: 12px;
  }
  .literature-drive-status-cell,
  .literature-drive-meta-cell,
  .literature-drive-actions-cell {
    display: flex;
    min-width: 0;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding-left: 44px;
  }
  .literature-drive-status-cell {
    align-items: flex-start;
  }
  .literature-drive-cell-label {
    display: inline-flex;
    flex-shrink: 0;
  }
  .literature-drive-actions-cell {
    justify-content: flex-start;
  }
  .literature-text-viewer__body {
    grid-template-columns: minmax(220px, 30%) minmax(0, 1fr);
  }
}
.literature-fab-menu {
  width: 260px;
  overflow: hidden;
  border: 1px solid #dbe3ea;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.16);
}

.literature-fab-menu__item {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  border-top: 1px solid #edf2f7;
  padding: 13px 15px;
  color: #334155;
  text-align: left;
  font-size: 13px;
  font-weight: 700;
  transition: background 160ms ease, color 160ms ease;
}

.literature-fab-menu__item:first-child {
  border-top: 0;
}

.literature-fab-menu__item svg {
  color: #0f766e;
}

.literature-fab-menu__item:hover:not(:disabled) {
  background: #f0fdfa;
  color: #0f172a;
}

.literature-fab-menu__item:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.literature-upload-chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #a7f3d0;
  border-radius: 999px;
  background: #ffffff;
  padding: 7px 12px;
  color: #047857;
  font-size: 12px;
  font-weight: 800;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.12);
}

.literature-upload-chip__pulse {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #10b981;
  box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.35);
  animation: literatureUploadPulse 1.3s ease-out infinite;
}

@keyframes literatureUploadPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.35);
  }
  100% {
    box-shadow: 0 0 0 9px rgba(16, 185, 129, 0);
  }
}
.literature-fab {
  display: inline-flex;
  width: 56px;
  height: 56px;
  align-items: center;
  justify-content: center;
  border: 1px solid #064e3b;
  border-radius: 999px;
  background: #064e3b;
  color: #ffffff;
  box-shadow: 0 18px 34px rgba(6, 78, 59, 0.26);
  transition: transform 170ms ease, background 170ms ease, box-shadow 170ms ease;
}

.literature-fab:hover:not(:disabled) {
  transform: translateY(-2px);
  background: #022c22;
  box-shadow: 0 22px 40px rgba(6, 78, 59, 0.32);
}

.literature-fab:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.literature-modal-backdrop {
  animation: literature-modal-fade 160ms ease-out both;
}

.literature-folder-modal {
  animation: literature-modal-pop 220ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.literature-collection-modal {
  animation: literature-modal-pop 240ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.literature-folder-modal__icon {
  animation: literature-modal-icon-float 1.6s ease-in-out infinite;
}

.literature-collection-modal__icon {
  animation: literature-modal-icon-float 1.6s ease-in-out infinite;
}

@media (prefers-reduced-motion: reduce) {
  .literature-modal-backdrop,
  .literature-folder-modal,
  .literature-collection-modal,
  .literature-folder-modal__icon,
  .literature-collection-modal__icon,
  .literature-loading-mark > span {
    animation: none;
  }
}
@media (min-width: 1024px) {
  .literature-home-header {
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
  }
  .literature-drive-titlebar {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .literature-drive-tools {
    flex: 0 0 auto;
    justify-content: flex-end;
  }
  .literature-drive-search {
    width: 288px;
  }
  .literature-overview-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .literature-bundle-head,
  .literature-bundle-row {
    display: grid;
    grid-template-columns: minmax(180px, 1fr) minmax(220px, 1.15fr) 92px 82px 130px 44px;
  }
}
@media (max-width: 640px) {
  .literature-home-header {
    padding: 18px;
  }
  .literature-drive-header {
    padding: 10px;
  }
  .literature-drive-title-main,
  .literature-drive-tools {
    width: 100%;
  }
  .literature-drive-tools .literature-search,
  .literature-drive-tools .literature-secondary-button {
    width: 100%;
  }
  .literature-drive-status-cell,
  .literature-drive-meta-cell,
  .literature-drive-actions-cell {
    padding-left: 0;
  }
  .literature-stage-drawer {
    width: 100%;
  }
  .literature-stage-backdrop {
    padding: 10px;
  }
  .literature-stage-modal {
    min-height: 0;
    max-height: calc(100vh - 20px);
  }
  .literature-stage-modal__body {
    grid-template-columns: 1fr;
    overflow-y: auto;
  }
  .literature-stage-timeline {
    max-height: 260px;
    border-right: 0;
    border-bottom: 1px solid #edf2f7;
  }
  .literature-stage-metrics {
    grid-template-columns: 1fr;
  }
  .literature-stage-preview {
    max-height: 50vh;
  }
  .literature-stage-preview__head,
  .literature-stage-preview-summary,
  .literature-text-viewer__toolbar,
  .literature-text-viewer__page-head {
    align-items: stretch;
    flex-direction: column;
  }
  .literature-text-viewer-backdrop {
    padding: 8px;
  }
  .literature-text-viewer {
    height: calc(100vh - 16px);
    min-height: 0;
  }
  .literature-text-viewer__body {
    grid-template-columns: 1fr;
    overflow-y: auto;
  }
  .literature-text-viewer__pages {
    max-height: 240px;
    border-right: 0;
    border-bottom: 1px solid #edf2f7;
  }
  .literature-text-viewer__content {
    overflow: visible;
  }
  .literature-text-viewer__pager {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .literature-stage-file-row {
    grid-template-columns: 1fr;
  }
  .literature-stage-file-row__meta {
    align-items: flex-start;
  }
  .literature-overview-grid,
  .literature-storage-strip {
    grid-template-columns: 1fr;
  }
  .literature-collection-grid {
    grid-template-columns: 1fr;
  }
}`],
})
export class PageLiteratureComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public driveLoading: boolean = false;
    public uploading: boolean = false;
    public artifactBuilding: boolean = false;
    public error: string = '';
    public uploadMessage: string = '';
    public lastUploadSummary: any = null;
    public uploadPhase: string = 'idle';
    public uploadPlan: any = {
        file_count: 0,
        folder_count: 0,
        total_bytes: 0,
        source_candidate_count: 0,
        preview: [],
        items: [],
    };

    public collections: any[] = [];
    public collectionQuery: string = '';
    public collectionSaving: boolean = false;
    public collectionDeleting: boolean = false;
    public folderDeletingPath: string = '';
    public bundleDeletingKey: string = '';
    public collectionReindexingId: string = '';
    public showCollectionForm: boolean = false;
    public editingCollection: any = null;
    public expandedCollectionId: string = '';
    public collectionActionMenuId: string = '';
    public collectionForm: any = { title: '', description: '' };
    public showProjectionDiagnostic: boolean = false;
    public projectionDiagnosticLoading: boolean = false;
    public projectionDiagnostic: any = { summary: {}, rows: [] };
    public projectionDiagnosticError: string = '';
    public fileQuery: string = '';
    public fileTypeFilter: string = 'all';
    public fileTypeFilters: any[] = [
        { key: 'all', label: '전체' },
        { key: 'source', label: '원본 자료' },
        { key: 'metadata', label: '자료 정보' },
        { key: 'ocr', label: '텍스트 자료' },
        { key: 'embedding', label: '근거 자료' },
        { key: 'vector', label: '근거 자료' },
        { key: 'status', label: '점검' },
        { key: 'unregistered', label: '원본 자료 확보 전' },
        { key: 'error', label: '오류' },
    ];
    public current: any = null;
    public health: any = { status: 'empty', cards: [], queue: [], summary: {} };
    public readiness: any = { status: 'attention', summary: {}, documents: [], total: 0, listed: 0, truncated: false };
    public root: string = '';
    public currentPath: string = '';
    public currentFolderId: string = '';
    public breadcrumbs: any[] = [];
    public folders: any[] = [];
    public files: any[] = [];
    public bundles: any[] = [];
    public exists: boolean = true;
    public truncated: boolean = false;
    public selected: any = null;
    public stageDetail: any = null;
    public textViewer: any = null;
    public newFolderName: string = '';
    public driveActionMenuOpen: boolean = false;
    public showNewFolderForm: boolean = false;
    public uploadStatus: any = { uploading: false, percent: 0 };
    public driveDragActive: boolean = false;
    public driveInitialVisibleLimit: number = 20;
    public drivePageSize: number = 10;
    public driveVisibleLimit: number = 20;
    public driveIncrementLoading: boolean = false;

    public task: string = 'drive';
    private routerSub: any = null;
    private lastDriveRouteKey: string = '';
    private driveIncrementTimer: any = null;
    private driveScrollContainer: any = null;
    private driveScrollHandler: any = null;
    private stageDetailPreviewToken: number = 0;
    private textViewerToken: number = 0;
    private driveDragDepth: number = 0;
    private uploadSourceExtensions: string[] = ['pdf', 'hwp', 'hwpx', 'doc', 'docx', 'txt'];


    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router,@Inject( ElementRef)  private elementRef: ElementRef) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        if (this.isReviewerRole()) {
            this.service.href('/review');
            return;
        }
        if (this.redirectLegacyDatasetTask()) return;
        this.task = 'drive';
        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd && location.pathname.indexOf('/literature') === 0) {
                await this.syncTask();
            }
        });
        this.bindDriveScrollContainer();
        const route = this.currentDriveRoute();
        await this.loadDrive(route.collectionId, route.folderId, route.path);
    }

    public isReviewerRole() {
        return String(this.service.auth.session?.role || '').toLowerCase() === 'reviewer';
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.driveIncrementTimer) clearTimeout(this.driveIncrementTimer);
        this.unbindDriveScrollContainer();
    }

    public async load() {
        await this.loadDrive(this.current?.id || '', this.currentFolderId || '', this.currentPath || '', true);
    }

    public currentTask() {
        return 'drive';
    }

    public legacyQaUrl() {
        const params = new URLSearchParams(location.search || '');
        if (params.get('task') !== 'dataset') return '';
        const collectionId = this.decodeRouteValue(params.get('collection_id') || '');
        return collectionId ? `/qa?collection_id=${encodeURIComponent(collectionId)}` : '/qa';
    }

    public redirectLegacyDatasetTask() {
        const url = this.legacyQaUrl();
        if (!url) return false;
        this.service.href(url);
        return true;
    }

    public currentDriveRoute() {
        const params = new URLSearchParams(location.search || '');
        const parts = (location.pathname || '').split('/').filter((part: string) => part);
        const literatureIndex = parts.indexOf('literature');
        const pathCollectionId = literatureIndex >= 0 ? this.decodeRouteValue(parts[literatureIndex + 1] || '') : '';
        const pathDriveValue = literatureIndex >= 0 ? parts.slice(literatureIndex + 2).join('/') : '';
        const routeValue = this.normalizeDrivePath(pathDriveValue || '');
        const queryCollectionId = this.decodeRouteValue(params.get('collection_id') || '');
        const queryFolderId = this.decodeRouteValue(params.get('folder_id') || '');
        const queryPath = this.normalizeDrivePath(params.get('path') || '');
        const folderId = queryFolderId || routeValue;
        return {
            collectionId: pathCollectionId || queryCollectionId,
            folderId,
            path: queryPath || (folderId ? '' : routeValue),
        };
    }

    public isCollectionListRoute(route: any) {
        return !route?.collectionId && !route?.folderId && !route?.path;
    }

    public decodeRouteValue(value: any) {
        const text = String(value || '');
        try {
            return decodeURIComponent(text);
        } catch (error) {
            return text;
        }
    }

    public normalizeDrivePath(value: any) {
        return this.decodeRouteValue(value)
            .replace(/\\/g, '/')
            .replace(/^\/+|\/+$/g, '')
            .split('/')
            .filter((part: string) => part && part !== '.' && part !== '..')
            .join('/');
    }

    public isFolderId(value: any) {
        return /^[a-f0-9]{64}$/i.test(String(value || ''));
    }

    public driveNodeRouteKey(collectionId: any = '', folderId: any = '', path: any = '') {
        return `${String(collectionId || '')}::${this.normalizeDrivePath(path || folderId)}`;
    }

    public driveUrl(collectionId: any = '', folderId: any = '') {
        const id = this.decodeRouteValue(collectionId || this.current?.id || '');
        if (!id) return '/literature';
        const nodePath = this.normalizeDrivePath(folderId || '');
        return `/literature/${encodeURIComponent(id)}${nodePath ? `?path=${encodeURIComponent(nodePath)}` : ''}`;
    }

    public async openDriveRoute(collectionId: any = '', folderId: any = '', replace: boolean = false) {
        const targetCollectionId = this.decodeRouteValue(collectionId || this.current?.id || '');
        const nextPath = this.normalizeDrivePath(folderId || '');
        const url = this.driveUrl(targetCollectionId, nextPath);
        await this.loadDrive(targetCollectionId, '', nextPath);
        if (`${location.pathname}${location.search}` !== url) {
            if (replace) {
                window.history.replaceState({}, '', url);
            } else {
                window.history.pushState({}, '', url);
            }
            const wizRoute = (window as any).WizRoute;
            if (wizRoute?.segment) {
                wizRoute.segment.collection_id = targetCollectionId;
                wizRoute.segment.drive_path = nextPath;
            }
        }
    }

    public isDatasetTask() {
        return false;
    }

    public showTopHeader() {
        return !this.loading && !this.isDatasetTask() && !this.current;
    }

    public async openCollectionList() {
        this.selected = null;
        this.stageDetail = null;
        this.current = null;
        this.currentPath = '';
        this.currentFolderId = '';
        this.fileQuery = '';
        this.driveActionMenuOpen = false;
        this.showNewFolderForm = false;
        this.expandedCollectionId = '';
        this.collectionActionMenuId = '';
        this.lastUploadSummary = null;
        const url = '/literature';
        if (`${location.pathname}${location.search}` !== url) {
            window.history.pushState({}, '', url);
        }
        const wizRoute = (window as any).WizRoute;
        if (wizRoute?.segment) {
            wizRoute.segment.collection_id = '';
            wizRoute.segment.drive_path = '';
        }
        await this.loadDrive('', '', '');
    }

    public pageTitle() {
        return '자료 준비';
    }

    public pageCaption() {
        return '원본 확보, 텍스트 완료, 근거 준비, 점검 상태를 관리합니다.';
    }

    public async syncTask() {
        if (this.redirectLegacyDatasetTask()) return;
        const route = this.currentDriveRoute();
        const collectionListRoute = this.isCollectionListRoute(route);
        if (!this.loading) {
            if (collectionListRoute) {
                await this.openCollectionList();
                return;
            }
            const routeKey = this.driveNodeRouteKey(route.collectionId || '', route.folderId, route.path);
            if (routeKey !== this.lastDriveRouteKey) {
                await this.loadDrive(route.collectionId || '', route.folderId, route.path);
            }
            return;
        }
        this.task = 'drive';
        this.loading = true;
        this.error = '';
        this.uploadMessage = '';
        this.lastUploadSummary = null;
        await this.service.render();
        if (collectionListRoute) {
            await this.openCollectionList();
        } else {
            await this.loadDrive(route.collectionId || '', route.folderId, route.path);
        }
    }

    public async loadDrive(collectionId: any = '', folderId: any = '', path: any = null, refresh: boolean = false) {
        const nextPath = path === null || path === undefined ? this.currentPath : path;
        this.error = '';
        this.uploadMessage = '';
        this.lastUploadSummary = null;
        this.driveLoading = !this.loading;
        await this.service.render();

        try {
            const params = {
                collection_id: collectionId || this.current?.id || '',
                folder_id: folderId || '',
                path: nextPath || '',
                refresh: refresh ? '1' : '',
            };
            const { code, data } = await wiz.call("drive", params);
            if (code === 200) {
                this.assignDrive(data || {});
            } else {
                this.error = data?.message || '드라이브 목록을 불러오지 못했습니다.';
            }
        } catch (error: any) {
            this.error = error?.message || '드라이브 목록을 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            this.driveLoading = false;
            await this.service.render();
        }
    }

    public assignDrive(data: any) {
        this.collections = data.collections || this.collections || [];
        this.current = data.current || null;
        this.health = data.health || this.health || { status: 'empty', cards: [], queue: [], summary: {} };
        this.readiness = data.readiness || { status: 'attention', summary: {}, documents: [], total: 0, listed: 0, truncated: false };
        this.root = data.root || '';
        this.currentPath = data.path || '';
        this.currentFolderId = data.folder_id || data.current_node?.id || '';
        this.breadcrumbs = data.breadcrumbs || [];
        this.folders = data.folders || [];
        this.files = data.files || [];
        this.bundles = data.bundles || [];
        this.exists = data.exists !== false;
        this.truncated = data.truncated === true;
        this.lastDriveRouteKey = this.driveNodeRouteKey(this.current?.id || '', this.currentFolderId || '', this.currentPath || '');
        this.resetDriveItemWindow();
        if (this.selected) {
            if (this.selected.type === 'bundle') {
                const currentBundle = this.filteredBundles.find((bundle: any) => bundle.key === this.selected.key);
                this.selected = currentBundle ? { ...currentBundle, type: 'bundle' } : null;
            } else if (!this.files.find((file: any) => file.path === this.selected.path)) {
                this.selected = null;
            }
        }
    }

    public uploadSummaryFromResponse(data: any) {
        const uploaded = data?.uploaded || [];
        const registered = uploaded.filter((item: any) => item?.registered);
        const completed = registered.filter((item: any) => String(item?.auto_pipeline?.status || '') === 'completed');
        const failed = registered.filter((item: any) => String(item?.auto_pipeline?.status || '') === 'failed');
        const processing = registered.filter((item: any) => {
            const status = String(item?.auto_pipeline?.status || '');
            return status && status !== 'completed' && status !== 'failed';
        });
        const sourceCandidates = uploaded.filter((item: any) => this.isUploadSourceExtension(item?.extension || item?.name || item?.path));
        return {
            uploaded_count: uploaded.length,
            registered_count: registered.length,
            pipeline_completed_count: completed.length,
            pipeline_failed_count: failed.length,
            pipeline_processing_count: processing.length,
            source_candidate_count: sourceCandidates.length,
            stored_only_count: uploaded.length - sourceCandidates.length,
            files: uploaded,
        };
    }

    public uploadCompletionMessage(summary: any) {
        const uploaded = Number(summary?.uploaded_count || 0);
        const registered = Number(summary?.registered_count || 0);
        const completed = Number(summary?.pipeline_completed_count || 0);
        const failed = Number(summary?.pipeline_failed_count || 0);
        if (registered > 0) {
            if (failed > 0) {
                const reason = this.uploadFailureReason(summary);
                return `${this.number(uploaded)}개 파일을 업로드하고 ${this.number(registered)}개 자료를 등록했습니다. ${this.number(failed)}개 자료는 OCR/임베딩 자동 처리 확인이 필요합니다.${reason ? ` 원인: ${reason}` : ''}`;
            }
            if (completed > 0) {
                return `${this.number(uploaded)}개 파일을 업로드하고 ${this.number(registered)}개 자료를 등록했습니다. OCR과 임베딩까지 자동 생성했습니다.`;
            }
            return `${this.number(uploaded)}개 파일을 업로드하고 ${this.number(registered)}개 자료를 등록했습니다. OCR과 임베딩 자동 처리를 진행했습니다.`;
        }
        return `${this.number(uploaded)}개 파일을 업로드했습니다. 원본 자료 형식이면 자료 등록 후 처리 흐름에 들어갑니다.`;
    }

    public uploadFailureReason(summary: any) {
        const files = summary?.files || [];
        for (const file of files) {
            const message = this.primaryIssueMessage(file);
            if (message) return message;
        }
        return '';
    }

    public pipelineIssuesFrom(source: any) {
        const issues: any[] = [];
        const push = (items: any) => {
            if (!Array.isArray(items)) return;
            for (const issue of items) {
                if (!issue || typeof issue !== 'object') continue;
                const key = `${issue?.code || ''}:${issue?.message || ''}:${issue?.path || ''}`;
                const exists = issues.some((item: any) => `${item?.code || ''}:${item?.message || ''}:${item?.path || ''}` === key);
                if (!exists) issues.push(issue);
            }
        };
        push(source?.issues);
        push(source?.auto_pipeline?.issues);
        push(source?.pipeline?.issues);
        if (Array.isArray(source?.files)) {
            for (const file of source.files) {
                push(file?.issues);
                push(file?.auto_pipeline?.issues);
            }
        }
        return issues;
    }

    public issueMessage(issue: any) {
        const code = String(issue?.code || '').trim();
        if (code === 'GEMINI_INLINE_FILE_TOO_LARGE') return '전체 파일 LLM OCR 입력 제한을 초과했습니다. 페이지 단위 OCR로 다시 처리해야 합니다.';

        const message = this.businessStatusText(issue?.message || '').trim();
        if (message) {
            const normalized = message
                .replace(/Gemini inline\s*(OCR|텍스트 자료)?\s*입력 크기 제한을 초과했습니다\.?/gi, '전체 파일 LLM OCR 입력 제한을 초과했습니다.')
                .replace(/\s*PDF를 분할하거나 용량을 줄여 다시 업로드하세요\.?/g, '')
                .replace(/Gemini OCR API 키/g, 'OCR API 키');
            if (/전체 파일 LLM OCR 입력 제한/.test(normalized) && !/페이지 단위 OCR/.test(normalized)) {
                return `${normalized} 페이지 단위 OCR로 다시 처리해야 합니다.`;
            }
            return normalized;
        }
        if (code === 'PDF_PAGE_UNIT_OCR_REQUIRED') return '텍스트 레이어가 없는 PDF입니다. 전체 파일 LLM 입력 대신 페이지 단위 OCR 처리가 필요합니다.';
        if (code === 'PDF_PAGE_OCR_DEFERRED') return '페이지 단위 OCR 처리 한도를 초과해 일부 페이지는 후속 처리가 필요합니다.';
        if (code === 'PDF_PAGE_OCR_FAILED') return '일부 페이지 OCR에 실패했습니다. 해당 페이지를 확인해야 합니다.';
        if (code === 'PDF_RENDERER_UNAVAILABLE' || code === 'PDF_RENDERER_OPEN_FAILED') return 'PDF 페이지 렌더링을 준비하지 못해 페이지 단위 OCR을 진행하지 못했습니다.';
        if (code === 'PAGE_UNIT_TEXT_EXTRACTION_REQUIRED') return '전체 파일 LLM 입력 대신 페이지/섹션 단위 텍스트 추출 정책이 필요한 문서입니다.';
        if (code === 'GEMINI_API_KEY_MISSING') return 'OCR API 키가 설정되지 않아 자동 텍스트 추출을 진행하지 못했습니다.';
        if (code === 'UNSUPPORTED_UPLOAD_SOURCE') return '지원하지 않는 원본 형식이라 자동 처리를 진행하지 못했습니다.';
        if (code === 'OPENAI_EMBEDDING_FAILED') return '임베딩 생성에 실패했습니다. API 설정과 처리 상태를 확인하세요.';
        if (code === 'MILVUS_INSERT_FAILED') return '근거 자료 저장소 등록에 실패했습니다.';
        return '';
    }

    public primaryIssueMessage(source: any) {
        const issues = this.pipelineIssuesFrom(source);
        const preferred = issues.find((issue: any) => String(issue?.severity || '').toLowerCase() === 'review_required') || issues[0];
        return preferred ? this.issueMessage(preferred) : '';
    }

    public isUploadSourceExtension(value: any) {
        const raw = String(value || '').toLowerCase().split('?')[0].split('#')[0];
        const extension = raw.includes('.') ? raw.split('.').pop() : raw;
        return this.uploadSourceExtensions.includes(String(extension || '').replace(/^\./, ''));
    }

    public uploadRelativePath(file: any) {
        return String(file?.filepath || file?.webkitRelativePath || file?.name || '').replace(/\\/g, '/').replace(/^\/+/, '');
    }

    public buildUploadPlan(list: any[]) {
        const folderMap: any = {};
        const preview: string[] = [];
        const items: any[] = [];
        let totalBytes = 0;
        let sourceCandidateCount = 0;
        for (let i = 0; i < list.length; i++) {
            const file: any = list[i];
            const relpath = this.uploadRelativePath(file) || String(file?.name || '');
            const extension = String(relpath.split('.').pop() || '').toLowerCase();
            const sourceCandidate = this.isUploadSourceExtension(relpath);
            totalBytes += Number(file?.size || 0);
            if (sourceCandidate) sourceCandidateCount += 1;
            if (preview.length < 3) preview.push(relpath || `파일 ${i + 1}`);
            items.push({
                name: String(file?.name || relpath || `파일 ${i + 1}`),
                path: relpath,
                size_bytes: Number(file?.size || 0),
                extension,
                source_candidate: sourceCandidate,
            });
            const parts = relpath.split('/').filter((part: string) => part);
            if (parts.length > 1) folderMap[parts.slice(0, -1).join('/')] = true;
        }
        return {
            file_count: list.length,
            folder_count: Object.keys(folderMap).length,
            total_bytes: totalBytes,
            source_candidate_count: sourceCandidateCount,
            preview,
            items,
        };
    }

    public uploadProgressPercent() {
        return Math.max(0, Math.min(100, Number(this.uploadStatus?.percent || 0)));
    }

    public uploadFloatingLabel() {
        if (this.uploadPhase === 'processing') return `업로드 ${this.number(this.uploadProgressPercent())}% · 처리 중`;
        return `업로드 ${this.number(this.uploadProgressPercent())}%`;
    }

    public uploadWorkItemsVisible() {
        if (this.uploading) return true;
        if (!this.lastUploadSummary) return false;
        return Number(this.lastUploadSummary?.pipeline_failed_count || 0) > 0
            || Number(this.lastUploadSummary?.pipeline_processing_count || 0) > 0
            || Number(this.lastUploadSummary?.stored_only_count || 0) > 0;
    }

    public uploadWorkItems() {
        const files = this.lastUploadSummary?.files || [];
        const source = files.length
            ? files.map((file: any) => ({
                name: String(file?.name || file?.path || ''),
                path: String(file?.path || file?.name || ''),
                size_bytes: Number(file?.size_bytes || 0),
                extension: String(file?.extension || '').toLowerCase(),
                source_candidate: this.isUploadSourceExtension(file?.extension || file?.path || file?.name),
                registered: !!file?.registered,
                auto_pipeline: file?.auto_pipeline || {},
                issues: file?.issues || file?.auto_pipeline?.issues || [],
            }))
            : (this.uploadPlan?.items || []);
        return source.slice(0, 8);
    }

    public uploadWorkHiddenCount() {
        const total = Number(this.lastUploadSummary?.uploaded_count || this.uploadPlan?.file_count || 0);
        return Math.max(0, total - this.uploadWorkItems().length);
    }

    public uploadWorkItemStatus(item: any) {
        if (this.uploading && this.uploadPhase !== 'processing') return 'transferring';
        if (this.uploading && this.uploadPhase === 'processing') return item?.source_candidate ? 'processing' : 'stored';
        if (item?.registered) {
            const status = String(item?.auto_pipeline?.status || '');
            if (status === 'failed') return 'attention';
            if (status === 'completed') return 'complete';
            return 'processing';
        }
        return item?.source_candidate ? 'attention' : 'stored';
    }

    public uploadWorkItemStatusLabel(item: any) {
        const status = this.uploadWorkItemStatus(item);
        if (status === 'transferring') return `${this.number(this.uploadProgressPercent())}%`;
        if (status === 'processing') {
            const progress = this.uploadWorkItemProgress(item);
            if (progress > 0 && progress < 100) return `${this.number(progress)}%`;
            return this.uploading ? '전송 완료' : '처리 중';
        }
        if (status === 'complete') return '완료';
        if (status === 'attention') return '확인 필요';
        return '보관 완료';
    }

    public uploadWorkItemDetail(item: any) {
        const status = this.uploadWorkItemStatus(item);
        if (status === 'transferring') return '파일을 서버로 전송하고 있습니다.';
        if (status === 'processing') return this.uploading ? '서버 처리 결과를 기다리고 있습니다.' : 'OCR과 임베딩을 처리하고 있습니다.';
        if (status === 'complete') return 'OCR과 임베딩 자동 처리가 완료되었습니다.';
        if (status === 'attention') {
            const reason = this.primaryIssueMessage(item);
            if (reason) return reason;
            return item?.registered ? 'OCR/임베딩 처리 결과 확인이 필요합니다.' : '원본 자료 등록 여부를 확인해야 합니다.';
        }
        return '서버에 파일을 보관했습니다.';
    }

    public uploadWorkItemClass(item: any) {
        return `is-${this.uploadWorkItemStatus(item)}`;
    }

    public uploadWorkItemBarWidth(item: any) {
        return this.uploadWorkItemProgress(item);
    }

    public uploadWorkItemProgress(item: any) {
        const status = this.uploadWorkItemStatus(item);
        if (status === 'transferring') return this.uploadProgressPercent();
        if (status === 'processing') {
            if (this.uploading) return this.uploadProgressPercent();
            return this.uploadPipelineProgressPercent(item);
        }
        if (status === 'attention') {
            return item?.registered ? this.uploadPipelineProgressPercent(item) : 0;
        }
        return 100;
    }

    public uploadPipelineProgressPercent(item: any) {
        const pipeline = item?.auto_pipeline || {};
        const rawStatus = String(pipeline?.status || '').toLowerCase();
        if (rawStatus === 'completed') return 100;
        const steps = [
            !!item?.registered || !!pipeline?.document_id,
            this.uploadPipelineStageDone(pipeline?.ocr_status) || Number(pipeline?.text_unit_count || pipeline?.ocr_page_count || 0) > 0,
            this.uploadPipelineStageDone(pipeline?.embedding_status) || Number(pipeline?.evidence_unit_count || pipeline?.embedding_chunk_count || 0) > 0,
            this.uploadPipelineStageDone(pipeline?.vector_status) || Number(pipeline?.indexed_evidence_count || 0) > 0,
        ];
        const completed = steps.filter((done: boolean) => done).length;
        return Math.max(0, Math.min(100, Math.round((completed / steps.length) * 100)));
    }

    public uploadPipelineStageDone(status: any) {
        const value = String(status || '').toLowerCase();
        return this.doneStatus(value) || ['empty', 'not_required', 'skipped'].includes(value);
    }

    public uploadWorkItemSize(item: any) {
        return Number(item?.size_bytes || 0) > 0 ? this.fileSize(item?.size_bytes) : '-';
    }

    public uploadFlowSubtitle() {
        if (this.uploading && this.uploadPhase === 'processing') {
            return `${this.number(this.uploadPlan?.file_count || 0)}개 파일 전송 완료 · OCR과 임베딩을 서버에서 처리합니다.`;
        }
        if (this.uploading) {
            return `${this.number(this.uploadPlan?.file_count || 0)}개 파일 · ${this.fileSize(this.uploadPlan?.total_bytes || 0)} · ${this.number(this.uploadProgressPercent())}% 전송`;
        }
        const uploaded = Number(this.lastUploadSummary?.uploaded_count || 0);
        const registered = Number(this.lastUploadSummary?.registered_count || 0);
        if (registered > 0) return `${this.number(uploaded)}개 업로드 · ${this.number(registered)}개 자료 등록`;
        return `${this.number(uploaded)}개 업로드 · 처리 대상 원본 자료는 등록 후 진행됩니다.`;
    }

    public lastUploadedBundles() {
        const files = this.lastUploadSummary?.files || [];
        if (!files.length) return [];
        const refs = files
            .filter((file: any) => file?.registered)
            .map((file: any) => ({
                bundle_id: String(file?.bundle_id || ''),
                bundle_key: String(file?.bundle_key || ''),
                path: String(file?.path || '').replace(/\\/g, '/').replace(/^\/+/, ''),
            }));
        if (!refs.length) return [];
        return (this.bundles || []).filter((bundle: any) => {
            const bundleId = String(bundle?.bundle_id || '');
            const bundleKey = String(bundle?.bundle_key || bundle?.key || '');
            const sourcePaths = this.sourceFiles(bundle).map((file: any) => String(file?.path || '').replace(/\\/g, '/').replace(/^\/+/, ''));
            return refs.some((ref: any) => {
                if (ref.bundle_id && ref.bundle_id === bundleId) return true;
                if (ref.bundle_key && ref.bundle_key === bundleKey) return true;
                return ref.path && sourcePaths.includes(ref.path);
            });
        });
    }

    public get visibleCollections() {
        const text = this.collectionQuery.trim().toLowerCase();
        if (!text) return this.collections;
        return this.collections.filter((collection: any) => this.matches(collection, text, ['title', 'id', 'source_path', 'description']));
    }

    public get datasetCollectionOptions() {
        return this.collections || [];
    }

    public collectionFlowExpanded(collection: any) {
        return !!collection?.id && this.expandedCollectionId === collection.id;
    }

    public async toggleCollectionFlow(collection: any) {
        if (!collection?.id) return;
        this.collectionActionMenuId = '';
        this.expandedCollectionId = this.collectionFlowExpanded(collection) ? '' : collection.id;
        await this.service.render();
    }

    public collectionActionMenuOpen(collection: any) {
        return !!collection?.id && this.collectionActionMenuId === collection.id;
    }

    public async toggleCollectionActionMenu(collection: any) {
        if (!collection?.id) return;
        this.expandedCollectionId = '';
        this.collectionActionMenuId = this.collectionActionMenuOpen(collection) ? '' : collection.id;
        await this.service.render();
    }

    public async closeCollectionActionMenu() {
        if (!this.collectionActionMenuId) return;
        this.collectionActionMenuId = '';
        await this.service.render();
    }

    public collectionStatus(collection: any) {
        return collection?.status || 'active';
    }

    public collectionDeletionRequested(collection: any) {
        const status = this.collectionStatus(collection);
        return status === 'deletion_requested' || status === 'archived';
    }

    public collectionReferenceCount(collection: any) {
        return Math.max(
            Number(collection?.qa_reference_document_count || 0),
            Number(collection?.qa_reference_file_count || 0),
            Number(collection?.document_count || 0),
            Number(collection?.file_count || 0),
        );
    }

    public collectionProjectionStatus(collection: any) {
        return String(collection?.qa_projection_cache_status || collection?.qa_lightweight_ledger_status || 'ready');
    }

    public collectionProjectionNeedsRefresh(collection: any) {
        const status = this.collectionProjectionStatus(collection);
        return this.collectionReferenceCount(collection) > 0
            && ['preparing', 'refresh_required', 'reindex_required', 'fallback', 'stale'].includes(status);
    }

    public collectionProjectionLabel(collection: any) {
        if (!this.collectionProjectionNeedsRefresh(collection)) return '';
        const label = String(collection?.qa_projection_cache_label || collection?.qa_lightweight_ledger_label || '').trim();
        if (label) return this.projectionStatusText(label);
        const status = this.collectionProjectionStatus(collection);
        if (status === 'preparing') return '처리 상태 비어 있음';
        if (status === 'fallback') return '처리 상태 임시 표시';
        if (status === 'stale') return '처리 상태 오래됨';
        return '처리 상태 재계산 필요';
    }

    public collectionProjectionMessage(collection: any) {
        if (!this.collectionProjectionNeedsRefresh(collection)) return '';
        const message = String(collection?.qa_projection_cache_message || collection?.qa_lightweight_ledger_message || '').trim();
        if (message) return this.projectionStatusText(message);
        return '화면 조회 상태가 비어 있거나 오래되어 처리 기준으로 임시 표시합니다.';
    }

    public collectionProjectionNoticeCollections() {
        return (this.collections || []).filter((collection: any) => this.collectionProjectionNeedsRefresh(collection));
    }

    public collectionProjectionNoticeCount() {
        return this.collectionProjectionNoticeCollections().length;
    }

    public collectionProjectionNoticeTitle() {
        const count = this.collectionProjectionNoticeCount();
        if (count <= 1) return '처리 상태 재계산 필요';
        return `처리 상태 재계산 필요 ${this.number(count)}개`;
    }

    public collectionProjectionNoticeMessage() {
        const targets = this.collectionProjectionNoticeCollections();
        if (targets.length <= 0) return '';
        const first = targets[0];
        const base = this.collectionProjectionMessage(first);
        if (targets.length === 1) return base;
        return `${base} 외 ${this.number(targets.length - 1)}개 컬렉션도 처리 상태 갱신이 필요합니다.`;
    }

    public collectionProjectionNoticeActionLabel() {
        const targets = this.collectionProjectionNoticeCollections();
        if (this.collectionReindexingId) return '갱신 중';
        return targets.length > 1 ? '필요 항목 재계산' : '처리 상태 재계산';
    }

    public async refreshCollectionsNeedingProjection() {
        if (this.collectionReindexingId) return;
        const targets = this.collectionProjectionNoticeCollections();
        for (const target of targets) {
            const collection = (this.collections || []).find((item: any) => item.id === target.id) || target;
            if (!this.collectionProjectionNeedsRefresh(collection)) continue;
            await this.recalculateCollectionStatus(collection);
        }
    }

    public harnessDisplayText(value: any) {
        const text = String(value || '').trim();
        if (!text) return '';
        return text
            .replace(/DB\s*\/\s*파일\s*\/\s*벡터/gi, '처리 결과')
            .replace(/DB\s*원장/gi, '운영 상태')
            .replace(/artifact chain\s*\/\s*doc\s*\/\s*file\s*\/\s*chunk\s*\/\s*vec/gi, '처리 결과 흐름')
            .replace(/doc\s*\/\s*file\s*\/\s*chunk\s*\/\s*vec/gi, '처리 결과 흐름')
            .replace(/doc\s*\/\s*file|col\s*\/\s*doc\s*\/\s*file|doc\s*\/\s*file\s*원장/gi, '원본 자료')
            .replace(/chunk\s*\/\s*vec/gi, '근거 자료')
            .replace(/lit_bundle/gi, '자료 상태')
            .replace(/lit_catalog/gi, '점검 상태')
            .replace(/\bDB\b/gi, '운영')
            .replace(/\bdoc\b/gi, '원본 자료')
            .replace(/\bfile\b/gi, '원본 자료')
            .replace(/\bchunk\b/gi, '근거 자료')
            .replace(/\bvec\b/gi, '근거 자료')
            .replace(/\bvector\b/gi, '근거 자료')
            .replace(/\bembedding\b/gi, '근거 자료')
            .replace(/\bocr\b/gi, '텍스트 자료')
            .replace(/\bcatalog\b/gi, '점검 상태')
            .replace(/\bbundle\b/gi, '자료 상태')
            .replace(/벡터/g, '근거 자료')
            .replace(/색인 상태/g, '근거 준비 상태')
            .replace(/원장/g, '운영 상태')
            .replace(/\s{2,}/g, ' ');
    }

    public projectionStatusText(value: any) {
        const text = String(value || '');
        const normalized = text
            .replace(/\uACBD\uB7C9\s*\uC6D0\uC7A5/g, '운영 상태')
            .replace(/projection\/cache/gi, '운영 상태')
            .replace(/projection/gi, '상태')
            .replace(/cache/gi, '조회 상태')
            .replace(/lit_bundle/g, '자료 상태')
            .replace(/lit_catalog/g, '점검 상태')
            .replace(/bundle\s+조회 상태/gi, '자료 상태')
            .replace(/catalog\s+조회 상태/gi, '점검 상태')
            .replace(/artifact chain\/doc\/file\/chunk\/vec/gi, '운영 상태')
            .replace(/doc\/file\/chunk\/vec/gi, '운영 상태')
            .replace(/doc\/file|col\/doc\/file|doc\/file\s*\uC6D0\uC7A5/g, '원본 확보 상태')
            .replace(/\uC6D0\uC7A5/g, '기준 상태')
            .replace(/DB\s*file/gi, '파일 상태');
        return this.harnessDisplayText(normalized);
    }

    public collectionPurpose(collection: any) {
        const description = String(collection?.description || '').trim();
        if (description && !this.isCollectionTechnicalSummary(description)) return description;
        return '';
    }

    public isCollectionTechnicalSummary(value: any) {
        const text = String(value || '').trim();
        if (!text) return false;
        const keys = [
            'embedding', 'embedding_status', 'metadata_json', 'ocr', 'ocr_status',
            'other_file', 'source_pdf', 'vector_status',
        ];
        if (!(text.startsWith('{') && text.endsWith('}'))) return false;
        try {
            const parsed = JSON.parse(text);
            if (!parsed || Array.isArray(parsed) || typeof parsed !== 'object') return false;
            const parsedKeys = Object.keys(parsed);
            const knownCount = parsedKeys.filter((key: string) => keys.includes(key)).length;
            const numericCount = parsedKeys.filter((key: string) => Number.isFinite(Number(parsed[key]))).length;
            return knownCount >= 2 && numericCount === parsedKeys.length;
        } catch (error) {
            return keys.some((key: string) => text.indexOf(`"${key}"`) >= 0);
        }
    }

    public collectionDocumentCount(collection: any) {
        return Number(collection?.qa_bundle_total || collection?.qa_document_total || collection?.document_count || 0);
    }

    public collectionOriginalRegisteredCount(collection: any) {
        return Number(collection?.qa_original_registered_count || collection?.source_file_count || 0);
    }

    public collectionProcessingCount(collection: any) {
        return Number(collection?.qa_processing_count || 0);
    }

    public collectionAttentionCount(collection: any) {
        return Number(collection?.qa_attention_count || 0);
    }

    public collectionUnavailableCount(collection: any) {
        return Number(collection?.qa_unavailable_count || 0);
    }

    public collectionTextReadyCount(collection: any) {
        return Number(collection?.qa_text_ready_count || 0);
    }

    public collectionReviewRequiredCount(collection: any) {
        return this.collectionAttentionCount(collection);
    }

    public collectionEvidenceReadyDocumentCount(collection: any) {
        return Number(collection?.qa_evidence_ready_document_count || collection?.qa_usable_count || 0);
    }

    public collectionEvidenceReadyCount(collection: any) {
        return Number(collection?.qa_eligible_evidence_total || collection?.qa_evidence_total || 0);
    }

    public normalizeH2GateStatus(status: any) {
        const value = String(status || '').trim();
        if (value === 'usable') return 'usable';
        if (value === 'attention' || value === 'unavailable') return 'attention';
        if (value === 'partial' || value === 'processing') return 'processing';
        return '';
    }

    public collectionH2GateStatus(collection: any) {
        if (!collection) return 'processing';
        if (this.collectionDeletionRequested(collection)) return 'attention';
        if (this.collectionProjectionNeedsRefresh(collection)) return 'processing';
        const declared = this.normalizeH2GateStatus(collection?.h2_gate_status || collection?.qa_h2_gate_status || collection?.qa_status);
        if (declared) return declared;
        const total = this.collectionDocumentCount(collection);
        if (this.collectionReviewRequiredCount(collection) > 0 || total <= 0) return 'attention';
        if (this.collectionTextReadyCount(collection) < total) return this.collectionProcessingCount(collection) > 0 ? 'processing' : 'attention';
        if (this.collectionEvidenceReadyDocumentCount(collection) < total) return this.collectionProcessingCount(collection) > 0 ? 'processing' : 'attention';
        if (Number(collection?.qa_vector_total || 0) <= 0) return this.collectionProcessingCount(collection) > 0 ? 'processing' : 'attention';
        return 'usable';
    }

    public collectionH2GateLabel(collection: any) {
        const status = this.collectionH2GateStatus(collection);
        if (status === 'usable') return 'QA 작성 가능';
        if (status === 'attention') return '점검 필요';
        return '자료 처리 중';
    }

    public collectionH2GateReasons(collection: any) {
        const raw = collection?.h2_gate_reasons || collection?.qa_h2_gate_reasons || [];
        const reasons = Array.isArray(raw) ? raw : [raw];
        const cleaned = reasons.map((item: any) => String(item || '').trim()).filter((item: string) => item);
        if (cleaned.length > 0) return cleaned.map((item: string) => this.harnessDisplayText(item));
        const reason = String(collection?.h2_gate_reason || collection?.qa_h2_gate_reason || '').trim();
        if (reason) return [this.harnessDisplayText(reason)];
        return this.collectionReadinessGapItems(collection);
    }

    public collectionH2GateReason(collection: any) {
        if (this.collectionProjectionNeedsRefresh(collection)) return '상태 재계산 필요';
        if (this.collectionDeletionRequested(collection)) return '폐기 요청 상태';
        if (this.collectionH2GateStatus(collection) === 'usable') return '준비 완료';
        const reasons = this.collectionH2GateReasons(collection);
        return reasons[0] || '상태 확인 필요';
    }

    public collectionH2GateCriteria(collection: any) {
        const criteria = collection?.h2_gate_criteria || collection?.qa_h2_gate_criteria || [];
        if (Array.isArray(criteria) && criteria.length > 0) {
            return criteria.map((item: any) => ({
                label: this.h2GateCriterionLabel(item),
                value: this.h2GateCriterionStatusLabel(item?.status),
                sub: this.h2GateCriterionSubLabel(collection, item),
                status: this.normalizeH2GateStatus(item?.status) || 'processing',
            }));
        }
        return [
            { key: 'original', label: '원본', value: this.collectionSourceStatus(collection) === 'usable' ? '충족' : '점검', sub: `${this.number(this.collectionOriginalRegisteredCount(collection))} / ${this.number(this.collectionDocumentCount(collection))}건 확보`, status: this.collectionSourceStatus(collection) },
            { key: 'text', label: '텍스트', value: this.collectionRecognitionStatus(collection) === 'usable' ? '충족' : '미완료', sub: `${this.number(this.collectionTextReadyCount(collection))} / ${this.number(this.collectionDocumentCount(collection))}건 생성`, status: this.collectionRecognitionStatus(collection) },
            { key: 'evidence', label: '근거', value: this.collectionEvidenceStatus(collection) === 'usable' ? '충족' : '미완료', sub: `${this.number(this.collectionEvidenceReadyDocumentCount(collection))} / ${this.number(this.collectionDocumentCount(collection))}건 준비`, status: this.collectionEvidenceStatus(collection) },
            { key: 'search', label: '점검 상태', value: Number(collection?.qa_vector_total || 0) > 0 ? '충족' : '필요', sub: `근거 자료 ${this.number(collection?.qa_vector_total || 0)}개`, status: Number(collection?.qa_vector_total || 0) > 0 ? 'usable' : this.collectionH2GateStatus(collection) },
            { key: 'integrity', label: '오류/누락', value: this.collectionReviewRequiredCount(collection) > 0 ? '점검' : '없음', sub: this.collectionReviewRequiredCount(collection) > 0 ? `점검 ${this.number(this.collectionReviewRequiredCount(collection))}건` : '오류/누락 없음', status: this.collectionReviewRequiredCount(collection) > 0 ? 'attention' : 'usable' },
        ];
    }

    public h2GateCriterionLabel(item: any) {
        const key = String(item?.key || '').trim();
        if (key === 'original') return '원본 확보';
        if (key === 'text') return '텍스트 완료';
        if (key === 'evidence') return '근거 준비';
        if (key === 'search') return '점검 상태';
        if (key === 'integrity') return '점검 상태';
        return this.harnessDisplayText(item?.label || '-') || '-';
    }

    public h2GateCriterionSubLabel(collection: any, item: any) {
        const reason = String(item?.reason || '').trim();
        if (reason) return this.simplifyGateText(reason);
        const key = String(item?.key || '').trim();
        const total = this.collectionDocumentCount(collection);
        if (key === 'original') return `${this.number(this.collectionOriginalRegisteredCount(collection))} / ${this.number(total)}건 확보`;
        if (key === 'text') return `${this.number(this.collectionTextReadyCount(collection))} / ${this.number(total)}건 생성`;
        if (key === 'evidence') return `${this.number(this.collectionEvidenceReadyDocumentCount(collection))} / ${this.number(total)}건 준비`;
        if (key === 'search') return `근거 자료 ${this.number(collection?.qa_vector_total || 0)}개`;
        if (key === 'integrity') {
            const review = this.collectionReviewRequiredCount(collection);
            return review > 0 ? `점검 ${this.number(review)}건` : '오류/누락 없음';
        }
        return this.simplifyGateText(item?.description || '');
    }

    public simplifyGateText(value: any) {
        return this.harnessDisplayText(value);
    }

    public h2GateCriterionStatusLabel(status: any) {
        const value = this.normalizeH2GateStatus(status);
        if (value === 'usable') return '충족';
        if (value === 'attention') return '점검';
        return '진행 중';
    }

    public collectionSummaryItems(collection: any) {
        return [
            { key: 'documents', label: '원본 확보', value: this.collectionDocumentCount(collection), status: this.collectionSourceStatus(collection) },
            { key: 'recognition', label: '텍스트 완료', value: this.collectionTextReadyCount(collection), status: this.collectionRecognitionStatus(collection) },
            { key: 'evidence', label: '근거 준비', value: this.collectionEvidenceReadyDocumentCount(collection), status: this.collectionEvidenceStatus(collection) },
            { key: 'review', label: '점검 상태', value: this.collectionReviewRequiredCount(collection), status: this.collectionH2GateStatus(collection) },
        ];
    }

    public collectionOverviewCards() {
        const rows = this.collections || [];
        const active = rows.filter((collection: any) => !this.collectionDeletionRequested(collection)).length;
        const deletionRequested = rows.length - active;
        const documents = rows.reduce((sum: number, collection: any) => sum + this.collectionDocumentCount(collection), 0);
        const files = rows.reduce((sum: number, collection: any) => sum + Number(collection?.file_count || collection?.source_file_count || 0), 0);
        return [
            { label: '컬렉션', value: rows.length, sub: `사용 중 ${this.number(active)}개` },
            { label: '등록 자료', value: documents, sub: '컬렉션 기준 합계' },
            { label: '보관 파일', value: files, sub: '원본 파일 기준' },
            { label: '폐기 요청', value: deletionRequested, sub: '변경 제한 컬렉션' },
        ];
    }

    public collectionStorageItems(collection: any) {
        return [
            { label: '등록 자료', value: `${this.number(this.collectionDocumentCount(collection))}건` },
            { label: '보관 파일', value: `${this.number(collection?.file_count || 0)}개` },
            { label: '원본 파일', value: `${this.number(collection?.source_file_count || 0)}개` },
        ];
    }

    public collectionStageSequence(collection: any) {
        const total = this.collectionDocumentCount(collection);
        const original = this.collectionOriginalRegisteredCount(collection);
        const textReady = this.collectionTextReadyCount(collection);
        const evidenceReady = this.collectionEvidenceReadyDocumentCount(collection);
        const processing = this.collectionProcessingCount(collection);
        if (this.collectionProjectionNeedsRefresh(collection)) {
            return [
                { key: 'source', label: '원본 확보', status: 'unavailable' },
                { key: 'text', label: '텍스트 완료', status: 'unavailable' },
                { key: 'evidence', label: '근거 준비', status: 'unavailable' },
                { key: 'gate', label: '점검 상태', status: 'processing' },
            ];
        }

        const sourceStatus = total <= 0 || original <= 0
            ? 'attention'
            : (original < total ? (processing > 0 ? 'processing' : 'attention') : 'usable');
        const textStatus = sourceStatus !== 'usable'
            ? 'unavailable'
            : (textReady >= total ? 'usable' : (processing > 0 ? 'processing' : 'attention'));
        const evidenceStatus = textStatus !== 'usable'
            ? 'unavailable'
            : (evidenceReady >= total ? 'usable' : (processing > 0 ? 'processing' : 'attention'));
        const gateStatus = sourceStatus === 'usable' && textStatus === 'usable' && evidenceStatus === 'usable'
            ? this.collectionH2GateStatus(collection)
            : 'unavailable';
        return [
            { key: 'source', label: '원본 확보', status: sourceStatus },
            { key: 'text', label: '텍스트 완료', status: textStatus },
            { key: 'evidence', label: '근거 준비', status: evidenceStatus },
            { key: 'gate', label: '점검 상태', status: gateStatus },
        ];
    }

    public collectionBlockedStage(collection: any) {
        if (this.collectionProjectionNeedsRefresh(collection)) {
            return { key: 'gate', label: '점검 상태', status: 'processing' };
        }
        const stages = this.collectionStageSequence(collection);
        return stages.find((item: any) => ['attention', 'processing'].includes(item.status))
            || stages.find((item: any) => item.key === 'gate')
            || { key: 'gate', label: '점검 상태', status: 'usable' };
    }

    public collectionCardStageItems(collection: any) {
        const current = this.collectionBlockedStage(collection);
        return this.collectionStageSequence(collection).map((item: any) => ({
            ...item,
            value: this.collectionStageValue(item.key, item.status, collection),
            current: item.key === current.key && this.collectionFinalStatus(collection) !== 'usable',
        }));
    }

    public collectionStageValue(key: string, status: string, collection: any) {
        if (this.collectionProjectionNeedsRefresh(collection)) return key === 'gate' ? '재계산' : '확인 전';
        if (status === 'usable') return '통과';
        if (status === 'processing') return key === 'gate' ? '처리 중' : '진행';
        if (status === 'attention') return key === 'gate' ? '점검' : '막힘';
        return '대기';
    }

    public collectionDecisionTitle(collection: any) {
        if (this.collectionProjectionNeedsRefresh(collection)) return '상태 재계산 필요';
        if (this.collectionReadyForQaAuthoring(collection)) return 'QA 작성 가능';
        const current = this.collectionBlockedStage(collection);
        if (current.key === 'gate') return this.collectionFinalStatusLabel(collection);
        return current.status === 'processing' ? `${current.label} 진행 중` : `${current.label}에서 막힘`;
    }

    public collectionDecisionSub(collection: any) {
        if (this.collectionProjectionNeedsRefresh(collection)) return '상태 재계산 후 점검을 다시 확인하세요.';
        if (this.collectionReadyForQaAuthoring(collection)) return '준비 완료. QA 작성으로 이동할 수 있습니다.';
        const current = this.collectionBlockedStage(collection);
        if (current.key === 'source') return '원본 확보 후 텍스트 단계로 넘어갑니다.';
        if (current.key === 'text') return '텍스트 완료 후 근거 준비로 넘어갑니다.';
        if (current.key === 'evidence') return '근거 준비 후 점검을 확인합니다.';
        return this.collectionH2GateReason(collection);
    }

    public collectionDecisionClass(collection: any) {
        const status = this.collectionFinalStatus(collection);
        if (this.collectionProjectionNeedsRefresh(collection)) return 'border-amber-200 bg-amber-50 text-amber-800';
        if (status === 'usable') return 'border-emerald-200 bg-emerald-50 text-emerald-800';
        if (status === 'attention') return 'border-rose-200 bg-rose-50 text-rose-800';
        return 'border-amber-200 bg-amber-50 text-amber-800';
    }

    public collectionStageItemClass(item: any) {
        if (item?.current && item?.status === 'attention') return 'border-rose-200 bg-rose-50';
        if (item?.current && item?.status === 'processing') return 'border-amber-200 bg-amber-50';
        if (item?.status === 'usable') return 'border-emerald-100 bg-white';
        return 'border-gray-200 bg-gray-50/70';
    }

    public collectionInlineMetrics(collection: any) {
        return [
            { label: '원본 확보', value: this.collectionDocumentCount(collection) },
            { label: '근거 준비', value: this.collectionEvidenceReadyDocumentCount(collection) },
            { label: '처리 중', value: collection?.qa_processing_count || 0 },
            { label: '점검 필요', value: Number(collection?.qa_attention_count || 0) + Number(collection?.qa_unavailable_count || 0) },
        ];
    }

    public collectionCompactMetrics(collection: any) {
        return [
            {
                label: '점검 상태',
                value: this.collectionReviewRequiredCount(collection),
                unit: '건',
                sub: this.collectionH2GateReason(collection),
                status: this.collectionH2GateStatus(collection),
            },
            {
                label: '원본 확보',
                value: this.collectionDocumentCount(collection),
                unit: '건',
                sub: this.collectionSourceSummary(collection),
                status: this.collectionSourceStatus(collection),
            },
            {
                label: '텍스트 완료',
                value: this.collectionTextReadyCount(collection),
                unit: '건',
                sub: this.collectionRecognitionSubLabel(collection),
                status: this.collectionRecognitionStatus(collection),
            },
            {
                label: '근거 준비',
                value: this.collectionEvidenceReadyDocumentCount(collection),
                unit: '건',
                sub: this.collectionEvidenceSubLabel(collection),
                status: this.collectionEvidenceStatus(collection),
            },
        ];
    }

    public collectionPurposeReady(collection: any) {
        return !!this.collectionPurpose(collection);
    }

    public collectionSourceSummary(collection: any) {
        const total = this.collectionDocumentCount(collection);
        const original = this.collectionOriginalRegisteredCount(collection);
        if (this.collectionProjectionNeedsRefresh(collection)) {
            if (total <= 0 && this.collectionReferenceCount(collection) > 0) {
                return `처리 기준 ${this.number(this.collectionReferenceCount(collection))}건 임시 표시`;
            }
            return `처리 기준 ${this.number(total)}건 임시 표시 · 처리 상태 재계산 필요`;
        }
        if (total <= 0) return '원본 없음';
        return original > 0 ? `원본 ${this.number(original)}건` : '원본 없음';
    }

    public collectionSourceStatus(collection: any) {
        const total = this.collectionDocumentCount(collection);
        if (this.collectionProjectionNeedsRefresh(collection)) return 'processing';
        if (total <= 0) return 'unavailable';
        if (this.collectionReviewRequiredCount(collection) > 0) return 'attention';
        if (this.collectionProcessingCount(collection) > 0) return 'processing';
        return 'usable';
    }

    public collectionRecognitionStatus(collection: any) {
        const total = this.collectionDocumentCount(collection);
        const ready = this.collectionTextReadyCount(collection);
        if (this.collectionProjectionNeedsRefresh(collection)) return 'processing';
        if (total <= 0) return 'unavailable';
        if (ready <= 0) return this.collectionProcessingCount(collection) > 0 ? 'processing' : 'attention';
        if (this.collectionAttentionCount(collection) > 0) return 'attention';
        if (ready < total || this.collectionProcessingCount(collection) > 0) return 'processing';
        return 'usable';
    }

    public collectionEvidenceStatus(collection: any) {
        const total = this.collectionDocumentCount(collection);
        const evidence = this.collectionEvidenceReadyDocumentCount(collection);
        if (this.collectionProjectionNeedsRefresh(collection)) return 'processing';
        if (total <= 0) return 'unavailable';
        if (evidence <= 0) return this.collectionProcessingCount(collection) > 0 ? 'processing' : 'attention';
        if (this.collectionReviewRequiredCount(collection) > 0) return 'attention';
        if (evidence < total || this.collectionProcessingCount(collection) > 0) return 'processing';
        return 'usable';
    }

    public collectionReviewStatus(collection: any) {
        if (this.collectionProjectionNeedsRefresh(collection)) return 'processing';
        if (this.collectionReviewRequiredCount(collection) > 0) return 'attention';
        if (this.collectionProcessingCount(collection) > 0) return 'processing';
        return this.collectionDocumentCount(collection) > 0 ? 'usable' : 'unavailable';
    }

    public collectionRecognitionSubLabel(collection: any) {
        const total = this.collectionDocumentCount(collection);
        if (this.collectionProjectionNeedsRefresh(collection)) return '처리 기준 임시 표시';
        if (total <= 0) return '원본 없음';
        const ready = this.collectionTextReadyCount(collection);
        if (ready <= 0) return '텍스트 처리 중';
        if (this.collectionProcessingCount(collection) > 0) return `처리 중 ${this.number(this.collectionProcessingCount(collection))}건 포함`;
        return `준비 ${this.number(ready)} / ${this.number(total)}건`;
    }

    public collectionEvidenceSubLabel(collection: any) {
        if (this.collectionProjectionNeedsRefresh(collection)) return '처리 상태 갱신 후 정상 표시';
        const ready = this.collectionEvidenceReadyCount(collection);
        return ready > 0 ? `근거 ${this.number(ready)}건` : '근거 준비 중';
    }

    public collectionReviewSubLabel(collection: any) {
        if (this.collectionProjectionNeedsRefresh(collection)) return '운영 상태 확인';
        if (collection?.h2_gate_reason || collection?.qa_h2_gate_reason) return this.collectionH2GateReason(collection);
        const attention = this.collectionAttentionCount(collection);
        const unavailable = this.collectionUnavailableCount(collection);
        const processing = this.collectionProcessingCount(collection);
        if (attention + unavailable > 0) return `점검 ${this.number(attention)} · 준비 필요 ${this.number(unavailable)}`;
        if (processing > 0) return `처리 중 ${this.number(processing)}`;
        return this.collectionDocumentCount(collection) > 0 ? '준비 완료' : '원본 확보 후 확인';
    }

    public collectionReadinessSubLabel(collection: any) {
        const total = this.collectionDocumentCount(collection);
        const usable = this.collectionEvidenceReadyDocumentCount(collection);
        if (this.collectionDeletionRequested(collection)) return '폐기 요청 상태';
        if (this.collectionProjectionNeedsRefresh(collection)) return `처리 기준 ${this.number(total || this.collectionReferenceCount(collection))}건 임시 표시`;
        if (this.collectionH2GateStatus(collection) !== 'usable') return this.collectionH2GateReason(collection);
        if (total <= 0) return '원본 없음';
        return `준비 완료 · 근거 ${this.number(usable)} / ${this.number(total)}건`;
    }

    public collectionFinalStatus(collection: any) {
        return this.collectionH2GateStatus(collection);
    }

    public collectionFinalStatusLabel(collection: any) {
        return this.collectionH2GateLabel(collection);
    }

    public collectionFinalStatusBadgeClass(collection: any) {
        const status = this.collectionFinalStatus(collection);
        if (status === 'usable') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (status === 'attention') return 'border-rose-200 bg-rose-50 text-rose-700';
        return 'border-amber-200 bg-amber-50 text-amber-700';
    }

    public collectionReadinessGapItems(collection: any) {
        const declared = collection?.h2_gate_reasons || collection?.qa_h2_gate_reasons;
        if (Array.isArray(declared) && declared.length > 0) {
            return declared.map((item: any) => String(item || '').trim()).filter((item: string) => item);
        }
        const gaps: string[] = [];
        const total = this.collectionDocumentCount(collection);
        const textReady = this.collectionTextReadyCount(collection);
        const evidenceReady = this.collectionEvidenceReadyDocumentCount(collection);
        const review = this.collectionReviewRequiredCount(collection);
        const processing = this.collectionProcessingCount(collection);

        if (this.collectionProjectionNeedsRefresh(collection)) {
            gaps.push(this.collectionProjectionLabel(collection));
            gaps.push('처리 기준 임시 표시');
            return gaps;
        }
        if (this.collectionDeletionRequested(collection)) gaps.push('폐기 요청 상태');
        if (total <= 0) {
            gaps.push('원본 확보 필요');
        } else {
            if (textReady < total) gaps.push(`텍스트 ${this.number(total - textReady)}건 부족`);
            if (evidenceReady < total) gaps.push(`근거 ${this.number(total - evidenceReady)}건 부족`);
        }
        if (review > 0) gaps.push(`점검 ${this.number(review)}건`);
        if (processing > 0 && gaps.length === 0) gaps.push(`처리 중 ${this.number(processing)}건`);
        return gaps;
    }

    public collectionReadyForQaAuthoring(collection: any) {
        if (this.collectionProjectionNeedsRefresh(collection)) return false;
        return this.collectionFinalStatus(collection) === 'usable';
    }

    public collectionHeaderBadges(collection: any) {
        return [{
            label: this.collectionFinalStatusLabel(collection),
            status: this.collectionFinalStatus(collection),
        }];
    }

    public collectionFlowItems(collection: any) {
        return this.collectionCardStageItems(collection);
    }

    public collectionTechnicalDiagnosticItems(collection: any) {
        const total = this.collectionDocumentCount(collection);
        const review = this.collectionReviewRequiredCount(collection);
        return [
            {
                label: '원본 자료 진단',
                value: `${this.number(total)} / ${this.number(this.collectionOriginalRegisteredCount(collection))}건`,
                sub: `doc ${this.number(total)} · file ${this.number(this.collectionOriginalRegisteredCount(collection))}`,
            },
            {
                label: '텍스트 자료',
                value: `${this.number(this.collectionTextReadyCount(collection))}건`,
                sub: `text_ready ${this.number(this.collectionTextReadyCount(collection))} / ${this.number(total)}`,
            },
            {
                label: '근거 자료 진단',
                value: `${this.number(collection?.qa_vector_total || 0)}개`,
                sub: `chunk ${this.number(this.collectionEvidenceReadyCount(collection))} · vec ${this.number(collection?.qa_vector_total || 0)}`,
            },
            {
                label: '점검 진단',
                value: `${this.number(review)}건`,
                sub: review > 0 ? this.collectionH2GateReason(collection) : '오류/누락 없음',
            },
        ];
    }

    public async openProjectionDiagnostic() {
        this.showProjectionDiagnostic = true;
        await this.loadProjectionDiagnostic(false);
    }

    public async closeProjectionDiagnostic() {
        this.showProjectionDiagnostic = false;
        this.projectionDiagnosticError = '';
        await this.service.render();
    }

    public async refreshProjectionDiagnostic() {
        await this.loadProjectionDiagnostic(true);
    }

    public async loadProjectionDiagnostic(refresh: boolean = false) {
        if (this.projectionDiagnosticLoading) return;
        this.projectionDiagnosticLoading = true;
        this.projectionDiagnosticError = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call("projection_diagnostic_report", {
                refresh: refresh ? '1' : '',
            });
            if (code === 200) {
                this.projectionDiagnostic = data?.report || { summary: {}, rows: [] };
            } else {
                this.projectionDiagnosticError = data?.message || '처리 상태 운영점검 리포트를 불러오지 못했습니다.';
            }
        } catch (error: any) {
            this.projectionDiagnosticError = error?.message || '처리 상태 운영점검 리포트를 불러오지 못했습니다.';
        } finally {
            this.projectionDiagnosticLoading = false;
            await this.service.render();
        }
    }

    public projectionDiagnosticRows() {
        return this.projectionDiagnostic?.rows || [];
    }

    public projectionDiagnosticSummaryCards() {
        const summary = this.projectionDiagnostic?.summary || {};
        return [
            {
                label: '보관 파일',
                value: summary.filesystem_total || 0,
                sub: `원본 확보 상태 차이 ${this.signedNumber(summary.fs_db_file_delta || 0)}`,
            },
            {
                label: '원본 자료',
                value: summary.filesystem_source_file_count || 0,
                sub: `원본 확보 차이 ${this.signedNumber(summary.fs_db_source_delta || 0)}`,
            },
            {
                label: '원본 확보 상태',
                value: summary.db_file_count || 0,
                sub: `원본 ${this.number(summary.db_source_file_count || 0)} · 텍스트 ${this.number(summary.db_ocr_file_count || 0)}`,
            },
            {
                label: '점검 상태',
                value: summary.lit_catalog_registered_count || 0,
                sub: `자료 상태 차이 ${this.signedNumber(summary.catalog_bundle_delta || 0)}`,
            },
        ];
    }

    public projectionDiagnosticIssueCount(row: any) {
        return (row?.issues || []).length;
    }

    public projectionDiagnosticStatusLabel(row: any) {
        return this.projectionDiagnosticIssueCount(row) > 0 ? '차이 확인' : '일치';
    }

    public projectionDiagnosticStatusClass(row: any) {
        return this.projectionDiagnosticIssueCount(row) > 0
            ? 'border-amber-200 bg-amber-50 text-amber-700'
            : 'border-emerald-200 bg-emerald-50 text-emerald-700';
    }

    public projectionDeltaClass(value: any) {
        return Number(value || 0) === 0 ? 'text-emerald-700' : 'text-amber-700';
    }

    public signedNumber(value: any) {
        const numeric = Number(value || 0);
        if (numeric > 0) return `+${numeric.toLocaleString()}`;
        return numeric.toLocaleString();
    }


    public collectionStatusDotClass(status: string) {
        if (status === 'usable') return 'bg-emerald-500';
        if (status === 'partial') return 'bg-sky-500';
        if (status === 'processing') return 'bg-amber-500';
        if (status === 'attention') return 'bg-rose-500';
        return 'bg-gray-400';
    }

    public collectionSoftStatusClass(status: string) {
        if (status === 'usable') return 'bg-emerald-50 text-emerald-700';
        if (status === 'partial') return 'bg-sky-50 text-sky-700';
        if (status === 'processing') return 'bg-amber-50 text-amber-700';
        if (status === 'attention') return 'bg-rose-50 text-rose-700';
        return 'bg-gray-100 text-gray-600';
    }

    public collectionStatusTextClass(status: string) {
        if (status === 'usable') return 'text-emerald-700';
        if (status === 'partial') return 'text-sky-700';
        if (status === 'processing') return 'text-amber-700';
        if (status === 'attention') return 'text-rose-700';
        return 'text-gray-500';
    }

    public collectionMetricCardClass(status: string) {
        if (status === 'usable') return 'border-emerald-100 bg-emerald-50/60';
        if (status === 'partial') return 'border-sky-100 bg-sky-50/60';
        if (status === 'processing') return 'border-amber-100 bg-amber-50/60';
        if (status === 'attention') return 'border-rose-100 bg-rose-50/60';
        return 'border-gray-100 bg-gray-50';
    }

    public collectionBlockerStatus(collection: any) {
        if (this.collectionAttentionCount(collection) > 0) return 'attention';
        if (this.collectionProcessingCount(collection) > 0) return 'processing';
        if (this.collectionUnavailableCount(collection) > 0) return 'unavailable';
        if (this.collectionEvidenceReadyDocumentCount(collection) > 0) return 'usable';
        return 'unavailable';
    }

    public collectionBlockerLabel(collection: any) {
        const attention = this.collectionAttentionCount(collection);
        const processing = this.collectionProcessingCount(collection);
        const unavailable = this.collectionUnavailableCount(collection);
        const usable = this.collectionEvidenceReadyDocumentCount(collection);
        if (attention > 0) return `확인 필요 ${this.number(attention)}건`;
        if (processing > 0) return `처리 중 ${this.number(processing)}건`;
        if (unavailable > 0) return `자료 준비 필요 ${this.number(unavailable)}건`;
        if (usable > 0) return '막힘 없음';
        return '자료 등록 필요';
    }

    public collectionQaAvailable(collection: any) {
        if (this.collectionDeletionRequested(collection)) return false;
        return this.collectionEvidenceReadyDocumentCount(collection) > 0;
    }

    public collectionQaAvailabilityStatus(collection: any) {
        if (this.collectionDeletionRequested(collection)) return 'processing';
        const status = String(collection?.qa_status || '').trim();
        if (['usable', 'partial', 'processing', 'attention'].includes(status)) return status;
        if (this.collectionQaAvailable(collection)) return 'usable';
        return 'processing';
    }

    public collectionQaAvailabilityLabel(collection: any) {
        return this.collectionReadinessLabel(collection);
    }

    public collectionReadinessLabel(collection: any) {
        if (this.collectionDeletionRequested(collection)) return '폐기 요청됨';
        return this.collectionFinalStatusLabel(collection);
    }

    public collectionReadinessSummary(collection: any) {
        const total = this.collectionDocumentCount(collection);
        const usable = this.collectionEvidenceReadyDocumentCount(collection);
        const status = this.collectionFinalStatus(collection);
        if (this.collectionDeletionRequested(collection)) return '폐기 요청 상태';
        if (this.collectionProjectionNeedsRefresh(collection)) return this.collectionProjectionMessage(collection);
        if (status === 'usable') return `QA 작성 가능 ${this.number(usable)} / ${this.number(total)}건`;
        const gaps = this.collectionReadinessGapItems(collection);
        return gaps.length ? gaps.slice(0, 2).join(' · ') : '자료 처리 중';
    }

    public collectionImmediateDeleteAvailable(collection: any) {
        if (this.collectionDeletionRequested(collection)) return false;
        const qaTotal = Number(collection?.qa_usable_count || 0)
            + Number(collection?.qa_processing_count || 0)
            + Number(collection?.qa_attention_count || 0)
            + Number(collection?.qa_unavailable_count || 0);
        return this.collectionDocumentCount(collection) <= 0
            && Number(collection?.file_count || 0) <= 0
            && qaTotal <= 0;
    }

    public collectionDeleteActionLabel(collection: any) {
        if (this.collectionDeletionRequested(collection)) return '요청 취소';
        if (this.collectionImmediateDeleteAvailable(collection)) return '삭제';
        return '폐기 요청';
    }

    public collectionDeleteActionClass(collection: any) {
        if (this.collectionDeletionRequested(collection)) return 'border-gray-300 text-gray-700 hover:bg-gray-50';
        return 'border-rose-200 text-rose-700 hover:bg-rose-50';
    }

    public collectionEvidenceLabel(collection: any) {
        return `텍스트 자료 ${this.number(this.collectionTextReadyCount(collection))}건 · 근거 자료 ${this.number(this.collectionEvidenceReadyDocumentCount(collection))}건 · QA 작성용 근거 ${this.number(this.collectionEvidenceReadyCount(collection))}건`;
    }

    public get filteredFolders() {
        const text = this.fileQuery.trim().toLowerCase();
        if (!text) return this.folders;
        return this.folders.filter((folder: any) => this.matches(folder, text, ['name', 'path', 'id']));
    }

    public get visibleFolders() {
        return this.filteredFolders.slice(0, this.driveVisibleLimit);
    }

    public folderPath(folder: any) {
        return this.normalizeDrivePath(folder?.path || folder?.id || '');
    }

    public bundleDeletePaths(bundle: any) {
        const seen: any = {};
        const paths: string[] = [];
        for (const file of bundle?.files || []) {
            if (file?.virtual) continue;
            const path = this.normalizeDrivePath(file?.path || '');
            if (!path || seen[path]) continue;
            seen[path] = true;
            paths.push(path);
        }
        return paths;
    }

    public bundleDeleteKey(bundle: any) {
        const direct = String(bundle?.bundle_id || bundle?.bundle_key || bundle?.key || '').trim();
        if (direct) return direct;
        return this.bundleDeletePaths(bundle).join('|');
    }

    public bundleDeleteDisabled(bundle: any) {
        const key = this.bundleDeleteKey(bundle);
        return this.uploading
            || this.driveLoading
            || this.collectionDeletionRequested(this.current)
            || this.bundleDeletePaths(bundle).length <= 0
            || (!!this.bundleDeletingKey && this.bundleDeletingKey !== key)
            || this.bundleDeletingKey === key;
    }

    public cookieValue(name: string) {
        const prefix = `${name}=`;
        const cookies = String(document.cookie || '').split(';');
        for (const item of cookies) {
            const cookie = item.trim();
            if (cookie.indexOf(prefix) === 0) return cookie.substring(prefix.length);
        }
        return '';
    }

    public setWizDevModeCookie(value: any) {
        const enabled = value === true || String(value || '').toLowerCase() === 'true';
        document.cookie = `season-wiz-devmode=${enabled ? 'true' : 'false'}; path=/; SameSite=Lax`;
    }

    public apiErrorMessage(response: any, fallback: string) {
        if (response?.data?.message) return response.data.message;
        if (response?.message) return response.message;
        if (response?.responseJSON?.data?.message) return response.responseJSON.data.message;
        if (response?.responseJSON?.message) return response.responseJSON.message;
        const responseText = String(response?.responseText || '').trim();
        if (responseText) {
            try {
                const parsed = JSON.parse(responseText);
                if (parsed?.data?.message) return parsed.data.message;
                if (parsed?.message) return parsed.message;
            } catch (error) {
                if (responseText.indexOf('<') < 0) return responseText.slice(0, 180);
            }
        }
        return fallback;
    }

    public filesMatchingQuery() {
        const text = this.fileQuery.trim().toLowerCase();
        if (!text) return this.files;
        return this.files.filter((file: any) => this.matches(file, text, [
            'name', 'path', 'extension', 'file_role', 'parse_status',
            'document_title', 'metadata_title', 'artifact_status',
            'ocr_status', 'embedding_status', 'vector_status', 'quality_status',
            'source_mode', 'source_mode_label',
        ]));
    }

    public get filteredBundles() {
        return this.allBundles()
            .filter((bundle: any) => this.isPrimaryBundle(bundle))
            .filter((bundle: any) => this.bundleMatchesQuery(bundle))
            .filter((bundle: any) => this.bundleMatchesType(bundle, this.fileTypeFilter))
            .sort((a: any, b: any) => a.title.localeCompare(b.title));
    }

    public get visibleBundles() {
        return this.filteredBundles.slice(0, this.driveSecondaryVisibleLimit());
    }

    public get driveTotalItems() {
        return this.filteredFolders.length + this.filteredBundles.length;
    }

    public get hasMoreDriveItems() {
        return this.driveVisibleLimit < this.driveTotalItems;
    }

    public driveSecondaryVisibleLimit() {
        return Math.max(0, this.driveVisibleLimit - this.filteredFolders.length);
    }

    public resetDriveItemWindow() {
        this.driveVisibleLimit = this.driveInitialVisibleLimit;
        this.driveIncrementLoading = false;
        if (this.driveIncrementTimer) {
            clearTimeout(this.driveIncrementTimer);
            this.driveIncrementTimer = null;
        }
    }

    public async setFileQuery(value: any) {
        this.fileQuery = String(value || '');
        this.resetDriveItemWindow();
        await this.service.render();
    }

    public bindDriveScrollContainer() {
        if (this.driveScrollHandler) return;
        this.driveScrollHandler = () => {
            this.loadMoreDriveItemsOnScroll();
        };
        setTimeout(() => {
            if (!this.driveScrollHandler) return;
            const container = this.findDriveScrollContainer();
            this.driveScrollContainer = container;
            if (container === window) {
                window.addEventListener('scroll', this.driveScrollHandler, { passive: true });
            } else if (container?.addEventListener) {
                container.addEventListener('scroll', this.driveScrollHandler, { passive: true });
            }
            window.addEventListener('resize', this.driveScrollHandler, { passive: true });
            this.driveScrollHandler();
        }, 0);
    }

    public unbindDriveScrollContainer() {
        if (!this.driveScrollHandler) return;
        if (this.driveScrollContainer === window) {
            window.removeEventListener('scroll', this.driveScrollHandler);
        } else if (this.driveScrollContainer?.removeEventListener) {
            this.driveScrollContainer.removeEventListener('scroll', this.driveScrollHandler);
        }
        window.removeEventListener('resize', this.driveScrollHandler);
        this.driveScrollContainer = null;
        this.driveScrollHandler = null;
    }

    public findDriveScrollContainer() {
        let node = this.elementRef?.nativeElement?.parentElement || null;
        while (node && node !== document.body) {
            const style = window.getComputedStyle(node);
            const overflowY = `${style.overflowY || style.overflow || ''}`.toLowerCase();
            if (overflowY.indexOf('auto') >= 0 || overflowY.indexOf('scroll') >= 0) {
                return node;
            }
            node = node.parentElement;
        }
        return window;
    }

    public driveScrollMetrics() {
        const container = this.driveScrollContainer || this.findDriveScrollContainer();
        if (container && container !== window) {
            return {
                scrollTop: Number(container.scrollTop || 0),
                viewportHeight: Number(container.clientHeight || 0),
                scrollHeight: Number(container.scrollHeight || 0),
            };
        }
        const doc = document.documentElement;
        const body = document.body;
        return {
            scrollTop: window.pageYOffset || doc.scrollTop || body.scrollTop || 0,
            viewportHeight: window.innerHeight || doc.clientHeight || 0,
            scrollHeight: Math.max(
                body.scrollHeight,
                doc.scrollHeight,
                body.offsetHeight,
                doc.offsetHeight,
                body.clientHeight,
                doc.clientHeight,
            ),
        };
    }

    public async loadMoreDriveItemsOnScroll() {
        if (this.loading || this.driveLoading || this.driveIncrementLoading) return;
        if (!this.current || !this.exists || !this.hasMoreDriveItems) return;
        const { scrollTop, viewportHeight, scrollHeight } = this.driveScrollMetrics();
        if (scrollTop + viewportHeight < scrollHeight - 160) return;

        this.driveIncrementLoading = true;
        await this.service.render();
        this.driveIncrementTimer = setTimeout(async () => {
            this.driveVisibleLimit = Math.min(this.driveVisibleLimit + this.drivePageSize, this.driveTotalItems);
            this.driveIncrementLoading = false;
            this.driveIncrementTimer = null;
            await this.service.render();
        }, 260);
    }

    public isPrimaryBundle(bundle: any) {
        if (Number(bundle?.source?.length || 0) > 0) return true;
        if (this.bundleDocumentId(bundle)) return true;
        const files = bundle?.files || [];
        return files.some((file: any) => {
            const meta = this.classifyFile(file);
            const ext = String(file?.extension || '').toLowerCase();
            const technical = ['metadata', 'ocr', 'embedding', 'vector', 'status', 'ocr_status', 'embedding_status', 'vector_status'].includes(meta.role);
            return !technical && ext !== 'json';
        });
    }

    public allBundles() {
        if ((this.bundles || []).length > 0) {
            return this.bundles.map((bundle: any) => this.prepareBundle({ ...bundle }));
        }
        const map: any = {};
        for (const file of this.files) {
            const meta = this.classifyFile(file);
            const key = `${meta.dir}/${meta.base}`;
            if (!map[key]) {
                map[key] = {
                    key,
                    title: meta.base,
                    dir: meta.dir,
                    source: [],
                    metadata: [],
                    ocr: [],
                    embedding: [],
                    vector: [],
                    status: [],
                    ocr_status: [],
                    embedding_status: [],
                    vector_status: [],
                    other: [],
                    files: [],
                    slots: [],
                    source_mode: '',
                    source_mode_label: '',
                };
            }
            const role = map[key][meta.role] ? meta.role : 'other';
            map[key][role].push(file);
            if (role === 'metadata' && file?.metadata_title) {
                map[key].metadata_title = file.metadata_title;
            }
            if (['ocr_status', 'embedding_status', 'vector_status'].includes(role)) {
                map[key].status.push(file);
            }
            if (!map[key].source_mode && file?.source_mode) {
                map[key].source_mode = file.source_mode;
                map[key].source_mode_label = file.source_mode_label || this.sourceModeLabel(file.source_mode);
            }
            map[key].files.push(file);
        }

        return Object.values(map).map((bundle: any) => this.prepareBundle(bundle));
    }

    public prepareBundle(bundle: any) {
        for (const key of ['source', 'metadata', 'ocr', 'embedding', 'vector', 'status', 'ocr_status', 'embedding_status', 'vector_status', 'other', 'files']) {
            if (!bundle[key]) bundle[key] = [];
        }
        const statusFiles = this.statusFiles(bundle);
        const registeredSource = (bundle.source || []).find((file: any) => file?.registered);
        if (registeredSource && !bundle.metadata.length) {
            bundle.metadata.push({
                virtual: true,
                name: '자료 정보',
                metadata_title: registeredSource.document_title || bundle.title,
                artifact_status: 'ready',
                parse_status: 'ready',
            });
        }
        if (!bundle.source_mode) {
            const source = (bundle.source || []).find((file: any) => file?.source_mode);
            bundle.source_mode = source?.source_mode || (registeredSource ? 'migrated_2025' : '');
            bundle.source_mode_label = source?.source_mode_label || this.sourceModeLabel(bundle.source_mode);
        }
        bundle.slots = [
            { key: 'source', label: '원본 자료', files: bundle.source, required: true },
            { key: 'metadata', label: '자료 정보', files: bundle.metadata, required: true },
            { key: 'ocr', label: '텍스트 자료', files: bundle.ocr, required: false },
            { key: 'embedding', label: '근거 자료', files: bundle.embedding, required: false },
            { key: 'vector', label: '근거 자료', files: bundle.vector, required: false },
            { key: 'status', label: '점검 상태', files: statusFiles, required: false },
        ];
        bundle.missing = bundle.slots.filter((slot: any) => slot.required && slot.files.length === 0).length;
        bundle.ocr_page_count = this.bundleCountValue(bundle, 'ocr_page_count');
        bundle.embedding_chunk_count = this.bundleCountValue(bundle, 'embedding_chunk_count');
        bundle.vector_count = this.bundleCountValue(bundle, 'vector_count');
        bundle.vector_inserted_count = this.bundleCountValue(bundle, 'vector_inserted_count');
        bundle.evidence_count = this.bundleCountValue(bundle, 'evidence_count');
        bundle.eligible_evidence_count = this.bundleCountValue(bundle, 'eligible_evidence_count');
        bundle.qa_status = bundle.qa_status || this.bundleQaStatus(bundle);
        bundle.qa_reason = bundle.qa_reason || this.bundleQaReason(bundle);
        return bundle;
    }

    public bundleMatchesQuery(bundle: any) {
        const text = this.fileQuery.trim().toLowerCase();
        if (!text) return true;
        if (this.matches(bundle, text, ['title', 'dir', 'metadata_title', 'qa_status', 'qa_reason', 'source_mode', 'source_mode_label'])) return true;
        return (bundle?.files || []).some((file: any) => this.matches(file, text, [
            'name', 'path', 'extension', 'file_role', 'parse_status',
            'document_title', 'metadata_title', 'artifact_status',
            'ocr_status', 'embedding_status', 'vector_status', 'quality_status',
            'source_mode', 'source_mode_label',
        ]));
    }

    public bundleMatchesType(bundle: any, key: string) {
        if (!key || key === 'all') return true;
        if (key === 'source') return Number(bundle?.source?.length || 0) > 0;
        if (key === 'metadata') return Number(bundle?.metadata?.length || 0) > 0;
        if (key === 'ocr') return Number(bundle?.ocr?.length || 0) > 0;
        if (key === 'embedding') return Number(bundle?.embedding?.length || 0) > 0;
        if (key === 'vector') return Number(bundle?.vector?.length || 0) > 0 || Number(bundle?.vector_status?.length || 0) > 0;
        if (key === 'status') return this.statusFiles(bundle).length > 0;
        if (key === 'unregistered') return this.bundleUnregisteredSourceCount(bundle) > 0;
        if (key === 'error') return this.bundleErrorCount(bundle) > 0 || this.bundleQaStatus(bundle) === 'attention';
        return true;
    }

    public bundleMax(bundle: any, key: string) {
        const values = (bundle?.files || []).map((file: any) => Number(file?.[key] !== undefined ? file?.[key] : (file?.artifact_summary?.[key] || 0)));
        return values.length ? Math.max(...values, 0) : 0;
    }

    public bundleCountValue(bundle: any, key: string) {
        const dbValues = (bundle?.files || [])
            .filter((file: any) => file?.document_id && file?.[key] !== undefined && file?.[key] !== null && file?.[key] !== '')
            .map((file: any) => Number(file?.[key] || 0));
        if (dbValues.length) return Math.max(...dbValues, 0);
        const direct = Number(bundle?.[key] || 0);
        const fallback = this.bundleMax(bundle, key);
        return Math.max(Number.isFinite(direct) ? direct : 0, fallback);
    }

    public bundleStatusValues(bundle: any, key: string = '') {
        const values: string[] = [];
        for (const file of bundle?.files || []) {
            values.push(...this.fileStatusValues(file));
        }
        if (key) {
            for (const file of bundle?.[key] || []) {
                values.push(String(file?.artifact_status || '').toLowerCase());
            }
            const statusKey = key === 'ocr' ? 'ocr_status' : (key === 'embedding' ? 'embedding_status' : (key === 'vector' ? 'vector_status' : ''));
            if (statusKey) {
                values.push(...(bundle?.[statusKey] || []).map((file: any) => String(file?.artifact_status || '').toLowerCase()));
            }
        }
        return values.filter((value: string) => value);
    }

    public hasWorkingStatus(bundle: any, key: string = '') {
        return this.bundleStatusValues(bundle, key).some((status: string) => ['pending', 'queued', 'running', 'working', 'processing'].includes(status));
    }

    public bundleQaStatus(bundle: any) {
        if (bundle?.bundle_status) return bundle.bundle_status;
        if (this.bundleErrorCount(bundle) > 0) return 'attention';
        if (Number(bundle?.source?.length || 0) <= 0) return 'unavailable';
        if (!this.bundleDocumentId(bundle)) return 'unavailable';
        if (Number(bundle?.metadata?.length || 0) <= 0) return 'unavailable';
        if (Number(bundle?.ocr_page_count || 0) <= 0) return 'processing';
        if (Number(bundle?.embedding_chunk_count || 0) <= 0) return 'processing';
        if (Number(bundle?.vector_inserted_count || 0) <= 0) return 'processing';
        if (Number(bundle?.eligible_evidence_count || bundle?.evidence_count || 0) <= 0) return 'processing';
        return 'usable';
    }

    public bundleQaReason(bundle: any) {
        if (bundle?.review_required) return '오류/누락 확인';
        if (bundle?.qa_evidence_ready) return '준비 완료';
        if (bundle?.text_ready) return '근거 준비 필요';
        if (bundle?.original_registered) return '텍스트 완료 필요';
        if (this.bundleErrorCount(bundle) > 0) return '오류/누락 확인';
        if (Number(bundle?.source?.length || 0) <= 0) return '원본 자료 확보 필요';
        if (!this.bundleDocumentId(bundle)) return '원본 확보 상태 확인 필요';
        if (Number(bundle?.metadata?.length || 0) <= 0) return '원본 확보 상태 확인 필요';
        if (Number(bundle?.ocr_page_count || 0) <= 0) return '텍스트 완료 필요';
        if (Number(bundle?.embedding_chunk_count || 0) <= 0) return '근거 준비 필요';
        if (Number(bundle?.vector_inserted_count || 0) <= 0) return '근거 준비 필요';
        if (Number(bundle?.eligible_evidence_count || bundle?.evidence_count || 0) <= 0) return '근거 준비 필요';
        return '준비 완료';
    }

    public bundleDocumentId(bundle: any) {
        const file = (bundle?.files || []).find((item: any) => String(item?.document_id || '').trim());
        return file?.document_id || '';
    }

    public bundlePreviewDocumentId(bundle: any, key: string = '') {
        if (String(bundle?.document_id || '').trim()) return bundle.document_id;
        const files = (bundle?.files || []).filter((item: any) => String(item?.document_id || '').trim());
        if (!files.length) return bundle?.document_id || '';
        const score = (file: any) => {
            const role = String(file?.file_role || file?.role || '').toLowerCase();
            let value = 0;
            if (key === 'text') {
                if (['ocr', 'ocr_page'].includes(role)) value += 100;
                if (role === 'ocr_status') value += 60;
                if (Number(file?.ocr_page_count || file?.page_count || 0) > 0) value += 80;
            } else if (key === 'qa_evidence') {
                if (['embedding', 'chunk', 'vector', 'vector_index'].includes(role)) value += 100;
                if (['embedding_status', 'vector_status'].includes(role)) value += 60;
                if (Number(file?.embedding_chunk_count || file?.chunk_count || 0) > 0) value += 80;
            }
            if (file?.registered) value += 10;
            return value;
        };
        const sorted = [...files].sort((a: any, b: any) => score(b) - score(a));
        return sorted[0]?.document_id || bundle?.document_id || this.bundleDocumentId(bundle);
    }

    public bundlePreviewPaths(bundle: any, key: string = '') {
        const roles = key === 'text'
            ? ['ocr', 'ocr_page', 'ocr_status', 'source', 'original']
            : ['embedding', 'chunk', 'vector', 'vector_index', 'embedding_status', 'vector_status'];
        const paths = (bundle?.files || [])
            .filter((file: any) => {
                const role = String(file?.file_role || file?.role || '').toLowerCase();
                return !key || roles.includes(role);
            })
            .map((file: any) => file?.path || file?.relative_path || file?.name || '')
            .filter((value: any) => String(value || '').trim());
        return Array.from(new Set(paths));
    }

    public bundleQaStatusLabel(bundle: any) {
        switch (bundle?.qa_status || this.bundleQaStatus(bundle)) {
            case 'usable':
                return 'QA 작성 가능';
            case 'partial':
                return '자료 처리 중';
            case 'processing':
                return '자료 처리 중';
            case 'unavailable':
                return '점검 필요';
            default:
                return '점검 필요';
        }
    }

    public bundleProcessingStatus(bundle: any) {
        if (bundle?.bundle_status) return bundle.bundle_status;
        if (this.bundleErrorCount(bundle) > 0) return 'attention';
        if (Number(bundle?.source?.length || 0) <= 0) return 'unavailable';
        if (!this.bundleDocumentId(bundle) || Number(bundle?.metadata?.length || 0) <= 0) return 'pending';
        const statuses = ['ocr', 'chunk', 'vector', 'evidence'].map((key: string) => this.bundleStageStatus(bundle, key));
        if (statuses.includes('processing')) return 'processing';
        if (statuses.every((status: string) => status === 'usable')) return 'usable';
        return 'attention';
    }

    public bundleProcessingStatusLabel(bundle: any) {
        switch (this.bundleProcessingStatus(bundle)) {
            case 'usable':
                return 'QA 작성 가능';
            case 'processing':
                return '자료 처리 중';
            case 'pending':
                return '자료 처리 중';
            case 'unavailable':
                return '자료 처리 중';
            default:
                return '점검 필요';
        }
    }

    public bundleProcessingStatusClass(bundle: any) {
        return this.statusClass(this.bundleProcessingStatus(bundle));
    }

    public readinessStepClass(status: string) {
        if (status === 'usable') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (status === 'processing') return 'border-amber-200 bg-amber-50 text-amber-700';
        if (status === 'unavailable') return 'border-gray-200 bg-gray-50 text-gray-600';
        return 'border-rose-200 bg-rose-50 text-rose-700';
    }

    public get healthCards() {
        return this.health?.cards || [];
    }

    public get queueItems() {
        return this.health?.queue || [];
    }

    public get pipelineItems() {
        return this.health?.pipeline || [];
    }

    public get healthSummary() {
        return this.health?.summary || {};
    }

    public get readinessSummary() {
        return this.readiness?.summary || {};
    }

    public get readinessCards() {
        const summary = this.readinessSummary;
        return [
            { key: 'usable', label: 'QA 작성 가능', value: summary.usable_count || 0, status: 'usable' },
            { key: 'processing', label: '자료 처리 중', value: summary.processing_count || 0, status: 'processing' },
            { key: 'attention', label: '점검 필요', value: summary.attention_count || 0, status: 'attention' },
            { key: 'unavailable', label: '점검 필요', value: summary.unavailable_count || 0, status: 'unavailable' },
        ];
    }

    public get readinessArtifactCards() {
        const summary = this.readinessSummary;
        return [
            { label: '텍스트 자료', value: summary.ocr_page_total || 0 },
            { label: '근거 자료', value: summary.eligible_evidence_total || summary.evidence_total || 0 },
            { label: '준비 자료', value: summary.usable_count || 0 },
            { label: '점검 필요', value: summary.attention_count || 0 },
        ];
    }

    public get visibleReadinessDocuments() {
        const rows = this.readiness?.documents || [];
        const text = this.fileQuery.trim().toLowerCase();
        if (!text) return rows;
        return rows.filter((row: any) => this.matches(row, text, [
            'title', 'document_key', 'relative_dir', 'source_type',
            'qa_status', 'qa_reason', 'ocr_status', 'embedding_status', 'vector_status', 'quality_status',
        ]));
    }

    public get localUnregisteredCount() {
        return this.files.filter((file: any) => !file.registered).length;
    }

    public get currentFileStats() {
        const files = this.filesMatchingQuery();
        return {
            source: files.filter((file: any) => this.matchesFileType(file, 'source')).length,
            metadata: files.filter((file: any) => this.matchesFileType(file, 'metadata')).length,
            ocr: files.filter((file: any) => this.matchesFileType(file, 'ocr')).length,
            embedding: files.filter((file: any) => this.matchesFileType(file, 'embedding')).length,
            vector: files.filter((file: any) => this.matchesFileType(file, 'vector')).length,
            status: files.filter((file: any) => this.matchesFileType(file, 'status')).length,
            unregistered: files.filter((file: any) => this.matchesFileType(file, 'unregistered')).length,
            error: files.filter((file: any) => this.matchesFileType(file, 'error')).length,
        };
    }

    public classifyFile(file: any) {
        const filepath = String(file?.path || file?.name || '');
        const parts = filepath.split('/');
        const filename = parts.pop() || String(file?.name || '');
        const dir = parts.join('/');
        const lower = filename.toLowerCase();
        const ext = String(file?.extension || '').toLowerCase();
        const withoutExt = filename.replace(/\.[^/.]+$/, '');
        const role = String(file?.file_role || '').toLowerCase();
        const artifactKind = String(file?.artifact_kind || '').toLowerCase();
        if (artifactKind) {
            return {
                role: artifactKind,
                base: file?.artifact_base || withoutExt,
                dir: file?.artifact_dir || dir,
            };
        }
        const rules = [
            { suffix: '_ocr.status.json', role: 'ocr_status' },
            { suffix: '_embedding.status.json', role: 'embedding_status' },
            { suffix: '_vector.status.json', role: 'vector_status' },
            { suffix: '_ocr.json', role: 'ocr' },
            { suffix: '_embedding.json', role: 'embedding' },
            { suffix: '_vector.json', role: 'vector' },
        ];

        for (const rule of rules) {
            if (lower.endsWith(rule.suffix)) {
                return {
                    role: rule.role,
                    base: filename.slice(0, filename.length - rule.suffix.length) || withoutExt,
                    dir,
                };
            }
        }

        if (lower.endsWith('.status.json')) {
            return { role: 'status', base: filename.slice(0, filename.length - '.status.json'.length) || withoutExt, dir };
        }
        if (role.startsWith('source') || role === 'original' || role === 'original_file') {
            return { role: 'source', base: withoutExt, dir };
        }
        if (role === 'metadata' || role === 'meta') {
            return { role: 'metadata', base: withoutExt, dir };
        }
        if (role === 'ocr' || role === 'ocr_page') {
            return { role: 'ocr', base: withoutExt, dir };
        }
        if (role === 'embedding') {
            return { role: 'embedding', base: withoutExt, dir };
        }
        if (role === 'vector' || role === 'vector_index') {
            return { role: 'vector', base: withoutExt, dir };
        }
        if (role.indexOf('status') >= 0) {
            return { role: 'status', base: withoutExt, dir };
        }
        if (ext === 'json') {
            return { role: 'metadata', base: withoutExt, dir };
        }
        if (['pdf', 'hwp', 'hwpx', 'doc', 'docx', 'txt'].includes(ext)) {
            return { role: 'source', base: withoutExt, dir };
        }
        return { role: 'other', base: withoutExt, dir };
    }

    public slotFileLabel(slot: any) {
        if (!slot?.files?.length) return '없음';
        const first = slot.files[0];
        const extra = slot.files.length > 1 ? ` +${slot.files.length - 1}` : '';
        return `${first.name}${extra}`;
    }

    public slotStatusLabel(slot: any) {
        if (!slot?.files?.length) return slot?.key === 'source' ? '원본 없음' : '미연결';
        if (slot.files.some((file: any) => this.fileHasError(file))) return '오류';
        if (slot.key === 'source') {
            if (slot.files.some((file: any) => !file.registered)) return '자료 정보 생성 전';
            return '처리 완료';
        }
        if (slot.key === 'status') return '상태 연결';
        return '연결됨';
    }

    public statusFiles(bundle: any) {
        const files = [
            ...(bundle?.status || []),
            ...(bundle?.ocr_status || []),
            ...(bundle?.embedding_status || []),
            ...(bundle?.vector_status || []),
        ];
        const map: any = {};
        for (const file of files) {
            map[file?.path || file?.name] = file;
        }
        return Object.values(map);
    }

    public statusFileLabel(bundle: any) {
        const count = this.statusFiles(bundle).length;
        return count > 0 ? `${this.number(count)}개` : '미연결';
    }

    public sourceFiles(bundle: any) {
        return bundle?.source || [];
    }

    public sourceModeLabel(value: string) {
        const mode = String(value || '').trim();
        if (mode === 'new_upload') return '신규 업로드';
        if (mode === 'migrated_2025') return '2025 이관';
        return mode || '2025 이관';
    }

    public bundleSourceModeLabel(bundle: any) {
        return bundle?.source_mode_label || this.sourceModeLabel(bundle?.source_mode || '');
    }

    public bundleTypeLabel(bundle: any) {
        const file = this.sourceFiles(bundle)[0] || this.bundlePrimaryFile(bundle);
        const sourceType = String(bundle?.source_type || file?.source_type || '').trim();
        if (sourceType) return this.sourceTypeLabel(sourceType);
        const extension = String(file?.extension || '').trim();
        if (extension) return this.extensionLabel({ extension });
        return '-';
    }

    public sourceTypeLabel(value: string) {
        const text = String(value || '').trim();
        const normalized = text.toLowerCase().replace(/^\./, '');
        const labels: any = {
            pdf: 'PDF',
            hwp: 'HWP',
            hwpx: 'HWPX',
            doc: 'DOC',
            docx: 'DOCX',
            txt: 'TXT',
            json: 'JSON',
        };
        return labels[normalized] || text.toUpperCase();
    }

    public fileStatusValues(file: any) {
        return [
            file?.parse_status,
            file?.artifact_status,
            file?.ocr_status,
            file?.embedding_status,
            file?.vector_status,
            file?.quality_status,
        ].map((status: any) => String(status || '').toLowerCase()).filter((status: string) => status);
    }

    public isErrorStatus(status: string) {
        return ['failed', 'error', 'missing', 'blocked', 'rejected', 'change_requested'].includes(String(status || '').toLowerCase());
    }

    public fileHasError(file: any) {
        return this.fileStatusValues(file).some((status: string) => this.isErrorStatus(status));
    }

    public bundleErrorCount(bundle: any) {
        return (bundle?.files || []).filter((file: any) => this.fileHasError(file)).length;
    }

    public bundleUnregisteredSourceCount(bundle: any) {
        return this.sourceFiles(bundle).filter((file: any) => !file.registered).length;
    }

    public bundlePipelineMetadata(bundle: any) {
        const result: any = {};
        const sources = [
            bundle?.pipeline_status,
            ...(bundle?.files || []).map((file: any) => file?.pipeline_status),
        ];
        for (const source of sources) {
            if (!source || typeof source !== 'object') continue;
            for (const key of Object.keys(source)) {
                const value = String(source[key] || '').trim().toLowerCase();
                if (value && !result[key]) result[key] = value;
            }
        }
        return result;
    }

    public pipelineRawStatus(bundle: any, key: string) {
        const metadata = this.bundlePipelineMetadata(bundle);
        return String(metadata?.[key] || '').toLowerCase();
    }

    public pipelineStatusFromRaw(status: string) {
        const value = String(status || '').toLowerCase();
        if (!value) return '';
        if (this.isErrorStatus(value)) return 'attention';
        if (this.doneStatus(value)) return 'usable';
        if (['pending', 'queued', 'running', 'working', 'processing', 'new', 'discovered', 'unknown', 'unchecked'].includes(value)) return 'processing';
        return '';
    }

    public bundleSourceStageStatus(bundle: any) {
        const explicit = this.pipelineStatusFromRaw(this.pipelineRawStatus(bundle, 'original_file'));
        if (explicit === 'attention') return 'attention';
        const files = this.sourceFiles(bundle);
        if (!files.length) return explicit || 'unavailable';
        if (files.some((file: any) => this.fileHasError(file))) return 'attention';
        if (explicit === 'usable') return 'usable';
        if (files.some((file: any) => file?.registered || file?.document_id) || this.bundleDocumentId(bundle)) return 'usable';
        return explicit || 'processing';
    }

    public bundleMetadataStageStatus(bundle: any) {
        const explicit = this.pipelineStatusFromRaw(this.pipelineRawStatus(bundle, 'metadata'));
        if (explicit === 'attention') return 'attention';
        if (this.bundleErrorCount(bundle) > 0) return 'attention';
        if (this.bundleDocumentId(bundle) && Number(bundle?.metadata?.length || 0) > 0) return 'usable';
        const sourceStatus = this.bundleSourceStageStatus(bundle);
        if (sourceStatus === 'attention') return 'attention';
        if (sourceStatus === 'usable') return explicit || 'processing';
        return 'unavailable';
    }

    public bundleOcrStageStatus(bundle: any) {
        const explicit = this.pipelineStatusFromRaw(this.pipelineRawStatus(bundle, 'ocr_page'));
        const inferred = this.bundleStageStatus(bundle, 'ocr');
        if (inferred === 'usable' || explicit === 'attention' || explicit === 'processing') return inferred === 'usable' ? 'usable' : explicit;
        return this.bundleMetadataStageStatus(bundle) === 'usable' ? inferred : 'unavailable';
    }

    public bundleChunkStageStatus(bundle: any) {
        const explicit = this.pipelineStatusFromRaw(this.pipelineRawStatus(bundle, 'chunk'));
        const inferred = this.bundleStageStatus(bundle, 'chunk');
        if (inferred === 'usable' || explicit === 'attention' || explicit === 'processing') return inferred === 'usable' ? 'usable' : explicit;
        return this.bundleOcrStageStatus(bundle) === 'usable' ? inferred : 'unavailable';
    }

    public bundleEmbeddingStageStatus(bundle: any) {
        const explicit = this.pipelineStatusFromRaw(this.pipelineRawStatus(bundle, 'embedding'));
        const status = String(this.bundleProcessStatus(bundle, 'embedding_status') || '').toLowerCase();
        if (explicit === 'attention' || this.bundleStageHasError(bundle, 'embedding', 'embedding_status')) return 'attention';
        if (explicit === 'usable' && Number(bundle?.embedding_chunk_count || 0) > 0) return 'usable';
        if (Number(bundle?.embedding_chunk_count || 0) > 0 && (
            this.doneStatus(status)
            || Number(bundle?.embedding?.length || 0) > 0
            || Number(bundle?.vector_inserted_count || 0) > 0
            || Number(bundle?.eligible_evidence_count || 0) > 0
            || this.doneStatus(this.bundleProcessStatus(bundle, 'vector_status'))
            || this.bundleSourceModeLabel(bundle) !== '신규 업로드'
        )) return 'usable';
        if (explicit === 'processing') return 'processing';
        if (this.bundleChunkStageStatus(bundle) !== 'usable') return 'unavailable';
        if (this.hasWorkingStatus(bundle, 'embedding') || this.waitingStatus(status)) return 'processing';
        return 'attention';
    }

    public bundleVectorStageStatus(bundle: any) {
        const explicit = this.pipelineStatusFromRaw(this.pipelineRawStatus(bundle, 'vector_index'));
        const inferred = this.bundleStageStatus(bundle, 'vector');
        if (inferred === 'usable' || explicit === 'attention' || explicit === 'processing') return inferred === 'usable' ? 'usable' : explicit;
        return this.bundleEmbeddingStageStatus(bundle) === 'usable' ? inferred : 'unavailable';
    }

    public bundleEvidenceStageStatus(bundle: any) {
        const explicit = this.pipelineStatusFromRaw(this.pipelineRawStatus(bundle, 'evidence_ready'));
        const inferred = this.bundleStageStatus(bundle, 'evidence');
        if (inferred === 'usable' || explicit === 'attention' || explicit === 'processing') return inferred === 'usable' ? 'usable' : explicit;
        return this.bundleVectorStageStatus(bundle) === 'usable' ? inferred : 'unavailable';
    }

    public bundleOriginalRegisteredStatus(bundle: any) {
        const status = String(bundle?.source_status || '').trim();
        if (['usable', 'processing', 'attention', 'unavailable'].includes(status)) return status;
        return this.bundleSourceStageStatus(bundle);
    }

    public bundleTextReadyStatus(bundle: any) {
        const status = String(bundle?.text_status || '').trim();
        if (['usable', 'processing', 'attention', 'unavailable'].includes(status)) return status;
        return this.bundleOcrStageStatus(bundle);
    }

    public bundleQaEvidenceReadyStatus(bundle: any) {
        const status = String(bundle?.qa_evidence_status || '').trim();
        if (['usable', 'processing', 'attention', 'unavailable'].includes(status)) return status;
        return this.bundleEvidenceStageStatus(bundle);
    }

    public bundleReviewRequiredStatus(bundle: any) {
        const status = String(bundle?.review_status || '').trim();
        if (['usable', 'processing', 'attention', 'unavailable'].includes(status)) return status;
        return this.bundleErrorCount(bundle) > 0 ? 'attention' : 'usable';
    }

    public pipelineStageValue(bundle: any, key: string, status: string) {
        if (key === 'source') return status === 'usable' ? `${this.number(this.sourceFiles(bundle).length)}개` : this.pipelineStageStatusLabel(status);
        if (key === 'text') return Number(bundle?.ocr_page_count || 0) > 0 ? `${this.number(bundle?.ocr_page_count)}쪽` : this.pipelineStageStatusLabel(status);
        if (key === 'qa_evidence') return Number(bundle?.eligible_evidence_count || bundle?.evidence_count || 0) > 0 ? `${this.number(bundle?.eligible_evidence_count || bundle?.evidence_count)}개` : this.pipelineStageStatusLabel(status);
        if (key === 'review') return status === 'attention' ? '필요' : '없음';
        if (key === 'metadata') return status === 'usable' ? '생성됨' : this.pipelineStageStatusLabel(status);
        if (key === 'ocr') return Number(bundle?.ocr_page_count || 0) > 0 ? `${this.number(bundle?.ocr_page_count)}쪽` : this.pipelineStageStatusLabel(status);
        if (key === 'chunk') return Number(bundle?.embedding_chunk_count || 0) > 0 ? `${this.number(bundle?.embedding_chunk_count)}개` : this.pipelineStageStatusLabel(status);
        if (key === 'embedding') return this.statusLabel(this.bundleProcessStatus(bundle, 'embedding_status') || (status === 'usable' ? 'completed' : status));
        if (key === 'vector') return `${this.number(bundle?.vector_inserted_count)} / ${this.number(bundle?.vector_count || bundle?.embedding_chunk_count)}개`;
        if (key === 'evidence') return Number(bundle?.eligible_evidence_count || bundle?.evidence_count || 0) > 0 ? `${this.number(bundle?.eligible_evidence_count || bundle?.evidence_count)}개` : this.pipelineStageStatusLabel(status);
        return this.pipelineStageStatusLabel(status);
    }

    public pipelineStageSub(bundle: any, key: string, status: string) {
        if (status === 'attention') return this.bundlePipelineStopReason(bundle, key);
        if (key === 'source') return status === 'usable' ? '원본 자료 확보' : '원본 확보 대기';
        if (key === 'text') return status === 'usable' ? '텍스트 자료 사용 가능' : '텍스트 자료 생성 대기';
        if (key === 'qa_evidence') return status === 'usable' ? '근거 자료 사용 가능' : '텍스트 자료 후 근거 자료 생성';
        if (key === 'review') return status === 'usable' ? '준비 완료' : '점검 필요';
        if (key === 'metadata') return this.bundleDocumentId(bundle) ? `자료 ID ${this.shortId(this.bundleDocumentId(bundle))}` : '자료 정보 생성 대기';
        if (key === 'ocr') return this.statusLabel(this.bundleProcessStatus(bundle, 'ocr_status') || (status === 'usable' ? 'completed' : 'pending'));
        if (key === 'chunk') return this.statusLabel(this.bundleProcessStatus(bundle, 'embedding_status') || (status === 'usable' ? 'completed' : 'pending'));
        if (key === 'embedding') return Number(bundle?.embedding_chunk_count || 0) > 0 ? `근거 자료 ${this.number(bundle?.embedding_chunk_count)}건 기준` : '근거 자료 생성 후 진행';
        if (key === 'vector') return this.statusLabel(this.bundleProcessStatus(bundle, 'vector_status') || (status === 'usable' ? 'indexed' : 'pending'));
        if (key === 'evidence') return status === 'usable' ? '근거 자료 사용 가능' : '근거 자료 준비 후 판정';
        return '';
    }

    public bundlePipelineSteps(bundle: any) {
        const sourceStatus = this.bundleOriginalRegisteredStatus(bundle);
        const textStatus = sourceStatus === 'usable' ? this.bundleTextReadyStatus(bundle) : 'unavailable';
        const evidenceStatus = textStatus === 'usable' ? this.bundleQaEvidenceReadyStatus(bundle) : 'unavailable';
        const reviewStatus = evidenceStatus === 'usable' ? this.bundleReviewRequiredStatus(bundle) : 'unavailable';
        const steps = [
            { key: 'source', label: '원본 확보', status: sourceStatus },
            { key: 'text', label: '텍스트 추출', status: textStatus },
            { key: 'qa_evidence', label: '근거 생성', status: evidenceStatus },
            { key: 'review', label: '준비 점검', status: reviewStatus },
        ];
        return steps.map((step: any) => ({
            ...step,
            value: this.pipelineStageValue(bundle, step.key, step.status),
            sub: this.pipelineStageSub(bundle, step.key, step.status),
        }));
    }

    public bundleProgressPercent(bundle: any) {
        const steps = this.bundlePipelineSteps(bundle);
        if (!steps.length) return 0;
        const completed = steps.filter((step: any) => step.status === 'usable').length;
        return Math.round((completed / steps.length) * 100);
    }

    public bundleProgressButtonClass(bundle: any) {
        const current = this.bundlePipelineCurrentStep(bundle);
        return this.bundleFlowStepPillClass(current?.status || 'usable');
    }

    public bundleProgressButtonTitle(bundle: any) {
        return `${bundle?.title || '자료'} 진행 단계 보기`;
    }

    public bundleDefaultStage(bundle: any) {
        const steps = this.bundlePipelineSteps(bundle);
        const current = this.bundlePipelineCurrentStep(bundle);
        return current || steps.find((step: any) => step.key === 'text') || steps[0] || null;
    }

    public async openBundleProgressDetail(bundle: any, event: any = null) {
        const step = this.bundleDefaultStage(bundle);
        if (!step) return;
        await this.openBundleStageDetail(bundle, step, event);
    }

    public async openBundleStageDetail(bundle: any, step: any, event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const detail = this.bundleStageDetail(bundle, step);
        this.stageDetail = detail;
        await this.service.render();
        await this.loadBundleStagePreview(bundle, step, detail);
    }

    public async closeBundleStageDetail() {
        this.stageDetailPreviewToken += 1;
        this.textViewerToken += 1;
        this.textViewer = null;
        this.stageDetail = null;
        await this.service.render();
    }

    public async selectBundleStageDetail(step: any, event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const bundle = this.stageDetail?.bundle;
        if (!bundle || !step) return;
        const detail = this.bundleStageDetail(bundle, step);
        this.stageDetail = detail;
        await this.service.render();
        await this.loadBundleStagePreview(bundle, step, detail);
    }

    public bundleStageDetail(bundle: any, step: any) {
        const files = this.bundleStageFiles(bundle, step?.key || '');
        const key = step?.key || '';
        const steps = this.bundlePipelineSteps(bundle);
        return {
            bundle,
            bundleTitle: bundle?.title || this.bundlePrimaryFile(bundle)?.name || '자료',
            documentId: bundle?.document_id || this.bundlePreviewDocumentId(bundle, key) || this.bundleDocumentId(bundle) || '',
            steps,
            step,
            statusLabel: this.pipelineStageStatusLabel(step?.status || ''),
            metrics: this.bundleStageMetrics(bundle, step),
            files,
            emptyText: this.bundleStageEmptyText(step?.key || ''),
            previewEnabled: ['text', 'qa_evidence'].includes(key),
            previewLoading: false,
            previewError: '',
            preview: { summary: {}, pages: [], chunks: [] },
        };
    }

    public async loadBundleStagePreview(bundle: any, step: any, detail: any) {
        const key = step?.key || '';
        if (!['text', 'qa_evidence'].includes(key)) return;
        const documentId = detail?.documentId || bundle?.document_id || this.bundleDocumentId(bundle) || '';
        if (!documentId) {
            detail.previewError = '자료 ID가 없어 텍스트를 불러올 수 없습니다.';
            await this.service.render();
            return;
        }

        this.stageDetailPreviewToken += 1;
        const token = this.stageDetailPreviewToken;
        detail.previewLoading = true;
        detail.previewError = '';
        await this.service.render();

        try {
            const previewPaths = JSON.stringify(this.bundlePreviewPaths(bundle, key));
            const previewParams = {
                document_id: documentId,
                collection_id: this.current?.id || '',
                stage: key,
                preview_paths: previewPaths,
                bundle_id: bundle?.id || '',
                bundle_title: bundle?.title || bundle?.bundle_key || '',
                source_path: bundle?.source_path || '',
            };
            const fallbackParams = {
                collection_id: this.current?.id || '',
                preview_document_id: documentId,
                preview_stage: key,
                preview_paths: previewPaths,
                bundle_id: bundle?.id || '',
                bundle_title: bundle?.title || bundle?.bundle_key || '',
                source_path: bundle?.source_path || '',
            };
            let result: any = await wiz.call("stage_preview", previewParams);
            if (!result || result?.code !== 200 || this.stagePreviewResponseEmpty(result?.data, key)) {
                result = await wiz.call("drive", fallbackParams);
            }
            if (token !== this.stageDetailPreviewToken || this.stageDetail !== detail) return;
            const { code, data } = result || {};
            if (code === 200) {
                detail.preview = {
                    summary: data?.summary || {},
                    pages: data?.pages || [],
                    chunks: data?.chunks || [],
                    document: data?.document || null,
                };
            } else {
                detail.previewError = this.apiErrorMessage(result, '텍스트 미리보기를 불러오지 못했습니다.');
            }
        } catch (error: any) {
            try {
                const fallback: any = await wiz.call("drive", {
                    collection_id: this.current?.id || '',
                    preview_document_id: documentId,
                    preview_stage: key,
                    preview_paths: JSON.stringify(this.bundlePreviewPaths(bundle, key)),
                    bundle_id: bundle?.id || '',
                    bundle_title: bundle?.title || bundle?.bundle_key || '',
                    source_path: bundle?.source_path || '',
                });
                if (token !== this.stageDetailPreviewToken || this.stageDetail !== detail) return;
                if (fallback?.code === 200) {
                    detail.preview = {
                        summary: fallback?.data?.summary || {},
                        pages: fallback?.data?.pages || [],
                        chunks: fallback?.data?.chunks || [],
                        document: fallback?.data?.document || null,
                    };
                } else {
                    detail.previewError = this.apiErrorMessage(fallback, this.apiErrorMessage(error, '텍스트 미리보기를 불러오지 못했습니다.'));
                }
            } catch (fallbackError: any) {
                if (token !== this.stageDetailPreviewToken || this.stageDetail !== detail) return;
                detail.previewError = this.apiErrorMessage(fallbackError, this.apiErrorMessage(error, '텍스트 미리보기를 불러오지 못했습니다.'));
            }
        } finally {
            if (token === this.stageDetailPreviewToken && this.stageDetail === detail) {
                detail.previewLoading = false;
                await this.service.render();
            }
        }
    }

    public stagePreviewCanOpenTextViewer(detail: any) {
        return detail?.step?.key === 'text'
            && !!detail?.documentId
            && !detail?.previewLoading
            && !detail?.previewError
            && this.stagePreviewTotal(detail) > 0;
    }

    public async openTextViewer(detail: any, event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.stagePreviewCanOpenTextViewer(detail)) return;
        const pages = this.stagePreviewItems(detail);
        const initialPage = Number(pages?.[0]?.page_no || pages?.[0]?.page || 1);
        const bundle = detail?.bundle || {};
        this.textViewerToken += 1;
        this.textViewer = {
            bundle,
            detail,
            documentId: detail?.documentId || bundle?.document_id || this.bundleDocumentId(bundle) || '',
            title: detail?.bundleTitle || bundle?.title || '자료',
            summary: detail?.preview?.summary || {},
            document: detail?.preview?.document || null,
            selectedPage: initialPage > 0 ? initialPage : 1,
            pageInput: initialPage > 0 ? initialPage : 1,
            searchInput: '',
            search: '',
            pages: pages?.length ? [pages[0]] : [],
            loading: false,
            error: '',
        };
        await this.service.render();
        await this.loadTextViewerPage(this.textViewer.selectedPage);
    }

    public async closeTextViewer(event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.textViewerToken += 1;
        this.textViewer = null;
        await this.service.render();
    }

    public textViewerPageTotal() {
        return Number(this.textViewer?.summary?.page_total || this.textViewer?.document?.page_count || 0);
    }

    public textViewerCharTotal() {
        return Number(this.textViewer?.summary?.page_char_total || 0);
    }

    public textViewerMatchTotal() {
        return Number(this.textViewer?.summary?.match_page_total || 0);
    }

    public textViewerIsSearchMode() {
        return String(this.textViewer?.search || '').trim().length > 0;
    }

    public textViewerPageWindow() {
        const total = this.textViewerPageTotal();
        if (total <= 0) return [];
        const current = this.clampTextViewerPage(this.textViewer?.selectedPage || 1);
        const size = Math.min(25, total);
        let start = Math.max(1, current - Math.floor(size / 2));
        let end = Math.min(total, start + size - 1);
        start = Math.max(1, end - size + 1);
        const pages: number[] = [];
        for (let page = start; page <= end; page += 1) pages.push(page);
        return pages;
    }

    public clampTextViewerPage(pageNo: any) {
        const total = this.textViewerPageTotal();
        let page = Number(pageNo || 1);
        if (!Number.isFinite(page) || page <= 0) page = 1;
        if (total > 0) page = Math.min(total, page);
        return Math.max(1, Math.floor(page));
    }

    public textViewerPageButtonClass(pageNo: any) {
        const active = this.clampTextViewerPage(pageNo) === this.clampTextViewerPage(this.textViewer?.selectedPage || 1);
        return active ? 'is-active' : '';
    }

    public textViewerSummaryLabel() {
        const total = this.textViewerPageTotal();
        const chars = this.textViewerCharTotal();
        const parts = [];
        if (total > 0) parts.push(`${this.number(total)}쪽`);
        if (chars > 0) parts.push(`${this.number(chars)}자`);
        if (this.textViewerIsSearchMode()) parts.push(`검색 결과 ${this.number(this.textViewerMatchTotal())}쪽`);
        return parts.join(' · ') || '추출 텍스트';
    }

    public textViewerEmptyText() {
        if (this.textViewerIsSearchMode()) return '검색 결과가 없습니다.';
        return '표시할 추출 텍스트가 없습니다.';
    }

    public textViewerPreviewParams(pageNo: number, search: string = '') {
        const viewer = this.textViewer || {};
        const bundle = viewer.bundle || {};
        const searchText = String(search || '').trim();
        return {
            document_id: viewer.documentId || '',
            collection_id: this.current?.id || '',
            stage: 'text',
            page_no: searchText ? 0 : pageNo,
            page_limit: searchText ? 20 : 1,
            text_limit: 30000,
            search: searchText,
            preview_paths: JSON.stringify(this.bundlePreviewPaths(bundle, 'text')),
            bundle_id: bundle?.id || '',
            bundle_title: bundle?.title || bundle?.bundle_key || '',
            source_path: bundle?.source_path || '',
        };
    }

    public async loadTextViewerPreview(pageNo: number = 1, search: string = '') {
        if (!this.textViewer?.documentId) return;
        const viewer = this.textViewer;
        const token = ++this.textViewerToken;
        const searchText = String(search || '').trim();
        viewer.loading = true;
        viewer.error = '';
        await this.service.render();

        try {
            const page = this.clampTextViewerPage(pageNo);
            const params = this.textViewerPreviewParams(page, searchText);
            let result: any = await wiz.call("stage_preview", params);
            if (!searchText && (!result || result?.code !== 200 || this.stagePreviewResponseEmpty(result?.data, 'text'))) {
                result = await wiz.call("drive", {
                    collection_id: params.collection_id,
                    preview_document_id: params.document_id,
                    preview_stage: 'text',
                    page_no: params.page_no,
                    page_limit: params.page_limit,
                    text_limit: params.text_limit,
                    search: params.search,
                    preview_paths: params.preview_paths,
                    bundle_id: params.bundle_id,
                    bundle_title: params.bundle_title,
                    source_path: params.source_path,
                });
            }
            if (token !== this.textViewerToken || this.textViewer !== viewer) return;
            if (result?.code === 200) {
                const data = result?.data || {};
                viewer.summary = data.summary || viewer.summary || {};
                viewer.document = data.document || viewer.document || null;
                viewer.pages = data.pages || [];
                viewer.search = searchText;
                if (!searchText) {
                    viewer.selectedPage = page;
                    viewer.pageInput = page;
                }
            } else {
                viewer.error = this.apiErrorMessage(result, '추출 텍스트를 불러오지 못했습니다.');
            }
        } catch (error: any) {
            if (token !== this.textViewerToken || this.textViewer !== viewer) return;
            viewer.error = this.apiErrorMessage(error, '추출 텍스트를 불러오지 못했습니다.');
        } finally {
            if (token === this.textViewerToken && this.textViewer === viewer) {
                viewer.loading = false;
                await this.service.render();
            }
        }
    }

    public async loadTextViewerPage(pageNo: any, event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.textViewer) return;
        this.textViewer.search = '';
        this.textViewer.searchInput = '';
        await this.loadTextViewerPreview(this.clampTextViewerPage(pageNo), '');
    }

    public async loadTextViewerInputPage(event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        await this.loadTextViewerPage(this.textViewer?.pageInput || 1);
    }

    public async searchTextViewer(event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.textViewer) return;
        const search = String(this.textViewer.searchInput || '').trim();
        await this.loadTextViewerPreview(this.textViewer?.selectedPage || 1, search);
    }

    public async clearTextViewerSearch(event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!this.textViewer) return;
        this.textViewer.searchInput = '';
        this.textViewer.search = '';
        await this.loadTextViewerPage(this.textViewer.selectedPage || 1);
    }

    public async openTextViewerSearchResult(item: any, event: any = null) {
        await this.loadTextViewerPage(item?.page_no || item?.page || 1, event);
    }

    public bundleStageFiles(bundle: any, key: string) {
        let files: any[] = [];
        if (key === 'source') {
            files = this.sourceFiles(bundle);
        } else if (key === 'text') {
            files = [
                ...(bundle?.ocr || []),
                ...(bundle?.ocr_status || []),
            ];
        } else if (key === 'qa_evidence') {
            files = [
                ...(bundle?.embedding || []),
                ...(bundle?.vector || []),
                ...(bundle?.embedding_status || []),
                ...(bundle?.vector_status || []),
            ];
        } else if (key === 'review') {
            files = [
                ...this.statusFiles(bundle),
                ...(bundle?.files || []).filter((file: any) => this.fileHasError(file)),
            ];
        }
        return this.uniqueStageFiles(files);
    }

    public uniqueStageFiles(files: any[]) {
        const map: any = {};
        for (const file of files || []) {
            const key = file?.path || file?.name || file?.id || JSON.stringify(file);
            if (!key || map[key]) continue;
            map[key] = file;
        }
        return Object.values(map);
    }

    public bundleStageMetrics(bundle: any, step: any) {
        const status = step?.status || '';
        const key = step?.key || '';
        const metrics = [
            { label: '단계 상태', value: this.pipelineStageStatusLabel(status) },
            { label: '현재 값', value: step?.value || '-' },
        ];
        if (key === 'source') {
            metrics.push(
                { label: '원본 파일', value: `${this.number(this.sourceFiles(bundle).length)}개` },
                { label: '전체 용량', value: this.fileSize(this.bundleSize(bundle)) },
            );
        } else if (key === 'text') {
            metrics.push(
                { label: '텍스트 자료', value: `${this.number(bundle?.ocr_page_count || 0)}쪽` },
                { label: 'OCR 상태', value: this.statusLabel(this.bundleProcessStatus(bundle, 'ocr_status') || (status === 'usable' ? 'completed' : 'pending')) },
            );
        } else if (key === 'qa_evidence') {
            metrics.push(
                { label: '근거 chunk', value: `${this.number(bundle?.embedding_chunk_count || 0)}개` },
                { label: '벡터 저장', value: `${this.number(bundle?.vector_inserted_count || 0)} / ${this.number(bundle?.vector_count || bundle?.embedding_chunk_count || 0)}개` },
                { label: 'QA 근거', value: `${this.number(bundle?.eligible_evidence_count || bundle?.evidence_count || 0)}개` },
            );
        } else if (key === 'review') {
            metrics.push(
                { label: '오류 파일', value: `${this.number(this.bundleErrorCount(bundle))}개` },
                { label: '점검 사유', value: bundle?.qa_reason || step?.sub || '-' },
            );
        }
        return metrics;
    }

    public bundleStageEmptyText(key: string) {
        if (key === 'source') return '연결된 원본 파일이 없습니다.';
        if (key === 'text') return '아직 표시할 텍스트 추출 산출물이 없습니다.';
        if (key === 'qa_evidence') return '아직 표시할 근거 자료나 벡터 상태가 없습니다.';
        if (key === 'review') return '별도 점검 파일이나 오류 항목이 없습니다.';
        return '표시할 상세 항목이 없습니다.';
    }

    public stagePreviewTitle(detail: any) {
        if (detail?.step?.key === 'qa_evidence') return '근거 텍스트';
        return '추출 텍스트';
    }

    public stagePreviewResponseEmpty(data: any, key: string) {
        const items = key === 'qa_evidence' ? data?.chunks : data?.pages;
        return !Array.isArray(items) || items.length === 0;
    }

    public stagePreviewItems(detail: any) {
        if (detail?.step?.key === 'qa_evidence') return detail?.preview?.chunks || [];
        return detail?.preview?.pages || [];
    }

    public stagePreviewTotal(detail: any) {
        const summary = detail?.preview?.summary || {};
        if (detail?.step?.key === 'qa_evidence') return Number(summary.chunk_total || 0);
        return Number(summary.page_total || 0);
    }

    public stagePreviewCountLabel(detail: any) {
        const loaded = this.stagePreviewItems(detail).length;
        const total = this.stagePreviewTotal(detail);
        if (total > loaded) return `${this.number(loaded)} / ${this.number(total)}개`;
        return `${this.number(loaded)}개`;
    }

    public stagePreviewEmptyText(detail: any) {
        if (detail?.step?.key === 'qa_evidence') return '표시할 근거 chunk 텍스트가 없습니다.';
        return '표시할 추출 텍스트가 없습니다.';
    }

    public stagePreviewItemTitle(detail: any, item: any) {
        if (detail?.step?.key === 'qa_evidence') {
            const index = Number(item?.chunk_index || 0) + 1;
            return `Chunk ${this.number(index)}`;
        }
        const pageNo = Number(item?.page_no || item?.page || 0);
        return pageNo > 0 ? `${this.number(pageNo)}쪽` : '페이지';
    }

    public stagePreviewItemMeta(detail: any, item: any) {
        const parts: string[] = [];
        const pageNo = Number(item?.page_no || item?.page || 0);
        if (detail?.step?.key === 'qa_evidence' && pageNo > 0) parts.push(`${this.number(pageNo)}쪽`);
        const textLength = Number(item?.text_length || item?.char_count || 0);
        if (textLength > 0) parts.push(`${this.number(textLength)}자`);
        if (detail?.step?.key === 'qa_evidence') {
            const vectorDim = Number(item?.vector_dim || 0);
            if (vectorDim > 0) parts.push(`${this.number(vectorDim)}차원`);
            if (Number(item?.indexed_vector_count || 0) > 0) parts.push('벡터 저장됨');
            if (item?.evidence_id) parts.push(item.evidence_id);
        }
        if (Number(item?.truncated || 0) > 0) parts.push('일부 표시');
        return parts.join(' · ') || '-';
    }

    public stagePreviewItemText(item: any) {
        return String(item?.text || item?.text_preview || '').trim();
    }

    public stageTimelineItemClass(step: any, activeStep: any) {
        const classes = [this.bundleFlowStepPillClass(step?.status || '')];
        if (step?.key === activeStep?.key) classes.push('is-active');
        return classes.join(' ');
    }

    public stageFileTitle(file: any) {
        return file?.name || file?.document_title || file?.metadata_title || file?.path || '산출물';
    }

    public stageFilePath(file: any) {
        return file?.path || file?.relative_path || file?.dir || '-';
    }

    public stageFileMeta(file: any) {
        const parts = [this.roleLabel(file)];
        const extension = this.extensionLabel(file);
        if (extension && extension !== 'FILE') parts.push(extension);
        if (Number(file?.size_bytes || 0) > 0) parts.push(this.fileSize(file?.size_bytes));
        return parts.join(' · ');
    }

    public stageFileStatusLabel(file: any) {
        const statuses = this.fileStatusValues(file);
        if (statuses.some((status: string) => this.isErrorStatus(status))) return '오류';
        const status = statuses.find((value: string) => value) || (file?.registered ? 'registered' : '');
        return status ? this.statusLabel(status) : '-';
    }

    public stageFileStatusClass(file: any) {
        const statuses = this.fileStatusValues(file);
        if (statuses.some((status: string) => this.isErrorStatus(status))) return 'is-attention';
        if (statuses.some((status: string) => ['processing', 'running', 'working', 'pending'].includes(status))) return 'is-processing';
        if (statuses.length || file?.registered) return 'is-usable';
        return 'is-waiting';
    }

    public pipelineStageStatusLabel(status: string) {
        if (status === 'usable') return '완료';
        if (status === 'processing') return '자료 처리 중';
        if (status === 'attention') return '점검 필요';
        return '대기';
    }

    public pipelineStageClass(status: string) {
        if (status === 'usable') return 'border-emerald-200 bg-emerald-50 text-emerald-800';
        if (status === 'processing') return 'border-amber-200 bg-amber-50 text-amber-800';
        if (status === 'attention') return 'border-rose-200 bg-rose-50 text-rose-800 ring-1 ring-rose-200';
        return 'border-gray-200 bg-gray-50 text-gray-500';
    }

    public pipelineStepDotClass(status: string) {
        if (status === 'usable') return 'bg-emerald-500';
        if (status === 'processing') return 'bg-amber-500';
        if (status === 'attention') return 'bg-rose-500';
        return 'bg-gray-300';
    }

    public bundlePipelineCurrentStep(bundle: any) {
        return this.bundlePipelineSteps(bundle).find((step: any) => step.status !== 'usable') || null;
    }

    public bundlePipelineSummary(bundle: any) {
        const current = this.bundlePipelineCurrentStep(bundle);
        if (!current) return '근거 자료 준비 완료';
        if (current.status === 'attention') return this.businessStatusText(`${current.label} · ${current.sub || current.value}`);
        if (current.status === 'processing') return this.businessStatusText(`${current.label} 자료 처리 중 · ${current.sub || current.value}`);
        return this.businessStatusText(`${current.label} 대기 · 이전 단계 완료 필요`);
    }

    public bundleFlowCurrentLabel(bundle: any) {
        const current = this.bundlePipelineCurrentStep(bundle);
        if (!current) return 'QA 작성 가능';
        if (current.status === 'attention') return `${current.label} 확인 필요`;
        if (current.status === 'processing') return `${current.label} 진행 중`;
        return `${current.label} 대기`;
    }

    public bundleFlowDetail(bundle: any) {
        const current = this.bundlePipelineCurrentStep(bundle);
        if (!current) return '다음: QA 작성';
        if (current.sub) return current.sub;
        const steps = this.bundlePipelineSteps(bundle);
        const index = steps.findIndex((step: any) => step.key === current.key);
        const next = index >= 0 ? steps[index + 1] : null;
        return next ? `다음: ${next.label}` : '다음 단계 확인';
    }

    public bundleFlowStepPillClass(status: string) {
        if (status === 'usable') return 'is-usable';
        if (status === 'processing') return 'is-processing';
        if (status === 'attention') return 'is-attention';
        return 'is-waiting';
    }

    public businessStatusText(value: string) {
        const text = String(value || '').trim();
        if (!text) return '';
        return this.harnessDisplayText(text)
            .replace(/milvus/gi, '근거 자료 저장소');
    }

    public bundlePipelineStopReason(bundle: any, key: string) {
        const issueMessage = this.primaryIssueMessage(bundle);
        if (issueMessage) return issueMessage;
        if (this.bundleErrorCount(bundle) > 0) return '오류 상태 산출물 확인 필요';
        if (key === 'source') return '원본 자료 확인 필요';
        if (key === 'text') return '텍스트 자료 상태 확인 필요';
        if (key === 'qa_evidence') return '근거 자료 상태 확인 필요';
        if (key === 'review') return '점검 필요';
        if (key === 'metadata') return '자료 정보 연결 필요';
        if (key === 'ocr') return '텍스트 자료 필요';
        if (key === 'chunk') return '근거 자료 필요';
        if (key === 'embedding') return '근거 자료 상태 확인 필요';
        if (key === 'vector') return '근거 자료 필요';
        if (key === 'evidence') return '근거 자료 필요';
        return bundle?.qa_reason || '상태 확인 필요';
    }

    public bundleStageStatus(bundle: any, key: string) {
        if (key === 'source') {
            const files = this.sourceFiles(bundle);
            if (!files.length) return 'unavailable';
            if (files.some((file: any) => this.isErrorStatus(file?.parse_status || file?.artifact_status))) return 'attention';
            return 'usable';
        }
        if (key === 'evidence') {
            if (Number(bundle?.eligible_evidence_count || 0) > 0) return 'usable';
            if (Number(bundle?.evidence_count || 0) > 0 && Number(bundle?.vector_inserted_count || 0) > 0) return 'usable';
            if (Number(bundle?.embedding_chunk_count || 0) > 0) return 'processing';
            return this.bundleStageStatus(bundle, 'chunk') === 'processing' ? 'processing' : 'unavailable';
        }

        const artifactKey = key === 'chunk' ? 'embedding' : key;
        const statusKey = artifactKey === 'ocr' ? 'ocr_status' : (artifactKey === 'embedding' ? 'embedding_status' : (artifactKey === 'vector' ? 'vector_status' : ''));
        if (this.bundleStageHasError(bundle, artifactKey, statusKey)) return 'attention';

        const countKey = key === 'ocr' ? 'ocr_page_count' : (key === 'chunk' ? 'embedding_chunk_count' : 'vector_inserted_count');
        if (Number(bundle?.[countKey] || 0) > 0) return 'usable';
        if (this.hasWorkingStatus(bundle, artifactKey)) return 'processing';

        const processStatus = statusKey ? this.bundleProcessStatus(bundle, statusKey) : '';
        if (processStatus && !this.doneStatus(processStatus) && !this.isErrorStatus(processStatus)) return 'processing';
        return 'attention';
    }

    public bundleStageHasError(bundle: any, artifactKey: string, statusKey: string = '') {
        const files = [
            ...(bundle?.[artifactKey] || []),
            ...(statusKey ? (bundle?.[statusKey] || []) : []),
        ];
        if (files.some((file: any) => this.fileHasError(file))) return true;
        return statusKey ? this.isErrorStatus(this.bundleProcessStatus(bundle, statusKey)) : false;
    }

    public bundleStageLabel(bundle: any, key: string) {
        const status = this.bundleStageStatus(bundle, key);
        if (key === 'source') {
            if (status === 'attention') return Number(this.sourceFiles(bundle).length || 0) > 0 ? '확인 필요' : '없음';
            return '있음';
        }
        if (key === 'ocr') {
            const count = Number(bundle?.ocr_page_count || 0);
            if (count > 0) return `${this.number(count)}p`;
        }
        if (key === 'chunk') {
            const count = Number(bundle?.embedding_chunk_count || 0);
            if (count > 0) return `${this.number(count)}개`;
        }
        if (key === 'vector') {
            const count = Number(bundle?.vector_inserted_count || 0);
            if (count > 0) return `${this.number(count)}개`;
        }
        if (key === 'evidence') {
            const count = Number(bundle?.eligible_evidence_count || bundle?.evidence_count || 0);
            if (count > 0) return `${this.number(count)}개`;
        }
        if (status === 'processing') return '처리 중';
        if (status === 'unavailable') return '생성 불가';
        if (status === 'attention') return this.bundleStageHasAnyFile(bundle, key) ? '확인 필요' : '없음';
        return '있음';
    }

    public bundleStageHasAnyFile(bundle: any, key: string) {
        if (key === 'source') return Number(this.sourceFiles(bundle).length || 0) > 0;
        if (key === 'evidence') return Number(bundle?.evidence_count || bundle?.eligible_evidence_count || 0) > 0;
        const artifactKey = key === 'chunk' ? 'embedding' : key;
        const statusKey = artifactKey === 'ocr' ? 'ocr_status' : (artifactKey === 'embedding' ? 'embedding_status' : (artifactKey === 'vector' ? 'vector_status' : ''));
        return Number(bundle?.[artifactKey]?.length || 0) > 0 || Number(bundle?.[statusKey]?.length || 0) > 0;
    }

    public bundleStageClass(bundle: any, key: string) {
        return this.readinessStepClass(this.bundleStageStatus(bundle, key));
    }

    public bundleStatusLabel(bundle: any) {
        if (this.bundleErrorCount(bundle) > 0) return '오류';
        if (bundle?.missing > 0) return '원본 없음';
        if (this.bundleUnregisteredSourceCount(bundle) > 0) return '자료 정보 생성 전';
        return '처리 완료';
    }

    public bundleStatusTone(bundle: any) {
        if (this.bundleErrorCount(bundle) > 0 || bundle?.missing > 0) return 'border-rose-200 bg-rose-50 text-rose-700';
        if (this.bundleUnregisteredSourceCount(bundle) > 0) return 'border-amber-200 bg-amber-50 text-amber-700';
        return 'border-emerald-200 bg-emerald-50 text-emerald-700';
    }

    public fileTypeCount(key: string) {
        const files = this.filesMatchingQuery();
        if (key === 'all') return files.length;
        return files.filter((file: any) => this.matchesFileType(file, key)).length;
    }

    public matchesFileType(file: any, key: string) {
        const role = this.classifyFile(file).role;
        if (key === 'source') return role === 'source';
        if (key === 'metadata') return role === 'metadata';
        if (key === 'ocr') return role === 'ocr';
        if (key === 'embedding') return role === 'embedding';
        if (key === 'vector') return role === 'vector';
        if (key === 'status') return ['status', 'ocr_status', 'embedding_status', 'vector_status'].includes(role);
        if (key === 'unregistered') return role === 'source' && !file?.registered;
        if (key === 'error') return this.fileHasError(file);
        return true;
    }

    public async setFileTypeFilter(key: string) {
        this.fileTypeFilter = key || 'all';
        this.resetDriveItemWindow();
        await this.service.render();
    }

    public filterClass(key: string) {
        if (this.fileTypeFilter === key) return 'border-gray-950 bg-gray-950 text-white';
        return 'border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50';
    }

    public bundleProcessStatus(bundle: any, key: string) {
        const source = this.sourceFiles(bundle).find((file: any) => file?.[key]);
        return source?.[key] || '';
    }

    public processStatusLabel(bundle: any, key: string) {
        const status = this.bundleProcessStatus(bundle, key);
        return status ? this.statusLabel(status) : '대기';
    }

    public processStatusTone(bundle: any, key: string) {
        const status = this.bundleProcessStatus(bundle, key);
        return this.statusClass(status || 'pending');
    }

    public firstFileStatus(slot: any) {
        const first = slot.files[0];
        return this.statusLabel(first.parse_status || 'ready');
    }

    public bundleFileCount(bundle: any) {
        return Number(bundle?.files?.length || 0);
    }

    public bundleSize(bundle: any) {
        return (bundle?.files || []).reduce((total: number, file: any) => total + Number(file?.size_bytes || 0), 0);
    }

    public bundleModifiedAt(bundle: any) {
        const files = bundle?.files || [];
        const values = files.map((file: any) => file?.modified_at || '').filter((value: string) => value);
        if (!values.length) return '-';
        return values.sort().reverse()[0];
    }

    public bundlePrimaryFile(bundle: any) {
        const groups = [bundle?.source, bundle?.metadata, bundle?.ocr, bundle?.embedding, bundle?.vector, bundle?.other, bundle?.vector_status, bundle?.ocr_status, bundle?.embedding_status];
        for (const group of groups) {
            if (group?.length) return group[0];
        }
        return null;
    }

    public derivedFileCount(bundle: any) {
        return Math.max(0, this.bundleFileCount(bundle) - Number(bundle?.source?.length || 0));
    }

    public sourceLabel(bundle: any) {
        return Number(bundle?.source?.length || 0) > 0 ? '보존' : '없음';
    }

    public sourceTone(bundle: any) {
        if (Number(bundle?.source?.length || 0) > 0) return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        return 'border-rose-200 bg-rose-50 text-rose-700';
    }

    public registrationLabel(bundle: any) {
        const files = this.sourceFiles(bundle).length ? this.sourceFiles(bundle) : (bundle?.files || []);
        if (!files.length) return '-';
        if (files.some((file: any) => this.fileHasError(file))) return '오류';
        const registered = files.filter((file: any) => file.registered).length;
        if (registered === files.length) return '처리 완료';
        if (registered > 0) return '일부 완료';
        return '자료 정보 생성 전';
    }

    public registrationTone(bundle: any) {
        const files = this.sourceFiles(bundle).length ? this.sourceFiles(bundle) : (bundle?.files || []);
        if (!files.length) return 'border-gray-200 bg-gray-50 text-gray-500';
        if (files.some((file: any) => this.fileHasError(file))) return 'border-rose-200 bg-rose-50 text-rose-700';
        const registered = files.filter((file: any) => file.registered).length;
        if (registered === files.length) return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (registered > 0) return 'border-amber-200 bg-amber-50 text-amber-700';
        return 'border-gray-200 bg-gray-50 text-gray-500';
    }

    public supportLabel(bundle: any) {
        const count = this.derivedFileCount(bundle);
        return count > 0 ? `${this.number(count)}개` : '없음';
    }

    public supportTone(bundle: any) {
        if (this.derivedFileCount(bundle) > 0) return 'border-sky-200 bg-sky-50 text-sky-700';
        return 'border-gray-200 bg-gray-50 text-gray-500';
    }

    public doneStatus(status: string) {
        return ['completed', 'indexed', 'imported', 'ready', 'passed', 'published', 'approved', 'done'].includes(String(status || '').toLowerCase());
    }

    public waitingStatus(status: string) {
        return ['pending', 'queued', 'running', 'working', 'unknown', 'unchecked', 'new', 'discovered', ''].includes(String(status || '').toLowerCase());
    }

    public artifactStatus(bundle: any, key: string) {
        const files = bundle?.[key] || [];
        if (files.some((file: any) => this.fileHasError(file))) return 'failed';
        if (files.length > 0) return 'completed';
        const statusKey = key === 'ocr' ? 'ocr_status' : (key === 'embedding' ? 'embedding_status' : (key === 'vector' ? 'vector_status' : ''));
        const status = statusKey ? this.bundleProcessStatus(bundle, statusKey) : '';
        if (this.isErrorStatus(status)) return 'failed';
        if (this.doneStatus(status)) return 'completed';
        return 'pending';
    }

    public artifactLabel(bundle: any, key: string) {
        const status = this.artifactStatus(bundle, key);
        if (status === 'failed') return '확인 필요';
        if (status === 'completed') return '있음';
        return '없음';
    }

    public artifactTone(bundle: any, key: string) {
        return this.statusClass(this.artifactStatus(bundle, key));
    }

    public qualityStatus(status: string) {
        const value = String(status || '').toLowerCase();
        if (this.isErrorStatus(value) || ['rejected', 'change_requested'].includes(value)) return 'attention';
        if (this.doneStatus(value)) return 'completed';
        return 'pending';
    }

    public bundleQualityStatus(bundle: any) {
        const files = this.sourceFiles(bundle).length ? this.sourceFiles(bundle) : (bundle?.files || []);
        if (!files.length) return 'attention';
        if (files.some((file: any) => this.qualityStatus(file?.quality_status || '') === 'attention')) return 'attention';
        if (files.some((file: any) => this.qualityStatus(file?.quality_status || '') === 'pending')) return 'pending';
        return 'completed';
    }

    public bundleQualityLabel(bundle: any) {
        const status = this.bundleQualityStatus(bundle);
        if (status === 'attention') return '확인 필요';
        if (status === 'completed') return '확인 완료';
        return '대기';
    }

    public bundleQualityTone(bundle: any) {
        return this.statusClass(this.bundleQualityStatus(bundle));
    }

    public qaStatusLabel(status: string) {
        switch (String(status || '')) {
            case 'usable':
                return '사용 가능';
            case 'partial':
                return '부분 준비';
            case 'processing':
                return '처리 중';
            case 'attention':
                return '확인 필요';
            case 'unavailable':
                return '생성 불가';
            default:
                return this.statusLabel(status || 'attention');
        }
    }

    public qaStatusClass(status: string) {
        switch (String(status || '')) {
            case 'usable':
                return 'border-emerald-200 bg-emerald-50 text-emerald-700';
            case 'partial':
                return 'border-sky-200 bg-sky-50 text-sky-700';
            case 'processing':
                return 'border-amber-200 bg-amber-50 text-amber-700';
            case 'unavailable':
                return 'border-rose-200 bg-rose-50 text-rose-700';
            case 'attention':
                return 'border-rose-200 bg-rose-50 text-rose-700';
            default:
                return this.statusClass(status || 'attention');
        }
    }

    public collectionQaStatus(collection: any) {
        return collection?.qa_status || 'attention';
    }

    public collectionQaMeta(collection: any) {
        return `준비 ${this.number(this.collectionEvidenceReadyDocumentCount(collection))} · 처리중 ${this.number(collection?.qa_processing_count)} · 점검 ${this.number(this.collectionReviewRequiredCount(collection))}`;
    }

    public readinessProgressLabel() {
        const total = Number(this.readiness?.total || this.readinessSummary.document_total || 0);
        const listed = Number(this.readiness?.listed || (this.readiness?.documents || []).length || 0);
        if (!total) return '자료 없음';
        return this.readiness?.truncated ? `${this.number(listed)} / ${this.number(total)}건 표시` : `${this.number(total)}건`;
    }

    public readinessMetricLabel(row: any, key: string) {
        if (key === 'ocr') return `${this.number(row?.ocr_page_count)}쪽`;
        if (key === 'chunk') return `${this.number(row?.actual_chunk_count || row?.chunk_count)}개`;
        if (key === 'vector') {
            const total = Number(row?.vector_count || row?.actual_chunk_count || row?.chunk_count || 0);
            return `${this.number(row?.indexed_vector_count)} / ${this.number(total)}개`;
        }
        if (key === 'evidence') return `${this.number(row?.eligible_evidence_count || row?.evidence_count)}개`;
        return '-';
    }

    public readinessMetricStatus(row: any, key: string) {
        if (key === 'ocr') return row?.ocr_state || 'processing';
        if (key === 'chunk') return row?.chunk_state || 'processing';
        if (key === 'vector') return row?.vector_state || 'processing';
        if (key === 'evidence') return row?.evidence_state || 'processing';
        return 'processing';
    }

    public readinessMetricClass(row: any, key: string) {
        return this.qaStatusClass(this.readinessMetricStatus(row, key));
    }

    public documentQualityLabel(row: any) {
        const status = row?.quality_status || 'unchecked';
        if (row?.quality_state === 'usable') return this.statusLabel(status);
        return '확인 필요';
    }

    public documentPathLabel(row: any) {
        return row?.relative_dir || row?.document_key || row?.id || '-';
    }

    public matches(item: any, text: string, keys: string[]) {
        return keys.some((key: string) => String(item?.[key] || '').toLowerCase().indexOf(text) >= 0);
    }

    public async openCollectionForm() {
        this.collectionActionMenuId = '';
        this.editingCollection = null;
        this.collectionForm = { title: '', description: '' };
        this.showCollectionForm = true;
        this.error = '';
        await this.service.render();
    }

    public async openCollectionEditForm(collection: any) {
        if (!collection?.id) return;
        if (this.collectionDeletionRequested(collection)) {
            await this.service.modal.error('폐기 요청된 컬렉션은 요청 취소 후 수정하세요.');
            return;
        }
        this.collectionActionMenuId = '';
        this.editingCollection = collection;
        this.collectionForm = {
            title: collection.title || '',
            description: collection.description || '',
        };
        this.showCollectionForm = true;
        this.error = '';
        await this.service.render();
    }

    public async closeCollectionForm() {
        if (this.collectionSaving) return;
        this.showCollectionForm = false;
        this.editingCollection = null;
        await this.service.render();
    }

    public collectionFormTitle() {
        return this.editingCollection?.id ? '컬렉션 수정' : '새 컬렉션';
    }

    public collectionFormActionLabel() {
        if (this.collectionSaving) return this.editingCollection?.id ? '저장 중' : '생성 중';
        return this.editingCollection?.id ? '저장' : '생성';
    }

    public async saveCollectionForm() {
        if (this.editingCollection?.id) {
            await this.updateCollection();
            return;
        }
        await this.createCollection();
    }

    public async createCollection() {
        const title = String(this.collectionForm.title || '').trim();
        const description = String(this.collectionForm.description || '').trim();
        if (!title || this.collectionSaving) return;
        this.collectionSaving = true;
        this.error = '';
        this.uploadMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("create_collection", { title, description });
            if (code === 200) {
                this.assignDrive(data || {});
                const created = data?.created_collection || data?.current || null;
                if (created?.id) {
                    const url = this.driveUrl(created.id, '');
                    if (`${location.pathname}${location.search}` !== url) {
                        window.history.pushState({}, '', url);
                    }
                    const wizRoute = (window as any).WizRoute;
                    if (wizRoute?.segment) {
                        wizRoute.segment.collection_id = created.id;
                        wizRoute.segment.drive_path = '';
                    }
                }
                this.collectionForm = { title: '', description: '' };
                this.editingCollection = null;
                this.showCollectionForm = false;
                this.uploadMessage = '새 컬렉션을 만들었습니다.';
            } else {
                this.error = data?.message || '컬렉션을 만들지 못했습니다.';
            }
        } catch (error: any) {
            this.error = error?.message || '컬렉션을 만들지 못했습니다.';
        } finally {
            this.collectionSaving = false;
            await this.service.render();
        }
    }

    public async updateCollection() {
        const collectionId = this.editingCollection?.id || '';
        const title = String(this.collectionForm.title || '').trim();
        const description = String(this.collectionForm.description || '').trim();
        if (!collectionId || !title || this.collectionSaving) return;
        this.collectionSaving = true;
        this.error = '';
        this.uploadMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("update_collection", {
                collection_id: collectionId,
                title,
                description,
            });
            if (code === 200) {
                this.collections = data?.collections || this.collections || [];
                if (data?.updated_collection?.id && this.current?.id === data.updated_collection.id) {
                    this.current = data.updated_collection;
                }
                this.collectionForm = { title: '', description: '' };
                this.editingCollection = null;
                this.showCollectionForm = false;
                this.uploadMessage = data?.message || '컬렉션 정보를 저장했습니다.';
            } else {
                this.error = data?.message || '컬렉션 정보를 저장하지 못했습니다.';
            }
        } catch (error: any) {
            this.error = error?.message || '컬렉션 정보를 저장하지 못했습니다.';
        } finally {
            this.collectionSaving = false;
            await this.service.render();
        }
    }

    public async selectCollection(collection: any) {
        if (!collection?.id) return;
        this.selected = null;
        this.fileQuery = '';
        this.collectionActionMenuId = '';
        this.expandedCollectionId = '';
        await this.openDriveRoute(collection.id, '');
    }

    public async recalculateCollectionStatus(collection: any) {
        if (!collection?.id || this.collectionReindexingId) return;
        this.collectionActionMenuId = '';
        this.collectionReindexingId = collection.id;
        this.error = '';
        this.uploadMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("recalculate_collection_status", { collection_id: collection.id });
            if (code === 200) {
                this.collections = data?.collections || this.collections || [];
                if (this.current?.id === collection.id) {
                    this.current = data?.updated_collection || this.current;
                }
                const count = Number(data?.projection_refresh?.bundle_count || data?.reindex?.bundle_count || 0);
                this.uploadMessage = data?.message || `운영 상태 ${this.number(count)}건을 재계산했습니다.`;
            } else {
                await this.service.modal.error(data?.message || '처리 상태 재계산에 실패했습니다.');
            }
        } catch (error: any) {
            await this.service.modal.error(error?.message || '처리 상태 재계산에 실패했습니다.');
        } finally {
            this.collectionReindexingId = '';
            await this.service.render();
        }
    }

    public async reindexCollection(collection: any) {
        await this.recalculateCollectionStatus(collection);
    }

    public async deleteCollection(collection: any) {
        if (!collection?.id || this.collectionDeleting) return;
        this.collectionActionMenuId = '';
        if (this.uploading || this.driveLoading) {
            await this.service.modal.error('업로드 또는 목록 갱신이 끝난 뒤 삭제하세요.');
            return;
        }

        const title = collection.title || collection.id;
        const requested = this.collectionDeletionRequested(collection);
        const immediateDelete = this.collectionImmediateDeleteAvailable(collection);
        const action = this.collectionDeleteActionLabel(collection);
        const message = requested
            ? `${title} 컬렉션의 폐기 요청을 취소하고 다시 사용할 수 있게 전환합니다.`
            : immediateDelete
                ? `${title} 빈 컬렉션을 즉시 삭제하시겠습니까? 생성된 빈 폴더와 목록 항목이 제거됩니다.`
                : `${title} 컬렉션을 폐기 요청 상태로 전환하시겠습니까? 자료와 QA 데이터는 보존되고 변경 작업은 중지됩니다.`;
        const confirmed = await this.service.modal.show({
            title: requested ? '폐기 요청 취소' : immediateDelete ? '컬렉션 삭제' : '컬렉션 폐기 요청',
            message,
            action,
            cancel: '취소',
            status: requested ? 'warning' : immediateDelete ? 'error' : 'warning',
            actionBtn: immediateDelete ? 'error' : 'warning',
        });
        if (!confirmed) return;

        this.collectionDeleting = true;
        this.error = '';
        this.uploadMessage = '';
        await this.service.render();

        try {
            const apiName = requested ? "cancel_collection_deletion" : immediateDelete ? "delete_collection" : "request_collection_deletion";
            const { code, data } = await wiz.call(apiName, { collection_id: collection.id });
            if (code === 200) {
                if (immediateDelete) {
                    this.selected = null;
                    this.fileQuery = '';
                    this.driveActionMenuOpen = false;
                    this.showNewFolderForm = false;
                    const url = '/literature';
                    if (`${location.pathname}${location.search}` !== url) {
                        window.history.pushState({}, '', url);
                    }
                    const wizRoute = (window as any).WizRoute;
                    if (wizRoute?.segment) {
                        wizRoute.segment.collection_id = '';
                        wizRoute.segment.drive_path = '';
                    }
                    this.assignDrive(data || {});
                } else {
                    this.collections = data?.collections || this.collections || [];
                    if (data?.updated_collection?.id && this.current?.id === data.updated_collection.id) {
                        this.current = data.updated_collection;
                    }
                }
                this.uploadMessage = data?.message || (requested ? '폐기 요청을 취소했습니다.' : immediateDelete ? '컬렉션을 삭제했습니다.' : '컬렉션 폐기 요청을 등록했습니다.');
            } else {
                await this.service.modal.error(data?.message || '컬렉션 상태를 변경하지 못했습니다.');
            }
        } catch (error: any) {
            await this.service.modal.error(error?.message || '컬렉션 상태를 변경하지 못했습니다.');
        } finally {
            this.collectionDeleting = false;
            await this.service.render();
        }
    }

    public async openCollectionQa(collection: any) {
        if (!collection?.id) return;
        if (this.collectionDeletionRequested(collection)) {
            await this.service.modal.error('폐기 요청된 컬렉션은 QA 작성에 사용할 수 없습니다.');
            return;
        }
        if (!this.collectionReadyForQaAuthoring(collection)) {
            await this.service.modal.error('원본 자료, 텍스트 자료, 근거 자료와 준비 점검가 모두 통과한 컬렉션만 QA 작성으로 이동할 수 있습니다.');
            return;
        }
        this.service.href(`/qa?collection_id=${encodeURIComponent(collection.id)}`);
    }

    public async openFolder(folder: any) {
        if (!folder?.id) return;
        this.selected = null;
        this.stageDetail = null;
        this.fileQuery = '';
        this.driveActionMenuOpen = false;
        this.showNewFolderForm = false;
        await this.openDriveRoute(this.current?.id || '', folder.id);
    }

    public async deleteFolder(folder: any, event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const folderPath = this.folderPath(folder);
        if (!this.current?.id || !folderPath || this.uploading || this.driveLoading || this.folderDeletingPath) return;
        if (this.collectionDeletionRequested(this.current)) {
            await this.service.modal.error('폐기 요청된 컬렉션에는 폴더를 삭제할 수 없습니다.');
            return;
        }

        const folderName = folder?.name || folderPath;
        const confirmed = await this.service.modal.show({
            title: '폴더 삭제',
            message: `${folderName} 폴더를 삭제하시겠습니까? 비어 있는 폴더만 삭제됩니다.`,
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error',
        });
        if (!confirmed) return;

        this.folderDeletingPath = folderPath;
        this.driveLoading = true;
        this.error = '';
        this.uploadMessage = '';
        await this.service.render();

        const previousDevMode = this.cookieValue('season-wiz-devmode') || 'false';
        let errorMessage = '';
        try {
            this.setWizDevModeCookie('true');
            let result: any = await wiz.call("drive", {
                collection_id: this.current.id,
                folder_id: this.currentFolderId || '',
                path: this.currentPath || '',
                delete_folder_id: folder?.id || '',
                delete_folder_path: folderPath,
            });
            if (result?.code === 200 && !result?.data?.deleted_folder_path) {
                result = await wiz.call("delete_folder", {
                    collection_id: this.current.id,
                    folder_id: folder?.id || '',
                    path: folderPath,
                });
            }
            const { code, data } = result || {};
            if (code === 200) {
                this.selected = null;
                if (data?.refresh_required) {
                    await this.loadDrive(this.current.id, '', data?.path || this.currentPath || '');
                } else {
                    this.assignDrive(data || {});
                }
                this.uploadMessage = data?.message || '폴더를 삭제했습니다.';
            } else {
                errorMessage = this.apiErrorMessage(result, '폴더를 삭제하지 못했습니다.');
            }
        } catch (error: any) {
            errorMessage = this.apiErrorMessage(error, '폴더를 삭제하지 못했습니다.');
        } finally {
            this.setWizDevModeCookie(previousDevMode);
            this.folderDeletingPath = '';
            this.driveLoading = false;
            await this.service.render();
        }
        if (errorMessage) {
            await this.service.modal.error(errorMessage);
        }
    }

    public async deleteBundle(bundle: any, event: any = null) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const paths = this.bundleDeletePaths(bundle);
        const key = this.bundleDeleteKey(bundle);
        if (!this.current?.id || !key || !paths.length || this.uploading || this.driveLoading || this.bundleDeletingKey) return;
        if (this.collectionDeletionRequested(this.current)) {
            await this.service.modal.error('폐기 요청된 컬렉션에는 자료를 삭제할 수 없습니다.');
            return;
        }

        const title = bundle?.title || this.bundlePrimaryFile(bundle)?.name || '선택한 자료';
        const confirmed = await this.service.modal.show({
            title: '자료 삭제',
            message: `${title} 자료를 삭제하시겠습니까? 원본 파일과 생성된 텍스트/근거 자료를 함께 삭제합니다.`,
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error',
        });
        if (!confirmed) return;

        this.bundleDeletingKey = key;
        this.driveLoading = true;
        this.error = '';
        this.uploadMessage = '';
        await this.service.render();

        const previousDevMode = this.cookieValue('season-wiz-devmode') || 'false';
        let errorMessage = '';
        try {
            this.setWizDevModeCookie('true');
            const result: any = await wiz.call("delete_bundle", {
                collection_id: this.current.id,
                folder_id: this.currentFolderId || '',
                path: this.currentPath || '',
                bundle_id: bundle?.bundle_id || '',
                bundle_key: bundle?.bundle_key || bundle?.key || '',
                document_id: bundle?.document_id || this.bundleDocumentId(bundle) || '',
                file_paths: JSON.stringify(paths),
            });
            const { code, data } = result || {};
            if (code === 200) {
                this.selected = null;
                if (data?.refresh_required) {
                    await this.loadDrive(this.current.id, '', data?.path || this.currentPath || '');
                } else {
                    this.assignDrive(data || {});
                }
                this.uploadMessage = data?.message || '자료를 삭제했습니다.';
            } else {
                errorMessage = this.apiErrorMessage(result, '자료를 삭제하지 못했습니다.');
            }
        } catch (error: any) {
            errorMessage = this.apiErrorMessage(error, '자료를 삭제하지 못했습니다.');
        } finally {
            this.setWizDevModeCookie(previousDevMode);
            this.bundleDeletingKey = '';
            this.driveLoading = false;
            await this.service.render();
        }
        if (errorMessage) {
            await this.service.modal.error(errorMessage);
        }
    }

    public async openBreadcrumb(crumb: any) {
        this.stageDetail = null;
        this.fileQuery = '';
        this.driveActionMenuOpen = false;
        this.showNewFolderForm = false;
        await this.openDriveRoute(this.current?.id || '', crumb?.id || '');
    }

    public async loadArtifactChain(showError: boolean = true) {
        const documentId = this.selected?.document_id || '';
        if (!documentId) return;
        const targetId = documentId;
        try {
            const { code, data } = await wiz.call("artifact_chain", { document_id: targetId });
            if (this.selected?.document_id !== targetId) return;
            if (code === 200) {
                this.selected = { ...this.selected, artifact_chain: data?.chain || null };
            } else if (showError) {
                this.error = data?.message || '자료 처리 결과를 불러오지 못했습니다.';
            }
        } catch (error: any) {
            if (showError) this.error = error?.message || '자료 처리 결과를 불러오지 못했습니다.';
        }
        await this.service.render();
    }

    public async buildArtifactChain() {
        const documentId = this.selected?.document_id || '';
        if (!documentId || this.artifactBuilding) return;
        this.artifactBuilding = true;
        this.error = '';
        this.uploadMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("build_artifact_chain", { document_id: documentId });
            if (code === 200) {
                this.selected = { ...this.selected, artifact_chain: data?.chain || null };
                const status = data?.chain?.run?.status || '';
                this.uploadMessage = status === 'passed' ? '자료 처리 결과를 생성했습니다.' : '자료 처리 결과에 확인 필요 항목이 있습니다.';
            } else {
                this.error = data?.message || '자료 처리 결과를 생성하지 못했습니다.';
            }
        } catch (error: any) {
            this.error = error?.message || '자료 처리 결과를 생성하지 못했습니다.';
        } finally {
            this.artifactBuilding = false;
            await this.service.render();
        }
    }

    public artifactTypeLabel(type: string) {
        switch (type) {
            case 'original_file':
                return '원본 자료';
            case 'ocr_page':
                return '텍스트 자료';
            case 'chunk':
                return '근거 자료';
            case 'vector_index':
                return '근거 자료';
            default:
                return type || '-';
        }
    }

    public shortId(value: string) {
        return value ? String(value).slice(0, 8) : '-';
    }

    public async createFolder() {
        if (!this.current?.id || !this.newFolderName.trim()) return;
        if (this.collectionDeletionRequested(this.current)) {
            await this.service.modal.error('폐기 요청된 컬렉션에는 폴더를 만들 수 없습니다.');
            return;
        }
        this.driveLoading = true;
        this.error = '';
        this.uploadMessage = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call("create_folder", {
                collection_id: this.current.id,
                folder_id: this.currentFolderId || '',
                path: this.currentPath || '',
                name: this.newFolderName.trim(),
            });
            if (code === 200) {
                this.newFolderName = '';
                this.driveActionMenuOpen = false;
                this.showNewFolderForm = false;
                this.assignDrive(data || {});
            } else {
                this.error = data?.message || '폴더를 생성하지 못했습니다.';
            }
        } catch (error: any) {
            this.error = error?.message || '폴더를 생성하지 못했습니다.';
        } finally {
            this.driveLoading = false;
            await this.service.render();
        }
    }

    public async toggleDriveActionMenu() {
        if (!this.current?.id || this.uploading || this.driveLoading) return;
        if (this.collectionDeletionRequested(this.current)) {
            await this.service.modal.error('폐기 요청된 컬렉션은 자료를 추가할 수 없습니다.');
            return;
        }
        this.driveActionMenuOpen = !this.driveActionMenuOpen;
        if (!this.driveActionMenuOpen) {
            this.showNewFolderForm = false;
        }
        await this.service.render();
    }

    public async closeDriveActionMenu() {
        this.driveActionMenuOpen = false;
        this.showNewFolderForm = false;
        await this.service.render();
    }

    public async showNewFolderAction() {
        if (this.collectionDeletionRequested(this.current)) {
            await this.service.modal.error('폐기 요청된 컬렉션에는 폴더를 만들 수 없습니다.');
            return;
        }
        this.driveActionMenuOpen = false;
        this.newFolderName = '';
        this.showNewFolderForm = true;
        await this.service.render();
    }

    public async closeNewFolderForm() {
        if (this.driveLoading) return;
        this.showNewFolderForm = false;
        this.newFolderName = '';
        await this.service.render();
    }

    public async selectDriveUploadAction(mode: string) {
        this.driveActionMenuOpen = false;
        this.showNewFolderForm = false;
        await this.service.render();
        await this.uploadFiles(mode);
    }

    public async uploadFiles(mode: string = 'file') {
        if (!this.current?.id || this.uploading || this.driveLoading) return;
        if (this.collectionDeletionRequested(this.current)) {
            await this.service.modal.error('폐기 요청된 컬렉션에는 파일을 업로드할 수 없습니다.');
            return;
        }
        let selected: any = [];
        try {
            selected = mode === 'folder'
                ? await this.service.file.select({ type: 'folder' })
                : await this.service.file.select();
        } catch (error) {
            return;
        }
        await this.uploadSelected(selected);
    }

    public uploadDropAllowed() {
        return !!this.current?.id && !this.uploading && !this.driveLoading && !this.collectionDeletionRequested(this.current);
    }

    public dropHasFiles(event: any) {
        const types = Array.from(event?.dataTransfer?.types || []).map((type: any) => String(type || '').toLowerCase());
        return types.includes('files');
    }

    public async uploadDragEnter(event: any) {
        if (!this.dropHasFiles(event)) return;
        event.preventDefault();
        event.stopPropagation();
        if (!this.uploadDropAllowed()) {
            if (event?.dataTransfer) event.dataTransfer.dropEffect = 'none';
            return;
        }
        this.driveDragDepth += 1;
        if (!this.driveDragActive) {
            this.driveDragActive = true;
            await this.service.render();
        }
    }

    public uploadDragOver(event: any) {
        if (!this.dropHasFiles(event)) return;
        event.preventDefault();
        event.stopPropagation();
        if (event?.dataTransfer) event.dataTransfer.dropEffect = this.uploadDropAllowed() ? 'copy' : 'none';
    }

    public async uploadDragLeave(event: any) {
        if (!this.dropHasFiles(event) && !this.driveDragActive) return;
        event.preventDefault();
        event.stopPropagation();
        this.driveDragDepth = Math.max(0, this.driveDragDepth - 1);
        if (this.driveDragDepth === 0 && this.driveDragActive) {
            this.driveDragActive = false;
            await this.service.render();
        }
    }

    public async uploadDrop(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.driveDragDepth = 0;
        this.driveDragActive = false;
        await this.service.render();
        if (!this.current?.id || this.uploading || this.driveLoading) return;
        if (this.collectionDeletionRequested(this.current)) {
            await this.service.modal.error('폐기 요청된 컬렉션에는 파일을 업로드할 수 없습니다.');
            return;
        }
        const files = await this.droppedUploadFiles(event);
        await this.uploadSelected(files);
    }

    public preventDrop(event: any) {
        event.preventDefault();
        event.stopPropagation();
    }

    public async droppedUploadFiles(event: any) {
        const items: any[] = Array.from(event?.dataTransfer?.items || []);
        const entries = items
            .map((item: any) => typeof item.webkitGetAsEntry === 'function' ? item.webkitGetAsEntry() : null)
            .filter((entry: any) => !!entry);
        if (entries.length) {
            const files: any[] = [];
            for (const entry of entries) {
                const children = await this.readDroppedEntry(entry, '');
                files.push(...children);
            }
            return files;
        }
        try {
            const dropped = await this.service.file.drop(event);
            return Array.from(dropped || []);
        } catch (error) {
            return Array.from(event?.dataTransfer?.files || []);
        }
    }

    public async readDroppedEntry(entry: any, basePath: string): Promise<any[]> {
        if (!entry) return [];
        const name = String(entry.name || '').replace(/\\/g, '/').replace(/^\/+/, '');
        if (!name) return [];
        if (entry.isFile) {
            return new Promise((resolve) => {
                entry.file((file: any) => {
                    this.assignDroppedFilePath(file, `${basePath}${name}`);
                    resolve([file]);
                }, () => resolve([]));
            });
        }
        if (entry.isDirectory) {
            const reader = entry.createReader();
            const entries: any[] = [];
            while (true) {
                const batch = await this.readDroppedDirectoryBatch(reader);
                if (!batch.length) break;
                entries.push(...batch);
            }
            const files: any[] = [];
            const directoryPath = `${basePath}${name}/`;
            for (const child of entries) {
                const children = await this.readDroppedEntry(child, directoryPath);
                files.push(...children);
            }
            return files;
        }
        return [];
    }

    public readDroppedDirectoryBatch(reader: any): Promise<any[]> {
        return new Promise((resolve) => {
            reader.readEntries((entries: any[]) => resolve(Array.from(entries || [])), () => resolve([]));
        });
    }

    public assignDroppedFilePath(file: any, filepath: string) {
        const normalized = String(filepath || file?.name || '').replace(/\\/g, '/').replace(/^\/+/, '');
        try {
            file.filepath = normalized;
        } catch (error) {
            try {
                Object.defineProperty(file, 'filepath', { value: normalized, configurable: true });
            } catch (innerError) { }
        }
    }

    public async uploadSelected(files: any) {
        const list: any[] = Array.from(files || []);
        if (!list.length || !this.current?.id) return;
        if (this.collectionDeletionRequested(this.current)) {
            await this.service.modal.error('폐기 요청된 컬렉션에는 파일을 업로드할 수 없습니다.');
            return;
        }

        const fd = new FormData();
        const filepath: string[] = [];
        for (let i = 0; i < list.length; i++) {
            const file: any = list[i];
            const relpath = file.filepath || file.webkitRelativePath || file.name;
            filepath.push(relpath || file.name);
            fd.append('file[]', file);
        }
        fd.append('filepath', JSON.stringify(filepath));
        fd.append('collection_id', this.current.id);
        fd.append('folder_id', this.currentFolderId || '');
        fd.append('path', this.currentPath || '');

        this.uploading = true;
        this.uploadPhase = 'transferring';
        this.uploadPlan = this.buildUploadPlan(list);
        this.uploadStatus = { uploading: true, percent: 0 };
        this.error = '';
        this.uploadMessage = '';
        this.lastUploadSummary = null;
        await this.service.render();

        try {
            const result: any = await this.service.file.upload(wiz.url('upload'), fd, this.uploadProgress.bind(this));
            const code = result?.code;
            const data = result?.data || {};
            if (code === 200) {
                this.assignDrive(data);
                this.lastUploadSummary = this.uploadSummaryFromResponse(data);
                this.uploadPhase = Number(this.lastUploadSummary?.pipeline_failed_count || 0) > 0 ? 'failed' : 'complete';
                this.uploadMessage = this.uploadCompletionMessage(this.lastUploadSummary);
            } else {
                this.uploadPhase = 'failed';
                this.error = data?.message || '파일 업로드에 실패했습니다.';
            }
        } catch (error: any) {
            this.uploadPhase = 'failed';
            this.error = error?.message || '파일 업로드에 실패했습니다.';
        } finally {
            this.uploading = false;
            this.uploadStatus = { uploading: false, percent: 0 };
            await this.service.render();
        }
    }

    public async uploadProgress(percent: number) {
        const value = Math.max(0, Math.min(100, Number(percent || 0)));
        if (value >= 100 && this.uploading) {
            this.uploadPhase = 'processing';
        } else if (value > 0 && this.uploading) {
            this.uploadPhase = 'transferring';
        }
        this.uploadStatus = {
            uploading: value > 0 && value < 100,
            percent: value,
        };
        await this.service.render();
    }

    public number(value: any) {
        return Number(value || 0).toLocaleString();
    }

    public fileSize(value: any) {
        const bytes = Number(value || 0);
        if (bytes >= 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024 / 1024).toFixed(1)} GB`;
        if (bytes >= 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
        if (bytes >= 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${bytes} B`;
    }

    public pathLabel() {
        return this.currentPath ? `/${this.currentPath}` : '/';
    }

    public extensionLabel(file: any) {
        return (file?.extension || 'file').toUpperCase();
    }

    public roleLabel(file: any) {
        const role = this.classifyFile(file).role;
        switch (role) {
            case 'source':
                return '원본 자료';
            case 'metadata':
                return '자료 정보';
            case 'ocr':
                return '텍스트 자료';
            case 'embedding':
                return '근거 자료';
            case 'vector':
                return '근거 자료';
            case 'status':
                return '점검 상태';
            case 'ocr_status':
            case 'embedding_status':
                return '처리 상태 자료';
            case 'vector_status':
                return '근거 자료 상태';
            default:
                return file?.file_role || '보조 파일';
        }
    }

    public statusLabel(status: string) {
        switch (status) {
            case 'usable':
                return '사용 가능';
            case 'partial':
            case 'partial_ready':
            case 'partially_ready':
                return '부분 준비';
            case 'processing':
                return '처리 중';
            case 'preserved':
                return '원본 보존';
            case 'linked':
                return '연결됨';
            case 'active':
                return '운영 중';
            case 'registered':
                return '처리 완료';
            case 'unregistered':
                return '자료 정보 생성 전';
            case 'ready':
                return '검수 준비';
            case 'draft':
                return '초안';
            case 'candidate':
                return '후보';
            case 'review_requested':
                return '검수 요청';
            case 'assigned':
                return '배정됨';
            case 'in_review':
                return '검수 중';
            case 'approved':
                return '승인';
            case 'rejected':
                return '반려';
            case 'change_requested':
                return '수정 요청';
            case 'not_requested':
                return '요청 전';
            case 'gate_ready':
                return '검수 가능';
            case 'train':
                return '작성용';
            case 'eval':
                return '평가용';
            case 'golden':
                return '골든셋';
            case 'queued':
                return '대기';
            case 'running':
                return '실행 중';
            case 'passed':
                return '통과';
            case 'published':
                return '게시';
            case 'blocked':
                return '보류';
            case 'working':
                return '처리 중';
            case 'attention':
                return '확인 필요';
            case 'unavailable':
                return '생성 불가';
            case 'empty':
                return '정보 없음';
            case 'completed':
            case 'indexed':
            case 'imported':
            case 'done':
                return '완료';
            case 'pending':
            case 'discovered':
            case 'new':
            case 'unchecked':
            case 'unknown':
                return '대기';
            case 'source':
            case 'exists':
                return '존재';
            case 'failed':
            case 'error':
                return '오류';
            case 'missing':
                return '누락';
            default:
                return status || 'unknown';
        }
    }

    public statusClass(status: string) {
        switch (status) {
            case 'ready':
            case 'usable':
            case 'completed':
            case 'indexed':
            case 'imported':
            case 'done':
            case 'passed':
            case 'published':
            case 'draft':
            case 'candidate':
            case 'registered':
            case 'preserved':
            case 'linked':
            case 'active':
            case 'approved':
            case 'gate_ready':
            case 'source':
            case 'metadata':
            case 'exists':
                return 'border-emerald-200 bg-emerald-50 text-emerald-700';
            case 'partial':
            case 'partial_ready':
            case 'partially_ready':
                return 'border-sky-200 bg-sky-50 text-sky-700';
            case 'working':
            case 'processing':
            case 'queued':
            case 'running':
            case 'pending':
            case 'review_requested':
            case 'assigned':
            case 'in_review':
            case 'not_requested':
            case 'discovered':
            case 'new':
            case 'unchecked':
            case 'unregistered':
            case 'unknown':
                return 'border-amber-200 bg-amber-50 text-amber-700';
            case 'attention':
            case 'failed':
            case 'error':
            case 'missing':
            case 'blocked':
            case 'rejected':
            case 'change_requested':
                return 'border-rose-200 bg-rose-50 text-rose-700';
            case 'unavailable':
                return 'border-gray-200 bg-gray-50 text-gray-600';
            default:
                return 'border-gray-200 bg-gray-50 text-gray-600';
        }
    }

    public metricTone(tone: string) {
        switch (tone) {
            case 'emerald':
                return 'border-emerald-200 bg-emerald-50 text-emerald-800';
            case 'sky':
                return 'border-sky-200 bg-sky-50 text-sky-800';
            case 'amber':
                return 'border-amber-200 bg-amber-50 text-amber-800';
            case 'rose':
                return 'border-rose-200 bg-rose-50 text-rose-800';
            default:
                return 'border-gray-200 bg-white text-gray-800';
        }
    }

    public pipelineTone(tone: string) {
        switch (tone) {
            case 'emerald':
                return 'border-emerald-200 bg-emerald-50 text-emerald-900';
            case 'amber':
                return 'border-amber-200 bg-amber-50 text-amber-900';
            case 'rose':
                return 'border-rose-200 bg-rose-50 text-rose-900';
            case 'sky':
                return 'border-sky-200 bg-sky-50 text-sky-900';
            default:
                return 'border-gray-200 bg-gray-50 text-gray-800';
        }
    }

    public slotTone(slot: any) {
        if (!slot?.files?.length) return 'border-gray-200 bg-gray-50 text-gray-400';
        switch (slot.key) {
            case 'source':
            case 'metadata':
                return 'border-sky-200 bg-sky-50 text-sky-800';
            case 'ocr':
                return 'border-amber-200 bg-amber-50 text-amber-800';
            case 'embedding':
                return 'border-violet-200 bg-violet-50 text-violet-800';
            case 'vector':
                return 'border-emerald-200 bg-emerald-50 text-emerald-800';
            case 'ocr_status':
            case 'embedding_status':
            case 'vector_status':
            case 'status':
                return 'border-emerald-200 bg-emerald-50 text-emerald-800';
            default:
                return 'border-gray-200 bg-white text-gray-800';
        }
    }

    public fileTone(file: any) {
        const ext = (file?.extension || '').toLowerCase();
        if (['pdf'].includes(ext)) return 'border-rose-100 bg-rose-50 text-rose-700';
        if (['xlsx', 'xls', 'csv'].includes(ext)) return 'border-emerald-100 bg-emerald-50 text-emerald-700';
        if (['doc', 'docx', 'hwp', 'hwpx'].includes(ext)) return 'border-sky-100 bg-sky-50 text-sky-700';
        if (['json', 'xml'].includes(ext)) return 'border-violet-100 bg-violet-50 text-violet-700';
        return 'border-gray-100 bg-gray-50 text-gray-600';
    }
}

export default PageLiteratureComponent;